// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.8_webpack@5.102.1_@swc+core@1.13.5_esbuild@0.28.0_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.8_webpack@5.102.1_@swc+core@1.13.5_esbuild@0.28.0_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.18 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: Inter, ui-sans-serif, system-ui, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: "JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
  :root {
    /* Light theme base colors — subtle warm gray */
    --background: 220 10% 98%;
    /* Slightly darker body text improves contrast vs soft backgrounds (WCAG AA). */
    --foreground: 222 24% 9%;

    /* Card and surface colors */
    --card: 0 0% 100%;
    --card-foreground: 222 24% 9%;
    --card-elevated: 220 14% 98%;

    /* Popover colors */
    --popover: 0 0% 100%;
    --popover-foreground: 222 24% 9%;

    /* Salesforce Brand — ~43% L keeps blue on white ≥4.5:1 for normal links/labels */
    --primary: 214 100% 43%;
    --primary-foreground: 0 0% 100%;
    --primary-glow: 214 100% 52%;

    /* Secondary colors */
    --secondary: 220 14% 92%;
    --secondary-foreground: 222 24% 9%;

    /* Muted — darker muted-foreground so helper text passes AA on white AND on --muted */
    --muted: 220 14% 92%;
    --muted-foreground: 215 22% 30%;

    /* Accent fills use white text — keep L ≤ ~48% for ≥4.5:1 vs white */
    --accent: 214 100% 47%;
    --accent-foreground: 0 0% 100%;
    --accent-glow: 214 100% 56%;
    --accent-warm: 16 76% 44%;
    --accent-warm-foreground: 0 0% 100%;
    --accent-warm-soft: 22 75% 90%;
    --charcoal: 220 10% 14%;
    --charcoal-foreground: 0 0% 100%;

    /* Status colors */
    --destructive: 0 84% 55%;
    --destructive-foreground: 0 0% 100%;
    --success: 142 76% 36%;
    --success-foreground: 0 0% 100%;
    --warning: 32 95% 44%;
    --warning-foreground: 0 0% 100%;
    /* Text-safe state colours. The base --success/--warning are tuned as FILLS; used as text on
       their own 10% tint they measure 2.1:1 and 2.8:1 against a light card — well under WCAG AA.
       These darker/lighter counterparts clear 4.5:1 in both themes and are what text should use. */
    --success-strong: 142 76% 26%;
    --warning-strong: 32 95% 27%;
    --destructive-strong: 0 74% 38%;

    /* Border / input — a bit stronger vs white for focus outlines & dividers */
    --border: 214 18% 76%;
    --input: 214 18% 80%;
    --ring: 214 100% 43%;

    /* Typography — subtitles/captions must pass AA on --muted (92% L) */
    --heading-primary: 222 24% 7%;
    --heading-secondary: 214 100% 43%;
    --heading-accent: 214 100% 47%;
    --body-text: 222 24% 7%;
    --subtitle-text: 215 18% 34%;
    --caption-text: 215 18% 34%;

    /* File Explorer Tree colors */
    --file-explorer-hover: 210 40% 93%;
    --file-explorer-hover-foreground: 222 47% 11%;
    --file-explorer-selected: 214 100% 96%;
    --file-explorer-selected-foreground: 222 47% 11%;
    --file-explorer-selected-border: 214 100% 60%;

    /* Sidebar colors */
    --sidebar-background: 220 14% 93%;
    --sidebar-foreground: 222 24% 9%;
    --sidebar-primary: 214 100% 43%;
    --sidebar-primary-foreground: 0 0% 100%;
    --sidebar-accent: 220 14% 90%;
    --sidebar-accent-foreground: 222 24% 9%;
    --sidebar-border: 214 18% 76%;
    --sidebar-ring: 214 100% 43%;

    /* Gradients — aligned with light-mode primary for readable gradient text */
    --gradient-primary: linear-gradient(135deg, hsl(214 100% 48%), hsl(195 100% 58%));
    --gradient-card: linear-gradient(145deg, hsl(0 0% 100%), hsl(0 0% 98%));
    --gradient-accent: linear-gradient(120deg, hsl(214 100% 56%), hsl(214 100% 64%));

    /* Shadows */
    --shadow-card: 0 1px 3px 0 hsl(0 0% 0% / 0.1), 0 1px 2px -1px hsl(0 0% 0% / 0.1);
    --shadow-glow: 0 0 20px hsl(214 100% 60% / 0.3);
    --shadow-elevated: 0 4px 6px -1px hsl(0 0% 0% / 0.1), 0 2px 4px -2px hsl(0 0% 0% / 0.1);

    /* Animation variables */
    --transition-smooth: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    --radius: 0.75rem;

    /* Studio paper theme tokens. Namespaced --rs-* so route-level theme wrappers
       can remap stock bg-card/text-foreground/border classes without touching
       every component. */
    --rs-paper: 220 23% 98%;
    --rs-paper-edge: 216 28% 94%;
    --rs-card: 0 0% 100%;
    --rs-card-edge: 216 24% 88%;
    --rs-ink: 222 20% 8%;
    --rs-ink-soft: 222 13% 28%;
    --rs-ink-mute: 217 13% 43%;
    --rs-warm: 217 91% 48%;
    --rs-warm-soft: 214 95% 93%;
    --rs-plum: 176 84% 32%;
    --rs-plum-soft: 174 48% 90%;
    --rs-leaf: 158 64% 32%;
    --rs-leaf-soft: 152 35% 90%;
    --rs-amber: 32 95% 44%;
    --rs-amber-soft: 40 80% 92%;
  }

  .dark {
    /* Dark theme base colors */
    --background: 222 20% 12%;
    --foreground: 210 40% 95%;

    /* Card and surface colors */
    --card: 222 18% 15%;
    --card-foreground: 210 40% 95%;
    --card-elevated: 222 16% 18%;

    /* Popover colors */
    --popover: 222 20% 10%;
    --popover-foreground: 210 40% 95%;

    /* Salesforce Brand Colors */
    --primary: 214 100% 60%;
    --primary-foreground: 0 0% 100%;
    --primary-glow: 214 100% 70%;

    /* Secondary colors */
    --secondary: 222 16% 15%;
    --secondary-foreground: 210 40% 90%;

    /* Muted colors */
    --muted: 222 14% 12%;
    --muted-foreground: 215 16% 65%;

    /* Accent colors */
    --accent: 214 100% 65%;
    --accent-foreground: 0 0% 100%;
    --accent-glow: 214 100% 75%;
    --accent-warm: 16 80% 58%;
    --accent-warm-foreground: 0 0% 100%;
    --accent-warm-soft: 22 35% 22%;
    --charcoal: 220 10% 8%;
    --charcoal-foreground: 0 0% 100%;

    /* Status colors */
    --destructive: 0 75% 60%;
    --destructive-foreground: 0 0% 100%;
    --success: 142 76% 36%;
    --success-foreground: 0 0% 100%;
    --warning: 32 95% 44%;
    --warning-foreground: 222 24% 7%;
    --success-strong: 142 60% 58%;
    --warning-strong: 32 95% 62%;
    --destructive-strong: 0 85% 70%;

    /* Border and input colors */
    --border: 222 14% 18%;
    --input: 222 14% 15%;
    --ring: 214 100% 60%;

    /* Typography colors */
    --heading-primary: 210 40% 98%;
    --heading-secondary: 214 100% 70%;
    --heading-accent: 214 100% 75%;
    --body-text: 210 40% 95%;
    --subtitle-text: 215 16% 75%;
    --caption-text: 215 16% 65%;

    /* File Explorer Tree dark colors */
    --file-explorer-hover: 222 16% 18%;
    --file-explorer-hover-foreground: 210 40% 95%;
    --file-explorer-selected: 214 80% 14%;
    --file-explorer-selected-foreground: 210 40% 98%;
    --file-explorer-selected-border: 214 100% 60%;

    /* Sidebar colors */
    --sidebar-background: 222 28% 6%;
    --sidebar-foreground: 210 40% 85%;
    --sidebar-primary: 214 100% 60%;
    --sidebar-primary-foreground: 0 0% 100%;
    --sidebar-accent: 222 16% 12%;
    --sidebar-accent-foreground: 210 40% 90%;
    --sidebar-border: 222 14% 15%;
    --sidebar-ring: 214 100% 60%;

    /* Gradients */
    --gradient-primary: linear-gradient(135deg, hsl(214 100% 60%), hsl(195 100% 65%));
    --gradient-card: linear-gradient(145deg, hsl(222 20% 10%), hsl(222 18% 12%));
    --gradient-accent: linear-gradient(120deg, hsl(214 100% 65%), hsl(214 100% 75%));

    /* Shadows */
    --shadow-card: 0 4px 12px -2px hsl(222 24% 4% / 0.3);
    --shadow-glow: 0 0 20px hsl(214 100% 60% / 0.4);
    --shadow-elevated: 0 8px 24px -4px hsl(222 24% 4% / 0.4);

    --rs-paper: 217 31% 7%;
    --rs-paper-edge: 215 25% 17%;
    --rs-card: 215 29% 12%;
    --rs-card-edge: 215 21% 24%;
    --rs-ink: 214 32% 93%;
    --rs-ink-soft: 214 18% 78%;
    --rs-ink-mute: 215 16% 68%;
    --rs-warm: 213 94% 68%;
    --rs-warm-soft: 213 58% 18%;
    --rs-plum: 185 96% 43%;
    --rs-plum-soft: 185 58% 17%;
    --rs-leaf: 158 64% 52%;
    --rs-leaf-soft: 152 30% 14%;
    --rs-amber: 41 84% 65%;             /* #f0c25a */
    --rs-amber-soft: 41 35% 16%;
  }
  * {
  border-color: hsl(var(--border));
}

  html,
  body,
  #root {
  margin: 0px;
  height: 100%;
  width: 100%;
}

  body {
  background-color: hsl(var(--background));
  color: hsl(var(--foreground));
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
    font-family: Inter, ui-sans-serif, system-ui, sans-serif;
}

  /* Custom gradient backgrounds */

  /* Custom shadows */

  .shadow-glow {
    box-shadow: var(--shadow-glow);
  }

  /* Smooth transitions */

  /* Custom scrollbar — vertical only, inset thumb (production-style) */
  .custom-scrollbar {
    overflow-x: hidden;
    scrollbar-gutter: stable;
    scrollbar-width: thin;
    scrollbar-color: hsl(var(--muted-foreground) / 0.32) transparent;
  }

  .custom-scrollbar::-webkit-scrollbar {
    width: 10px;
  }

  .custom-scrollbar::-webkit-scrollbar-track {
    margin: 6px 0;
    background: transparent;
    border-radius: 999px;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb {
    background: hsl(var(--muted-foreground) / 0.28);
    border: 2px solid transparent;
    background-clip: padding-box;
    border-radius: 999px;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: hsl(var(--muted-foreground) / 0.45);
    border: 2px solid transparent;
    background-clip: padding-box;
  }

  /* Diff / code block horizontal scrollbar — slim IDE-style thumb */
  .nc-diff-scroll {
    scrollbar-width: thin;
    scrollbar-color: hsl(var(--muted-foreground) / 0.28) transparent;
  }
  .nc-diff-scroll::-webkit-scrollbar {
    height: 5px;
  }
  .nc-diff-scroll::-webkit-scrollbar-track {
    background: transparent;
  }
  .nc-diff-scroll::-webkit-scrollbar-thumb {
    background: hsl(var(--muted-foreground) / 0.28);
    border-radius: 9999px;
  }
  .nc-diff-scroll::-webkit-scrollbar-thumb:hover {
    background: hsl(var(--muted-foreground) / 0.5);
  }
  * {
  border-color: hsl(var(--border));
}
  body {
  background-color: hsl(var(--background));
  color: hsl(var(--foreground));
}
.\\!container {
  width: 100% !important;
  margin-right: auto !important;
  margin-left: auto !important;
  padding-right: 2rem !important;
  padding-left: 2rem !important;
}
.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 2rem;
  padding-left: 2rem;
}
@media (min-width: 1400px) {

  .\\!container {
    max-width: 1400px !important;
  }

  .container {
    max-width: 1400px;
  }
}
.prose {
  color: var(--tw-prose-body);
  max-width: 65ch;
}
.prose :where(p):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}
.prose :where([class~="lead"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-lead);
  font-size: 1.25em;
  line-height: 1.6;
  margin-top: 1.2em;
  margin-bottom: 1.2em;
}
.prose :where(a):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-links);
  text-decoration: underline;
  font-weight: 500;
}
.prose :where(strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-bold);
  font-weight: 600;
}
.prose :where(a strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(blockquote strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(thead th strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(ol):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: decimal;
  margin-top: 1.25em;
  margin-bottom: 1.25em;
  padding-inline-start: 1.625em;
}
.prose :where(ol[type="A"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: upper-alpha;
}
.prose :where(ol[type="a"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: lower-alpha;
}
.prose :where(ol[type="A" s]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: upper-alpha;
}
.prose :where(ol[type="a" s]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: lower-alpha;
}
.prose :where(ol[type="I"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: upper-roman;
}
.prose :where(ol[type="i"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: lower-roman;
}
.prose :where(ol[type="I" s]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: upper-roman;
}
.prose :where(ol[type="i" s]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: lower-roman;
}
.prose :where(ol[type="1"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: decimal;
}
.prose :where(ul):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: disc;
  margin-top: 1.25em;
  margin-bottom: 1.25em;
  padding-inline-start: 1.625em;
}
.prose :where(ol > li):not(:where([class~="not-prose"],[class~="not-prose"] *))::marker {
  font-weight: 400;
  color: var(--tw-prose-counters);
}
.prose :where(ul > li):not(:where([class~="not-prose"],[class~="not-prose"] *))::marker {
  color: var(--tw-prose-bullets);
}
.prose :where(dt):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 600;
  margin-top: 1.25em;
}
.prose :where(hr):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  border-color: var(--tw-prose-hr);
  border-top-width: 1px;
  margin-top: 3em;
  margin-bottom: 3em;
}
.prose :where(blockquote):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-weight: 500;
  font-style: italic;
  color: var(--tw-prose-quotes);
  border-inline-start-width: 0.25rem;
  border-inline-start-color: var(--tw-prose-quote-borders);
  quotes: "\\201C""\\201D""\\2018""\\2019";
  margin-top: 1.6em;
  margin-bottom: 1.6em;
  padding-inline-start: 1em;
}
.prose :where(blockquote p:first-of-type):not(:where([class~="not-prose"],[class~="not-prose"] *))::before {
  content: open-quote;
}
.prose :where(blockquote p:last-of-type):not(:where([class~="not-prose"],[class~="not-prose"] *))::after {
  content: close-quote;
}
.prose :where(h1):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 800;
  font-size: 2.25em;
  margin-top: 0;
  margin-bottom: 0.8888889em;
  line-height: 1.1111111;
}
.prose :where(h1 strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-weight: 900;
  color: inherit;
}
.prose :where(h2):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 700;
  font-size: 1.5em;
  margin-top: 2em;
  margin-bottom: 1em;
  line-height: 1.3333333;
}
.prose :where(h2 strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-weight: 800;
  color: inherit;
}
.prose :where(h3):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 600;
  font-size: 1.25em;
  margin-top: 1.6em;
  margin-bottom: 0.6em;
  line-height: 1.6;
}
.prose :where(h3 strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-weight: 700;
  color: inherit;
}
.prose :where(h4):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 600;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  line-height: 1.5;
}
.prose :where(h4 strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-weight: 700;
  color: inherit;
}
.prose :where(img):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose :where(picture):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  display: block;
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose :where(video):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose :where(kbd):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-weight: 500;
  font-family: inherit;
  color: var(--tw-prose-kbd);
  box-shadow: 0 0 0 1px var(--tw-prose-kbd-shadows), 0 3px 0 var(--tw-prose-kbd-shadows);
  font-size: 0.875em;
  border-radius: 0.3125rem;
  padding-top: 0.1875em;
  padding-inline-end: 0.375em;
  padding-bottom: 0.1875em;
  padding-inline-start: 0.375em;
}
.prose :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-code);
  font-weight: 600;
  font-size: 0.875em;
}
.prose :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *))::before {
  content: "\`";
}
.prose :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *))::after {
  content: "\`";
}
.prose :where(a code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(h1 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(h2 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
  font-size: 0.875em;
}
.prose :where(h3 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
  font-size: 0.9em;
}
.prose :where(h4 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(blockquote code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(thead th code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(pre):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-pre-code);
  background-color: var(--tw-prose-pre-bg);
  overflow-x: auto;
  font-weight: 400;
  font-size: 0.875em;
  line-height: 1.7142857;
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
  border-radius: 0.375rem;
  padding-top: 0.8571429em;
  padding-inline-end: 1.1428571em;
  padding-bottom: 0.8571429em;
  padding-inline-start: 1.1428571em;
}
.prose :where(pre code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  background-color: transparent;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-weight: inherit;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
}
.prose :where(pre code):not(:where([class~="not-prose"],[class~="not-prose"] *))::before {
  content: none;
}
.prose :where(pre code):not(:where([class~="not-prose"],[class~="not-prose"] *))::after {
  content: none;
}
.prose :where(table):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  width: 100%;
  table-layout: auto;
  margin-top: 2em;
  margin-bottom: 2em;
  font-size: 0.875em;
  line-height: 1.7142857;
}
.prose :where(thead):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  border-bottom-width: 1px;
  border-bottom-color: var(--tw-prose-th-borders);
}
.prose :where(thead th):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 600;
  vertical-align: bottom;
  padding-inline-end: 0.5714286em;
  padding-bottom: 0.5714286em;
  padding-inline-start: 0.5714286em;
}
.prose :where(tbody tr):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  border-bottom-width: 1px;
  border-bottom-color: var(--tw-prose-td-borders);
}
.prose :where(tbody tr:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  border-bottom-width: 0;
}
.prose :where(tbody td):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  vertical-align: baseline;
}
.prose :where(tfoot):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  border-top-width: 1px;
  border-top-color: var(--tw-prose-th-borders);
}
.prose :where(tfoot td):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  vertical-align: top;
}
.prose :where(th, td):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  text-align: start;
}
.prose :where(figure > *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
  margin-bottom: 0;
}
.prose :where(figcaption):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-captions);
  font-size: 0.875em;
  line-height: 1.4285714;
  margin-top: 0.8571429em;
}
.prose {
  --tw-prose-body: #374151;
  --tw-prose-headings: #111827;
  --tw-prose-lead: #4b5563;
  --tw-prose-links: #111827;
  --tw-prose-bold: #111827;
  --tw-prose-counters: #6b7280;
  --tw-prose-bullets: #d1d5db;
  --tw-prose-hr: #e5e7eb;
  --tw-prose-quotes: #111827;
  --tw-prose-quote-borders: #e5e7eb;
  --tw-prose-captions: #6b7280;
  --tw-prose-kbd: #111827;
  --tw-prose-kbd-shadows: rgb(17 24 39 / 10%);
  --tw-prose-code: #111827;
  --tw-prose-pre-code: #e5e7eb;
  --tw-prose-pre-bg: #1f2937;
  --tw-prose-th-borders: #d1d5db;
  --tw-prose-td-borders: #e5e7eb;
  --tw-prose-invert-body: #d1d5db;
  --tw-prose-invert-headings: #fff;
  --tw-prose-invert-lead: #9ca3af;
  --tw-prose-invert-links: #fff;
  --tw-prose-invert-bold: #fff;
  --tw-prose-invert-counters: #9ca3af;
  --tw-prose-invert-bullets: #4b5563;
  --tw-prose-invert-hr: #374151;
  --tw-prose-invert-quotes: #f3f4f6;
  --tw-prose-invert-quote-borders: #374151;
  --tw-prose-invert-captions: #9ca3af;
  --tw-prose-invert-kbd: #fff;
  --tw-prose-invert-kbd-shadows: rgb(255 255 255 / 10%);
  --tw-prose-invert-code: #fff;
  --tw-prose-invert-pre-code: #d1d5db;
  --tw-prose-invert-pre-bg: rgb(0 0 0 / 50%);
  --tw-prose-invert-th-borders: #4b5563;
  --tw-prose-invert-td-borders: #374151;
  font-size: 1rem;
  line-height: 1.75;
}
.prose :where(picture > img):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
  margin-bottom: 0;
}
.prose :where(li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}
.prose :where(ol > li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0.375em;
}
.prose :where(ul > li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0.375em;
}
.prose :where(.prose > ul > li p):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}
.prose :where(.prose > ul > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.25em;
}
.prose :where(.prose > ul > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 1.25em;
}
.prose :where(.prose > ol > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.25em;
}
.prose :where(.prose > ol > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 1.25em;
}
.prose :where(ul ul, ul ol, ol ul, ol ol):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}
.prose :where(dl):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}
.prose :where(dd):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.5em;
  padding-inline-start: 1.625em;
}
.prose :where(hr + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose :where(h2 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose :where(h3 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose :where(h4 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose :where(thead th:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0;
}
.prose :where(thead th:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-end: 0;
}
.prose :where(tbody td, tfoot td):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-top: 0.5714286em;
  padding-inline-end: 0.5714286em;
  padding-bottom: 0.5714286em;
  padding-inline-start: 0.5714286em;
}
.prose :where(tbody td:first-child, tfoot td:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0;
}
.prose :where(tbody td:last-child, tfoot td:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-end: 0;
}
.prose :where(figure):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose :where(.prose > :first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose :where(.prose > :last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 0;
}
.prose-sm {
  font-size: 0.875rem;
  line-height: 1.7142857;
}
.prose-sm :where(p):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.1428571em;
  margin-bottom: 1.1428571em;
}
.prose-sm :where([class~="lead"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 1.2857143em;
  line-height: 1.5555556;
  margin-top: 0.8888889em;
  margin-bottom: 0.8888889em;
}
.prose-sm :where(blockquote):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
  padding-inline-start: 1.1111111em;
}
.prose-sm :where(h1):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 2.1428571em;
  margin-top: 0;
  margin-bottom: 0.8em;
  line-height: 1.2;
}
.prose-sm :where(h2):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 1.4285714em;
  margin-top: 1.6em;
  margin-bottom: 0.8em;
  line-height: 1.4;
}
.prose-sm :where(h3):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 1.2857143em;
  margin-top: 1.5555556em;
  margin-bottom: 0.4444444em;
  line-height: 1.5555556;
}
.prose-sm :where(h4):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.4285714em;
  margin-bottom: 0.5714286em;
  line-height: 1.4285714;
}
.prose-sm :where(img):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
}
.prose-sm :where(picture):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
}
.prose-sm :where(picture > img):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
  margin-bottom: 0;
}
.prose-sm :where(video):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
}
.prose-sm :where(kbd):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8571429em;
  border-radius: 0.3125rem;
  padding-top: 0.1428571em;
  padding-inline-end: 0.3571429em;
  padding-bottom: 0.1428571em;
  padding-inline-start: 0.3571429em;
}
.prose-sm :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8571429em;
}
.prose-sm :where(h2 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.9em;
}
.prose-sm :where(h3 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8888889em;
}
.prose-sm :where(pre):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8571429em;
  line-height: 1.6666667;
  margin-top: 1.6666667em;
  margin-bottom: 1.6666667em;
  border-radius: 0.25rem;
  padding-top: 0.6666667em;
  padding-inline-end: 1em;
  padding-bottom: 0.6666667em;
  padding-inline-start: 1em;
}
.prose-sm :where(ol):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.1428571em;
  margin-bottom: 1.1428571em;
  padding-inline-start: 1.5714286em;
}
.prose-sm :where(ul):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.1428571em;
  margin-bottom: 1.1428571em;
  padding-inline-start: 1.5714286em;
}
.prose-sm :where(li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.2857143em;
  margin-bottom: 0.2857143em;
}
.prose-sm :where(ol > li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0.4285714em;
}
.prose-sm :where(ul > li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0.4285714em;
}
.prose-sm :where(.prose-sm > ul > li p):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.5714286em;
  margin-bottom: 0.5714286em;
}
.prose-sm :where(.prose-sm > ul > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.1428571em;
}
.prose-sm :where(.prose-sm > ul > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 1.1428571em;
}
.prose-sm :where(.prose-sm > ol > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.1428571em;
}
.prose-sm :where(.prose-sm > ol > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 1.1428571em;
}
.prose-sm :where(ul ul, ul ol, ol ul, ol ol):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.5714286em;
  margin-bottom: 0.5714286em;
}
.prose-sm :where(dl):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.1428571em;
  margin-bottom: 1.1428571em;
}
.prose-sm :where(dt):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.1428571em;
}
.prose-sm :where(dd):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.2857143em;
  padding-inline-start: 1.5714286em;
}
.prose-sm :where(hr):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 2.8571429em;
  margin-bottom: 2.8571429em;
}
.prose-sm :where(hr + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-sm :where(h2 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-sm :where(h3 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-sm :where(h4 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-sm :where(table):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8571429em;
  line-height: 1.5;
}
.prose-sm :where(thead th):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-end: 1em;
  padding-bottom: 0.6666667em;
  padding-inline-start: 1em;
}
.prose-sm :where(thead th:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0;
}
.prose-sm :where(thead th:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-end: 0;
}
.prose-sm :where(tbody td, tfoot td):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-top: 0.6666667em;
  padding-inline-end: 1em;
  padding-bottom: 0.6666667em;
  padding-inline-start: 1em;
}
.prose-sm :where(tbody td:first-child, tfoot td:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0;
}
.prose-sm :where(tbody td:last-child, tfoot td:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-end: 0;
}
.prose-sm :where(figure):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
}
.prose-sm :where(figure > *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
  margin-bottom: 0;
}
.prose-sm :where(figcaption):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8571429em;
  line-height: 1.3333333;
  margin-top: 0.6666667em;
}
.prose-sm :where(.prose-sm > :first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-sm :where(.prose-sm > :last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 0;
}
.prose-lg {
  font-size: 1.125rem;
  line-height: 1.7777778;
}
.prose-lg :where(p):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
}
.prose-lg :where([class~="lead"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 1.2222222em;
  line-height: 1.4545455;
  margin-top: 1.0909091em;
  margin-bottom: 1.0909091em;
}
.prose-lg :where(blockquote):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.6666667em;
  margin-bottom: 1.6666667em;
  padding-inline-start: 1em;
}
.prose-lg :where(h1):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 2.6666667em;
  margin-top: 0;
  margin-bottom: 0.8333333em;
  line-height: 1;
}
.prose-lg :where(h2):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 1.6666667em;
  margin-top: 1.8666667em;
  margin-bottom: 1.0666667em;
  line-height: 1.3333333;
}
.prose-lg :where(h3):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 1.3333333em;
  margin-top: 1.6666667em;
  margin-bottom: 0.6666667em;
  line-height: 1.5;
}
.prose-lg :where(h4):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7777778em;
  margin-bottom: 0.4444444em;
  line-height: 1.5555556;
}
.prose-lg :where(img):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7777778em;
  margin-bottom: 1.7777778em;
}
.prose-lg :where(picture):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7777778em;
  margin-bottom: 1.7777778em;
}
.prose-lg :where(picture > img):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
  margin-bottom: 0;
}
.prose-lg :where(video):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7777778em;
  margin-bottom: 1.7777778em;
}
.prose-lg :where(kbd):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8888889em;
  border-radius: 0.3125rem;
  padding-top: 0.2222222em;
  padding-inline-end: 0.4444444em;
  padding-bottom: 0.2222222em;
  padding-inline-start: 0.4444444em;
}
.prose-lg :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8888889em;
}
.prose-lg :where(h2 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8666667em;
}
.prose-lg :where(h3 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.875em;
}
.prose-lg :where(pre):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8888889em;
  line-height: 1.75;
  margin-top: 2em;
  margin-bottom: 2em;
  border-radius: 0.375rem;
  padding-top: 1em;
  padding-inline-end: 1.5em;
  padding-bottom: 1em;
  padding-inline-start: 1.5em;
}
.prose-lg :where(ol):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
  padding-inline-start: 1.5555556em;
}
.prose-lg :where(ul):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
  padding-inline-start: 1.5555556em;
}
.prose-lg :where(li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.6666667em;
  margin-bottom: 0.6666667em;
}
.prose-lg :where(ol > li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0.4444444em;
}
.prose-lg :where(ul > li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0.4444444em;
}
.prose-lg :where(.prose-lg > ul > li p):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.8888889em;
  margin-bottom: 0.8888889em;
}
.prose-lg :where(.prose-lg > ul > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.3333333em;
}
.prose-lg :where(.prose-lg > ul > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 1.3333333em;
}
.prose-lg :where(.prose-lg > ol > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.3333333em;
}
.prose-lg :where(.prose-lg > ol > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 1.3333333em;
}
.prose-lg :where(ul ul, ul ol, ol ul, ol ol):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.8888889em;
  margin-bottom: 0.8888889em;
}
.prose-lg :where(dl):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
}
.prose-lg :where(dt):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.3333333em;
}
.prose-lg :where(dd):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.6666667em;
  padding-inline-start: 1.5555556em;
}
.prose-lg :where(hr):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 3.1111111em;
  margin-bottom: 3.1111111em;
}
.prose-lg :where(hr + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-lg :where(h2 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-lg :where(h3 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-lg :where(h4 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-lg :where(table):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8888889em;
  line-height: 1.5;
}
.prose-lg :where(thead th):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-end: 0.75em;
  padding-bottom: 0.75em;
  padding-inline-start: 0.75em;
}
.prose-lg :where(thead th:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0;
}
.prose-lg :where(thead th:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-end: 0;
}
.prose-lg :where(tbody td, tfoot td):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-top: 0.75em;
  padding-inline-end: 0.75em;
  padding-bottom: 0.75em;
  padding-inline-start: 0.75em;
}
.prose-lg :where(tbody td:first-child, tfoot td:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0;
}
.prose-lg :where(tbody td:last-child, tfoot td:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-end: 0;
}
.prose-lg :where(figure):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7777778em;
  margin-bottom: 1.7777778em;
}
.prose-lg :where(figure > *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
  margin-bottom: 0;
}
.prose-lg :where(figcaption):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8888889em;
  line-height: 1.5;
  margin-top: 1em;
}
.prose-lg :where(.prose-lg > :first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-lg :where(.prose-lg > :last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 0;
}
  .term-window {
  overflow: visible;
  border-radius: var(--radius);
  border-width: 1px;
  border-color: hsl(var(--border));
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
  .studio-shell :where(.bg-card.term-window, .border.bg-card):not(.studio-card):not(.term-window):not(.term-window-flat) {
  border-color: hsl(var(--border) / 0.72);
  background:
    linear-gradient(180deg, hsl(var(--card) / 0.82), hsl(var(--card-elevated) / 0.58));
  box-shadow:
    inset 0 1px 0 hsl(var(--foreground) / 0.035),
    0 1px 2px hsl(var(--foreground) / 0.035);
}
  .studio-shell :where(.term-window, .shadow-md):not(.studio-card) {
  box-shadow: 0 1px 2px hsl(var(--foreground) / 0.04);
}
  .term-window {
    position: relative;
    background:
      linear-gradient(180deg, hsl(var(--card) / 0.98), hsl(var(--card-elevated) / 0.88));
    box-shadow:
      inset 0 1px 0 hsl(var(--foreground) / 0.04),
      0 1px 2px hsl(var(--foreground) / 0.05);
  }

  .term-window-flat {
  overflow: visible;
  border-radius: var(--radius);
  border-width: 1px;
  border-color: hsl(var(--border));
}

  .studio-shell :where(.bg-card.term-window-flat, .border.bg-card):not(.studio-card):not(.term-window):not(.term-window-flat) {
  border-color: hsl(var(--border) / 0.72);
  background:
    linear-gradient(180deg, hsl(var(--card) / 0.82), hsl(var(--card-elevated) / 0.58));
  box-shadow:
    inset 0 1px 0 hsl(var(--foreground) / 0.035),
    0 1px 2px hsl(var(--foreground) / 0.035);
}

  .term-window-flat {
    background:
      linear-gradient(180deg, hsl(var(--card) / 0.98), hsl(var(--card-elevated) / 0.86));
  }

  .term-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom-width: 1px;
  border-color: hsl(var(--border));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
    min-height: 36px;
    background:
      linear-gradient(90deg, hsl(var(--muted) / 0.68), hsl(var(--card) / 0.82));
}

  .term-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: "JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.75rem;
  line-height: 1rem;
  color: hsl(var(--muted-foreground));
}

  .studio-org-menu-item-active .term-title {
  color: hsl(var(--background) / 0.68);
}

  .term-title {
    letter-spacing: 0.02em;
  }

  .term-status {
  font-family: "JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.75rem;
  line-height: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  color: hsl(var(--muted-foreground));
}

  .studio-org-menu-item-active .term-status {
  color: hsl(var(--background) / 0.68);
}

  .coral {
    color: hsl(var(--accent-warm));
  }

  .skill-outcome-shell {
  background-color: hsl(var(--card));
}

  .studio-shell :where(.skill-outcome-shell.border, .border.bg-card):not(.studio-card):not(.term-window):not(.term-window-flat) {
  border-color: hsl(var(--border) / 0.72);
  background:
    linear-gradient(180deg, hsl(var(--card) / 0.82), hsl(var(--card-elevated) / 0.58));
  box-shadow:
    inset 0 1px 0 hsl(var(--foreground) / 0.035),
    0 1px 2px hsl(var(--foreground) / 0.035);
}

  .skill-outcome-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  border-bottom-width: 1px;
  border-color: hsl(var(--border));
  background-color: hsl(var(--muted) / 0.3);
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

  .skill-outcome-pill {
  display: inline-flex;
  align-items: center;
  border-radius: calc(var(--radius) - 2px);
  border-width: 1px;
  border-color: hsl(var(--border));
  background-color: hsl(var(--background));
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-family: "JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 11px;
  color: hsl(var(--muted-foreground));
}

  .studio-org-menu-item-active .skill-outcome-pill {
  color: hsl(var(--background) / 0.68);
}

  .studio-shell :where(.bg-card.skill-outcome-pill, .border.bg-card):not(.studio-card):not(.term-window):not(.term-window-flat) {
  border-color: hsl(var(--border) / 0.72);
  background:
    linear-gradient(180deg, hsl(var(--card) / 0.82), hsl(var(--card-elevated) / 0.58));
  box-shadow:
    inset 0 1px 0 hsl(var(--foreground) / 0.035),
    0 1px 2px hsl(var(--foreground) / 0.035);
}

  .skill-outcome-body {
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

  .skill-streamdown {
  font-size: 0.875rem;
  line-height: 1.5rem;
  color: hsl(var(--foreground));
}

  /* Typography hierarchy */
  
  .text-heading-accent {
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 600;
    color: hsl(var(--heading-accent));
}
  
  .text-page-title {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
  --tw-gradient-from: hsl(var(--primary)) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--primary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: hsl(var(--accent)) var(--tw-gradient-to-position);
  -webkit-background-clip: text;
          background-clip: text;
  font-size: 2.25rem;
  line-height: 2.5rem;
  font-weight: 700;
  letter-spacing: -0.025em;
  color: transparent;
}
  
  .text-section-title {
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
    color: hsl(var(--heading-secondary));
}
  
  .text-subtitle {
    color: hsl(var(--subtitle-text));
  }
  
  .text-caption {
  font-size: 0.875rem;
  line-height: 1.25rem;
    color: hsl(var(--caption-text));
}

  /* Sidebar specific styles */

  /* Metric card styles */

  /* Glow effect for active states */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.\\!visible {
  visibility: visible !important;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.-inset-2 {
  inset: -0.5rem;
}
.inset-0 {
  inset: 0px;
}
.inset-3 {
  inset: 0.75rem;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-left-\\[26px\\] {
  left: -26px;
}
.-right-0\\.5 {
  right: -0.125rem;
}
.-right-1 {
  right: -0.25rem;
}
.-right-1\\.5 {
  right: -0.375rem;
}
.-top-0\\.5 {
  top: -0.125rem;
}
.-top-1 {
  top: -0.25rem;
}
.-top-1\\.5 {
  top: -0.375rem;
}
.-top-8 {
  top: -2rem;
}
.-top-\\[7px\\] {
  top: -7px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-0\\.5 {
  bottom: 0.125rem;
}
.bottom-1 {
  bottom: 0.25rem;
}
.bottom-10 {
  bottom: 2.5rem;
}
.bottom-3 {
  bottom: 0.75rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-5 {
  bottom: 1.25rem;
}
.bottom-6 {
  bottom: 1.5rem;
}
.bottom-8 {
  bottom: 2rem;
}
.bottom-full {
  bottom: 100%;
}
.left-0 {
  left: 0px;
}
.left-1 {
  left: 0.25rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-10 {
  left: 2.5rem;
}
.left-2 {
  left: 0.5rem;
}
.left-2\\.5 {
  left: 0.625rem;
}
.left-3 {
  left: 0.75rem;
}
.left-4 {
  left: 1rem;
}
.left-6 {
  left: 1.5rem;
}
.left-\\[50\\%\\] {
  left: 50%;
}
.right-0 {
  right: 0px;
}
.right-0\\.5 {
  right: 0.125rem;
}
.right-1 {
  right: 0.25rem;
}
.right-1\\.5 {
  right: 0.375rem;
}
.right-10 {
  right: 2.5rem;
}
.right-12 {
  right: 3rem;
}
.right-2 {
  right: 0.5rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.right-6 {
  right: 1.5rem;
}
.right-8 {
  right: 2rem;
}
.top-0 {
  top: 0px;
}
.top-0\\.5 {
  top: 0.125rem;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\.5 {
  top: 0.375rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-10 {
  top: 2.5rem;
}
.top-2 {
  top: 0.5rem;
}
.top-2\\.5 {
  top: 0.625rem;
}
.top-3 {
  top: 0.75rem;
}
.top-3\\.5 {
  top: 0.875rem;
}
.top-4 {
  top: 1rem;
}
.top-5 {
  top: 1.25rem;
}
.top-\\[50\\%\\] {
  top: 50%;
}
.top-full {
  top: 100%;
}
.isolate {
  isolation: isolate;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[2\\] {
  z-index: 2;
}
.z-\\[5\\] {
  z-index: 5;
}
.z-\\[60\\] {
  z-index: 60;
}
.z-\\[9000\\] {
  z-index: 9000;
}
.z-\\[9999\\] {
  z-index: 9999;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-3 {
  order: 3;
}
.-m-0\\.5 {
  margin: -0.125rem;
}
.m-0 {
  margin: 0px;
}
.m-1 {
  margin: 0.25rem;
}
.m-2 {
  margin: 0.5rem;
}
.m-3 {
  margin: 0.75rem;
}
.m-4 {
  margin: 1rem;
}
.m-5 {
  margin: 1.25rem;
}
.m-6 {
  margin: 1.5rem;
}
.m-7 {
  margin: 1.75rem;
}
.m-auto {
  margin: auto;
}
.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.mx-0\\.5 {
  margin-left: 0.125rem;
  margin-right: 0.125rem;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-3\\.5 {
  margin-left: 0.875rem;
  margin-right: 0.875rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-0\\.5 {
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-2\\.5 {
  margin-top: 0.625rem;
  margin-bottom: 0.625rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.-ml-1 {
  margin-left: -0.25rem;
}
.-mr-2 {
  margin-right: -0.5rem;
}
.-mt-10 {
  margin-top: -2.5rem;
}
.-mt-2 {
  margin-top: -0.5rem;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-2\\.5 {
  margin-bottom: 0.625rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-1\\.5 {
  margin-left: 0.375rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-0 {
  margin-right: 0px;
}
.mr-0\\.5 {
  margin-right: 0.125rem;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-1\\.5 {
  margin-right: 0.375rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[2px\\] {
  margin-top: 2px;
}
.mt-\\[3px\\] {
  margin-top: 3px;
}
.mt-\\[5px\\] {
  margin-top: 5px;
}
.mt-\\[7px\\] {
  margin-top: 7px;
}
.mt-auto {
  margin-top: auto;
}
.mt-px {
  margin-top: 1px;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.\\!table {
  display: table !important;
}
.table {
  display: table;
}
.table-cell {
  display: table-cell;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.list-item {
  display: list-item;
}
.\\!hidden {
  display: none !important;
}
.hidden {
  display: none;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.aspect-video {
  aspect-ratio: 16 / 9;
}
.size-4 {
  width: 1rem;
  height: 1rem;
}
.\\!h-2 {
  height: 0.5rem !important;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-28 {
  height: 7rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-32 {
  height: 8rem;
}
.h-36 {
  height: 9rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-64 {
  height: 16rem;
}
.h-7 {
  height: 1.75rem;
}
.h-72 {
  height: 18rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[11px\\] {
  height: 11px;
}
.h-\\[125px\\] {
  height: 125px;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[1em\\] {
  height: 1em;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-\\[22px\\] {
  height: 22px;
}
.h-\\[26px\\] {
  height: 26px;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[390px\\] {
  height: 390px;
}
.h-\\[480px\\] {
  height: 480px;
}
.h-\\[640px\\] {
  height: 640px;
}
.h-\\[calc\\(100vh-12rem\\)\\] {
  height: calc(100vh - 12rem);
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.h-svh {
  height: 100svh;
}
.max-h-12 {
  max-height: 3rem;
}
.max-h-28 {
  max-height: 7rem;
}
.max-h-32 {
  max-height: 8rem;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-44 {
  max-height: 11rem;
}
.max-h-48 {
  max-height: 12rem;
}
.max-h-52 {
  max-height: 13rem;
}
.max-h-56 {
  max-height: 14rem;
}
.max-h-60 {
  max-height: 15rem;
}
.max-h-64 {
  max-height: 16rem;
}
.max-h-72 {
  max-height: 18rem;
}
.max-h-80 {
  max-height: 20rem;
}
.max-h-96 {
  max-height: 24rem;
}
.max-h-\\[148px\\] {
  max-height: 148px;
}
.max-h-\\[250px\\] {
  max-height: 250px;
}
.max-h-\\[280px\\] {
  max-height: 280px;
}
.max-h-\\[300px\\] {
  max-height: 300px;
}
.max-h-\\[30vh\\] {
  max-height: 30vh;
}
.max-h-\\[320px\\] {
  max-height: 320px;
}
.max-h-\\[360px\\] {
  max-height: 360px;
}
.max-h-\\[400px\\] {
  max-height: 400px;
}
.max-h-\\[40vh\\] {
  max-height: 40vh;
}
.max-h-\\[420px\\] {
  max-height: 420px;
}
.max-h-\\[50vh\\] {
  max-height: 50vh;
}
.max-h-\\[520px\\] {
  max-height: 520px;
}
.max-h-\\[60vh\\] {
  max-height: 60vh;
}
.max-h-\\[640px\\] {
  max-height: 640px;
}
.max-h-\\[64vh\\] {
  max-height: 64vh;
}
.max-h-\\[70vh\\] {
  max-height: 70vh;
}
.max-h-\\[760px\\] {
  max-height: 760px;
}
.max-h-\\[80vh\\] {
  max-height: 80vh;
}
.max-h-\\[85vh\\] {
  max-height: 85vh;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.max-h-\\[min\\(70vh\\2c 520px\\)\\] {
  max-height: min(70vh,520px);
}
.max-h-screen {
  max-height: 100vh;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-10 {
  min-height: 2.5rem;
}
.min-h-12 {
  min-height: 3rem;
}
.min-h-24 {
  min-height: 6rem;
}
.min-h-28 {
  min-height: 7rem;
}
.min-h-36 {
  min-height: 9rem;
}
.min-h-6 {
  min-height: 1.5rem;
}
.min-h-7 {
  min-height: 1.75rem;
}
.min-h-8 {
  min-height: 2rem;
}
.min-h-9 {
  min-height: 2.25rem;
}
.min-h-\\[100dvh\\] {
  min-height: 100dvh;
}
.min-h-\\[120px\\] {
  min-height: 120px;
}
.min-h-\\[140px\\] {
  min-height: 140px;
}
.min-h-\\[156px\\] {
  min-height: 156px;
}
.min-h-\\[160px\\] {
  min-height: 160px;
}
.min-h-\\[180px\\] {
  min-height: 180px;
}
.min-h-\\[200px\\] {
  min-height: 200px;
}
.min-h-\\[20px\\] {
  min-height: 20px;
}
.min-h-\\[220px\\] {
  min-height: 220px;
}
.min-h-\\[240px\\] {
  min-height: 240px;
}
.min-h-\\[24px\\] {
  min-height: 24px;
}
.min-h-\\[280px\\] {
  min-height: 280px;
}
.min-h-\\[400px\\] {
  min-height: 400px;
}
.min-h-\\[48px\\] {
  min-height: 48px;
}
.min-h-\\[560px\\] {
  min-height: 560px;
}
.min-h-\\[5rem\\] {
  min-height: 5rem;
}
.min-h-\\[60px\\] {
  min-height: 60px;
}
.min-h-\\[60vh\\] {
  min-height: 60vh;
}
.min-h-\\[80px\\] {
  min-height: 80px;
}
.min-h-\\[96px\\] {
  min-height: 96px;
}
.min-h-full {
  min-height: 100%;
}
.min-h-screen {
  min-height: 100vh;
}
.\\!w-2 {
  width: 0.5rem !important;
}
.w-0\\.5 {
  width: 0.125rem;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-2\\/3 {
  width: 66.666667%;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-3\\/5 {
  width: 60%;
}
.w-3\\/6 {
  width: 50%;
}
.w-32 {
  width: 8rem;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-4\\/5 {
  width: 80%;
}
.w-4\\/6 {
  width: 66.666667%;
}
.w-40 {
  width: 10rem;
}
.w-44 {
  width: 11rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-5\\/6 {
  width: 83.333333%;
}
.w-52 {
  width: 13rem;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-9 {
  width: 2.25rem;
}
.w-96 {
  width: 24rem;
}
.w-\\[--radix-select-trigger-width\\] {
  width: var(--radix-select-trigger-width);
}
.w-\\[--sidebar-width\\] {
  width: var(--sidebar-width);
}
.w-\\[11px\\] {
  width: 11px;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[1px\\] {
  width: 1px;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[22px\\] {
  width: 22px;
}
.w-\\[22rem\\] {
  width: 22rem;
}
.w-\\[250px\\] {
  width: 250px;
}
.w-\\[2px\\] {
  width: 2px;
}
.w-\\[3px\\] {
  width: 3px;
}
.w-\\[400px\\] {
  width: 400px;
}
.w-\\[58\\%\\] {
  width: 58%;
}
.w-\\[60px\\] {
  width: 60px;
}
.w-\\[64\\%\\] {
  width: 64%;
}
.w-\\[70\\%\\] {
  width: 70%;
}
.w-\\[70vw\\] {
  width: 70vw;
}
.w-\\[72\\%\\] {
  width: 72%;
}
.w-\\[75\\%\\] {
  width: 75%;
}
.w-\\[78\\%\\] {
  width: 78%;
}
.w-\\[80\\%\\] {
  width: 80%;
}
.w-\\[85\\%\\] {
  width: 85%;
}
.w-\\[85vw\\] {
  width: 85vw;
}
.w-\\[88\\%\\] {
  width: 88%;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-\\[clamp\\(360px\\2c 34vw\\2c 560px\\)\\] {
  width: clamp(360px,34vw,560px);
}
.w-\\[min\\(26rem\\2c calc\\(100vw-24px\\)\\)\\] {
  width: min(26rem,calc(100vw - 24px));
}
.w-\\[min\\(92vw\\2c 420px\\)\\] {
  width: min(92vw,420px);
}
.w-auto {
  width: auto;
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: -moz-max-content;
  width: max-content;
}
.w-px {
  width: 1px;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-2 {
  min-width: 0.5rem;
}
.min-w-3\\.5 {
  min-width: 0.875rem;
}
.min-w-4 {
  min-width: 1rem;
}
.min-w-5 {
  min-width: 1.25rem;
}
.min-w-7 {
  min-width: 1.75rem;
}
.min-w-\\[--radix-select-trigger-width\\] {
  min-width: var(--radix-select-trigger-width);
}
.min-w-\\[1040px\\] {
  min-width: 1040px;
}
.min-w-\\[104px\\] {
  min-width: 104px;
}
.min-w-\\[110px\\] {
  min-width: 110px;
}
.min-w-\\[116px\\] {
  min-width: 116px;
}
.min-w-\\[118px\\] {
  min-width: 118px;
}
.min-w-\\[120px\\] {
  min-width: 120px;
}
.min-w-\\[126px\\] {
  min-width: 126px;
}
.min-w-\\[130px\\] {
  min-width: 130px;
}
.min-w-\\[140px\\] {
  min-width: 140px;
}
.min-w-\\[14rem\\] {
  min-width: 14rem;
}
.min-w-\\[150px\\] {
  min-width: 150px;
}
.min-w-\\[160px\\] {
  min-width: 160px;
}
.min-w-\\[170px\\] {
  min-width: 170px;
}
.min-w-\\[180px\\] {
  min-width: 180px;
}
.min-w-\\[190px\\] {
  min-width: 190px;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[240px\\] {
  min-width: 240px;
}
.min-w-\\[280px\\] {
  min-width: 280px;
}
.min-w-\\[300px\\] {
  min-width: 300px;
}
.min-w-\\[36rem\\] {
  min-width: 36rem;
}
.min-w-\\[42rem\\] {
  min-width: 42rem;
}
.min-w-\\[4px\\] {
  min-width: 4px;
}
.min-w-\\[720px\\] {
  min-width: 720px;
}
.min-w-\\[72px\\] {
  min-width: 72px;
}
.min-w-\\[820px\\] {
  min-width: 820px;
}
.min-w-\\[88px\\] {
  min-width: 88px;
}
.min-w-\\[8rem\\] {
  min-width: 8rem;
}
.min-w-\\[900px\\] {
  min-width: 900px;
}
.min-w-\\[92px\\] {
  min-width: 92px;
}
.min-w-\\[9rem\\] {
  min-width: 9rem;
}
.min-w-full {
  min-width: 100%;
}
.min-w-max {
  min-width: -moz-max-content;
  min-width: max-content;
}
.max-w-0 {
  max-width: 0px;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-72 {
  max-width: 18rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[--skeleton-width\\] {
  max-width: var(--skeleton-width);
}
.max-w-\\[120px\\] {
  max-width: 120px;
}
.max-w-\\[12rem\\] {
  max-width: 12rem;
}
.max-w-\\[140px\\] {
  max-width: 140px;
}
.max-w-\\[14rem\\] {
  max-width: 14rem;
}
.max-w-\\[1600px\\] {
  max-width: 1600px;
}
.max-w-\\[160px\\] {
  max-width: 160px;
}
.max-w-\\[180px\\] {
  max-width: 180px;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[20rem\\] {
  max-width: 20rem;
}
.max-w-\\[220px\\] {
  max-width: 220px;
}
.max-w-\\[22rem\\] {
  max-width: 22rem;
}
.max-w-\\[230px\\] {
  max-width: 230px;
}
.max-w-\\[240px\\] {
  max-width: 240px;
}
.max-w-\\[24rem\\] {
  max-width: 24rem;
}
.max-w-\\[260px\\] {
  max-width: 260px;
}
.max-w-\\[280px\\] {
  max-width: 280px;
}
.max-w-\\[28rem\\] {
  max-width: 28rem;
}
.max-w-\\[300px\\] {
  max-width: 300px;
}
.max-w-\\[320px\\] {
  max-width: 320px;
}
.max-w-\\[360px\\] {
  max-width: 360px;
}
.max-w-\\[36rem\\] {
  max-width: 36rem;
}
.max-w-\\[400px\\] {
  max-width: 400px;
}
.max-w-\\[42ch\\] {
  max-width: 42ch;
}
.max-w-\\[48ch\\] {
  max-width: 48ch;
}
.max-w-\\[520px\\] {
  max-width: 520px;
}
.max-w-\\[52ch\\] {
  max-width: 52ch;
}
.max-w-\\[560px\\] {
  max-width: 560px;
}
.max-w-\\[600px\\] {
  max-width: 600px;
}
.max-w-\\[7\\.5rem\\] {
  max-width: 7.5rem;
}
.max-w-\\[70\\%\\] {
  max-width: 70%;
}
.max-w-\\[80\\%\\] {
  max-width: 80%;
}
.max-w-\\[82\\%\\] {
  max-width: 82%;
}
.max-w-\\[820px\\] {
  max-width: 820px;
}
.max-w-\\[85\\%\\] {
  max-width: 85%;
}
.max-w-\\[90\\%\\] {
  max-width: 90%;
}
.max-w-\\[9rem\\] {
  max-width: 9rem;
}
.max-w-\\[calc\\(100\\%-2rem\\)\\] {
  max-width: calc(100% - 2rem);
}
.max-w-\\[min\\(100\\%\\2c 280px\\)\\] {
  max-width: min(100%,280px);
}
.max-w-\\[min\\(100\\%\\2c 320px\\)\\] {
  max-width: min(100%,320px);
}
.max-w-\\[min\\(10rem\\2c 30vw\\)\\] {
  max-width: min(10rem,30vw);
}
.max-w-\\[min\\(12rem\\2c 40vw\\)\\] {
  max-width: min(12rem,40vw);
}
.max-w-\\[min\\(44rem\\2c 64vw\\)\\] {
  max-width: min(44rem,64vw);
}
.max-w-\\[min\\(46rem\\2c 58vw\\)\\] {
  max-width: min(46rem,58vw);
}
.max-w-\\[min\\(92vw\\2c 900px\\)\\] {
  max-width: min(92vw,900px);
}
.max-w-\\[min\\(96vw\\2c 1100px\\)\\] {
  max-width: min(96vw,1100px);
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-none {
  max-width: none;
}
.max-w-prose {
  max-width: 65ch;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-\\[2\\] {
  flex: 2;
}
.flex-none {
  flex: none;
}
.flex-shrink {
  flex-shrink: 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink {
  flex-shrink: 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.grow {
  flex-grow: 1;
}
.basis-32 {
  flex-basis: 8rem;
}
.basis-40 {
  flex-basis: 10rem;
}
.basis-48 {
  flex-basis: 12rem;
}
.basis-52 {
  flex-basis: 13rem;
}
.basis-64 {
  flex-basis: 16rem;
}
.basis-\\[8rem\\] {
  flex-basis: 8rem;
}
.basis-full {
  flex-basis: 100%;
}
.table-fixed {
  table-layout: fixed;
}
.caption-bottom {
  caption-side: bottom;
}
.border-collapse {
  border-collapse: collapse;
}
.origin-top-right {
  transform-origin: top right;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-px {
  --tw-translate-x: -1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-0\\.5 {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0\\.5 {
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-4 {
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-px {
  --tw-translate-x: 1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\] {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.animate-\\[observability-refresh_1s_ease-in-out_infinite\\] {
  animation: observability-refresh 1s ease-in-out infinite;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-\\[pulse_1\\.6s_ease-in-out_infinite\\] {
  animation: pulse 1.6s ease-in-out infinite;
}
.animate-\\[shimmer_1\\.8s_ease-in-out_infinite\\] {
  animation: shimmer 1.8s ease-in-out infinite;
}
.animate-\\[shimmer_2s_ease-in-out_infinite\\] {
  animation: shimmer 2s ease-in-out infinite;
}
@keyframes bounce {

  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce {
  animation: bounce 1s infinite;
}
@keyframes fade-in {

  0% {
    opacity: 0;
    transform: translateY(10px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-fade-in {
  animation: fade-in 0.3s ease-out;
}
@keyframes ping {

  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-col-resize {
  cursor: col-resize;
}
.cursor-crosshair {
  cursor: crosshair;
}
.cursor-default {
  cursor: default;
}
.cursor-grab {
  cursor: grab;
}
.cursor-help {
  cursor: help;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-text {
  cursor: text;
}
.cursor-wait {
  cursor: wait;
}
.touch-none {
  touch-action: none;
}
.select-none {
  -moz-user-select: none;
       user-select: none;
}
.select-text {
  -moz-user-select: text;
       user-select: text;
}
.select-all {
  -moz-user-select: all;
       user-select: all;
}
.resize-none {
  resize: none;
}
.resize-y {
  resize: vertical;
}
.resize {
  resize: both;
}
.scroll-mt-3 {
  scroll-margin-top: 0.75rem;
}
.scroll-mt-4 {
  scroll-margin-top: 1rem;
}
.list-inside {
  list-style-position: inside;
}
.list-outside {
  list-style-position: outside;
}
.list-decimal {
  list-style-type: decimal;
}
.list-disc {
  list-style-type: disc;
}
.list-none {
  list-style-type: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.grid-cols-\\[1\\.5rem_minmax\\(0\\2c 1fr\\)\\] {
  grid-template-columns: 1.5rem minmax(0,1fr);
}
.grid-cols-\\[110px_minmax\\(0\\2c 1fr\\)\\] {
  grid-template-columns: 110px minmax(0,1fr);
}
.grid-cols-\\[140px_1fr_72px\\] {
  grid-template-columns: 140px 1fr 72px;
}
.grid-cols-\\[140px_minmax\\(180px\\2c 1\\.1fr\\)_minmax\\(240px\\2c 1\\.5fr\\)_minmax\\(180px\\2c 1fr\\)_112px\\] {
  grid-template-columns: 140px minmax(180px,1.1fr) minmax(240px,1.5fr) minmax(180px,1fr) 112px;
}
.grid-cols-\\[2rem_minmax\\(0\\2c 1fr\\)\\] {
  grid-template-columns: 2rem minmax(0,1fr);
}
.grid-cols-\\[auto_1fr\\] {
  grid-template-columns: auto 1fr;
}
.grid-cols-\\[max-content_1fr\\] {
  grid-template-columns: max-content 1fr;
}
.grid-cols-\\[minmax\\(0\\2c 1fr\\)_auto_auto\\] {
  grid-template-columns: minmax(0,1fr) auto auto;
}
.grid-cols-\\[minmax\\(120px\\2c 200px\\)_1fr_44px\\] {
  grid-template-columns: minmax(120px,200px) 1fr 44px;
}
.grid-rows-\\[minmax\\(180px\\2c 0\\.45fr\\)_minmax\\(220px\\2c 0\\.55fr\\)\\] {
  grid-template-rows: minmax(180px,0.45fr) minmax(220px,0.55fr);
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.place-items-center {
  place-items: center;
}
.content-start {
  align-content: flex-start;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-3\\.5 {
  gap: 0.875rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-7 {
  gap: 1.75rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-\\[2px\\] {
  gap: 2px;
}
.gap-x-1 {
  -moz-column-gap: 0.25rem;
       column-gap: 0.25rem;
}
.gap-x-1\\.5 {
  -moz-column-gap: 0.375rem;
       column-gap: 0.375rem;
}
.gap-x-10 {
  -moz-column-gap: 2.5rem;
       column-gap: 2.5rem;
}
.gap-x-2 {
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem;
}
.gap-x-2\\.5 {
  -moz-column-gap: 0.625rem;
       column-gap: 0.625rem;
}
.gap-x-3 {
  -moz-column-gap: 0.75rem;
       column-gap: 0.75rem;
}
.gap-x-4 {
  -moz-column-gap: 1rem;
       column-gap: 1rem;
}
.gap-x-5 {
  -moz-column-gap: 1.25rem;
       column-gap: 1.25rem;
}
.gap-x-6 {
  -moz-column-gap: 1.5rem;
       column-gap: 1.5rem;
}
.gap-x-7 {
  -moz-column-gap: 1.75rem;
       column-gap: 1.75rem;
}
.gap-x-8 {
  -moz-column-gap: 2rem;
       column-gap: 2rem;
}
.gap-y-0\\.5 {
  row-gap: 0.125rem;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-1\\.5 {
  row-gap: 0.375rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-2\\.5 {
  row-gap: 0.625rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-12 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(3rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(3rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-x > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-y-0 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(0px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(0px * var(--tw-divide-y-reverse));
}
.divide-border > :not([hidden]) ~ :not([hidden]) {
  border-color: hsl(var(--border));
}
.divide-border\\/40 > :not([hidden]) ~ :not([hidden]) {
  border-color: hsl(var(--border) / 0.4);
}
.divide-border\\/50 > :not([hidden]) ~ :not([hidden]) {
  border-color: hsl(var(--border) / 0.5);
}
.divide-border\\/60 > :not([hidden]) ~ :not([hidden]) {
  border-color: hsl(var(--border) / 0.6);
}
.self-start {
  align-self: flex-start;
}
.self-center {
  align-self: center;
}
.self-stretch {
  align-self: stretch;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.overflow-x-scroll {
  overflow-x: scroll;
}
.scroll-smooth {
  scroll-behavior: smooth;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre {
  white-space: pre;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-\\[var\\(--oa-radius-md\\)\\] {
  border-radius: var(--oa-radius-md);
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: var(--radius);
}
.rounded-md {
  border-radius: calc(var(--radius) - 2px);
}
.rounded-none {
  border-radius: 0px;
}
.rounded-sm {
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b-\\[var\\(--oa-radius-md\\)\\] {
  border-bottom-right-radius: var(--oa-radius-md);
  border-bottom-left-radius: var(--oa-radius-md);
}
.rounded-b-lg {
  border-bottom-right-radius: var(--radius);
  border-bottom-left-radius: var(--radius);
}
.rounded-b-md {
  border-bottom-right-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.rounded-b-xl {
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-l {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-r {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.rounded-t {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-t-\\[var\\(--oa-radius-md\\)\\] {
  border-top-left-radius: var(--oa-radius-md);
  border-top-right-radius: var(--oa-radius-md);
}
.rounded-t-full {
  border-top-left-radius: 9999px;
  border-top-right-radius: 9999px;
}
.rounded-t-lg {
  border-top-left-radius: var(--radius);
  border-top-right-radius: var(--radius);
}
.rounded-t-md {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-top-right-radius: calc(var(--radius) - 2px);
}
.rounded-br-md {
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.rounded-tl-sm {
  border-top-left-radius: calc(var(--radius) - 4px);
}
.rounded-tr-sm {
  border-top-right-radius: calc(var(--radius) - 4px);
}
.\\!border-0 {
  border-width: 0px !important;
}
.\\!border-2 {
  border-width: 2px !important;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-\\[1\\.5px\\] {
  border-width: 1.5px;
}
.border-x {
  border-left-width: 1px;
  border-right-width: 1px;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-l-4 {
  border-left-width: 4px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-dashed {
  border-style: dashed;
}
.border-none {
  border-style: none;
}
.\\!border-background {
  border-color: hsl(var(--background)) !important;
}
.border-\\[hsl\\(var\\(--accent-warm\\)\\)\\] {
  border-color: hsl(var(--accent-warm));
}
.border-\\[hsl\\(var\\(--accent-warm\\)\\)\\]\\/40 {
  border-color: hsl(var(--accent-warm) / 0.4);
}
.border-\\[hsl\\(var\\(--accent-warm\\)\\)\\]\\/45 {
  border-color: hsl(var(--accent-warm) / 0.45);
}
.border-\\[hsl\\(var\\(--accent-warm\\)\\)\\]\\/55 {
  border-color: hsl(var(--accent-warm) / 0.55);
}
.border-\\[hsl\\(var\\(--primary\\)\\)\\] {
  border-color: hsl(var(--primary));
}
.border-\\[hsl\\(var\\(--primary\\)\\/0\\.35\\)\\] {
  border-color: hsl(var(--primary)/0.35);
}
.border-\\[hsl\\(var\\(--primary\\)\\/0\\.45\\)\\] {
  border-color: hsl(var(--primary)/0.45);
}
.border-\\[hsl\\(var\\(--rs-warm\\2c var\\(--primary\\)\\)\\/0\\.4\\)\\] {
  border-color: hsl(var(--rs-warm,var(--primary))/0.4);
}
.border-\\[var\\(--oa-divider\\)\\] {
  border-color: var(--oa-divider);
}
.border-accent {
  border-color: hsl(var(--accent));
}
.border-accent\\/40 {
  border-color: hsl(var(--accent) / 0.4);
}
.border-amber-200 {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-amber-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1));
}
.border-amber-400 {
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}
.border-amber-400\\/70 {
  border-color: rgb(251 191 36 / 0.7);
}
.border-amber-500 {
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.border-amber-500\\/20 {
  border-color: rgb(245 158 11 / 0.2);
}
.border-amber-500\\/25 {
  border-color: rgb(245 158 11 / 0.25);
}
.border-amber-500\\/30 {
  border-color: rgb(245 158 11 / 0.3);
}
.border-amber-500\\/35 {
  border-color: rgb(245 158 11 / 0.35);
}
.border-amber-500\\/40 {
  border-color: rgb(245 158 11 / 0.4);
}
.border-amber-600 {
  --tw-border-opacity: 1;
  border-color: rgb(217 119 6 / var(--tw-border-opacity, 1));
}
.border-amber-600\\/40 {
  border-color: rgb(217 119 6 / 0.4);
}
.border-amber-800\\/30 {
  border-color: rgb(146 64 14 / 0.3);
}
.border-background {
  border-color: hsl(var(--background));
}
.border-blue-200 {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-blue-500\\/10 {
  border-color: rgb(59 130 246 / 0.1);
}
.border-blue-500\\/15 {
  border-color: rgb(59 130 246 / 0.15);
}
.border-blue-500\\/20 {
  border-color: rgb(59 130 246 / 0.2);
}
.border-blue-500\\/25 {
  border-color: rgb(59 130 246 / 0.25);
}
.border-blue-500\\/30 {
  border-color: rgb(59 130 246 / 0.3);
}
.border-blue-500\\/40 {
  border-color: rgb(59 130 246 / 0.4);
}
.border-blue-500\\/50 {
  border-color: rgb(59 130 246 / 0.5);
}
.border-blue-500\\/70 {
  border-color: rgb(59 130 246 / 0.7);
}
.border-border {
  border-color: hsl(var(--border));
}
.border-border\\/20 {
  border-color: hsl(var(--border) / 0.2);
}
.border-border\\/30 {
  border-color: hsl(var(--border) / 0.3);
}
.border-border\\/40 {
  border-color: hsl(var(--border) / 0.4);
}
.border-border\\/50 {
  border-color: hsl(var(--border) / 0.5);
}
.border-border\\/60 {
  border-color: hsl(var(--border) / 0.6);
}
.border-border\\/70 {
  border-color: hsl(var(--border) / 0.7);
}
.border-border\\/80 {
  border-color: hsl(var(--border) / 0.8);
}
.border-current {
  border-color: currentColor;
}
.border-cyan-500\\/30 {
  border-color: rgb(6 182 212 / 0.3);
}
.border-cyan-500\\/50 {
  border-color: rgb(6 182 212 / 0.5);
}
.border-destructive {
  border-color: hsl(var(--destructive));
}
.border-destructive\\/20 {
  border-color: hsl(var(--destructive) / 0.2);
}
.border-destructive\\/25 {
  border-color: hsl(var(--destructive) / 0.25);
}
.border-destructive\\/30 {
  border-color: hsl(var(--destructive) / 0.3);
}
.border-destructive\\/40 {
  border-color: hsl(var(--destructive) / 0.4);
}
.border-destructive\\/50 {
  border-color: hsl(var(--destructive) / 0.5);
}
.border-destructive\\/60 {
  border-color: hsl(var(--destructive) / 0.6);
}
.border-emerald-200 {
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-emerald-300 {
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity, 1));
}
.border-emerald-500 {
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.border-emerald-500\\/25 {
  border-color: rgb(16 185 129 / 0.25);
}
.border-emerald-500\\/30 {
  border-color: rgb(16 185 129 / 0.3);
}
.border-emerald-500\\/40 {
  border-color: rgb(16 185 129 / 0.4);
}
.border-emerald-600\\/40 {
  border-color: rgb(5 150 105 / 0.4);
}
.border-emerald-600\\/50 {
  border-color: rgb(5 150 105 / 0.5);
}
.border-foreground {
  border-color: hsl(var(--foreground));
}
.border-foreground\\/10 {
  border-color: hsl(var(--foreground) / 0.1);
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-500\\/30 {
  border-color: rgb(107 114 128 / 0.3);
}
.border-green-200 {
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-green-500\\/10 {
  border-color: rgb(34 197 94 / 0.1);
}
.border-green-500\\/20 {
  border-color: rgb(34 197 94 / 0.2);
}
.border-green-500\\/30 {
  border-color: rgb(34 197 94 / 0.3);
}
.border-green-500\\/40 {
  border-color: rgb(34 197 94 / 0.4);
}
.border-indigo-500\\/30 {
  border-color: rgb(99 102 241 / 0.3);
}
.border-input {
  border-color: hsl(var(--input));
}
.border-ma-accent-faint {
  border-color: color-mix(in oklab, var(--ma-accent) 25%, transparent);
}
.border-ma-err-line {
  border-color: var(--ma-state-err-line);
}
.border-ma-info-line {
  border-color: var(--ma-state-info-line);
}
.border-ma-ok-line {
  border-color: var(--ma-state-ok-line);
}
.border-ma-warn-line {
  border-color: var(--ma-state-warn-line);
}
.border-muted {
  border-color: hsl(var(--muted));
}
.border-muted-foreground\\/25 {
  border-color: hsl(var(--muted-foreground) / 0.25);
}
.border-muted-foreground\\/30 {
  border-color: hsl(var(--muted-foreground) / 0.3);
}
.border-muted-foreground\\/40 {
  border-color: hsl(var(--muted-foreground) / 0.4);
}
.border-muted-foreground\\/50 {
  border-color: hsl(var(--muted-foreground) / 0.5);
}
.border-muted-foreground\\/60 {
  border-color: hsl(var(--muted-foreground) / 0.6);
}
.border-muted\\/60 {
  border-color: hsl(var(--muted) / 0.6);
}
.border-orange-300 {
  --tw-border-opacity: 1;
  border-color: rgb(253 186 116 / var(--tw-border-opacity, 1));
}
.border-orange-500\\/20 {
  border-color: rgb(249 115 22 / 0.2);
}
.border-orange-500\\/30 {
  border-color: rgb(249 115 22 / 0.3);
}
.border-orange-500\\/40 {
  border-color: rgb(249 115 22 / 0.4);
}
.border-pink-500\\/30 {
  border-color: rgb(236 72 153 / 0.3);
}
.border-primary {
  border-color: hsl(var(--primary));
}
.border-primary\\/20 {
  border-color: hsl(var(--primary) / 0.2);
}
.border-primary\\/25 {
  border-color: hsl(var(--primary) / 0.25);
}
.border-primary\\/30 {
  border-color: hsl(var(--primary) / 0.3);
}
.border-primary\\/35 {
  border-color: hsl(var(--primary) / 0.35);
}
.border-primary\\/40 {
  border-color: hsl(var(--primary) / 0.4);
}
.border-primary\\/45 {
  border-color: hsl(var(--primary) / 0.45);
}
.border-primary\\/50 {
  border-color: hsl(var(--primary) / 0.5);
}
.border-primary\\/60 {
  border-color: hsl(var(--primary) / 0.6);
}
.border-primary\\/80 {
  border-color: hsl(var(--primary) / 0.8);
}
.border-purple-200 {
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}
.border-purple-500\\/30 {
  border-color: rgb(168 85 247 / 0.3);
}
.border-purple-500\\/50 {
  border-color: rgb(168 85 247 / 0.5);
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-red-400 {
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-red-500\\/20 {
  border-color: rgb(239 68 68 / 0.2);
}
.border-red-500\\/25 {
  border-color: rgb(239 68 68 / 0.25);
}
.border-red-500\\/30 {
  border-color: rgb(239 68 68 / 0.3);
}
.border-red-500\\/40 {
  border-color: rgb(239 68 68 / 0.4);
}
.border-red-600\\/40 {
  border-color: rgb(220 38 38 / 0.4);
}
.border-rose-500\\/20 {
  border-color: rgb(244 63 94 / 0.2);
}
.border-rose-500\\/30 {
  border-color: rgb(244 63 94 / 0.3);
}
.border-secondary {
  border-color: hsl(var(--secondary));
}
.border-sidebar-border {
  border-color: hsl(var(--sidebar-border));
}
.border-sky-500\\/20 {
  border-color: rgb(14 165 233 / 0.2);
}
.border-sky-500\\/30 {
  border-color: rgb(14 165 233 / 0.3);
}
.border-slate-200 {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-slate-200\\/60 {
  border-color: rgb(226 232 240 / 0.6);
}
.border-slate-300 {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.border-success {
  border-color: hsl(var(--success));
}
.border-success\\/20 {
  border-color: hsl(var(--success) / 0.2);
}
.border-success\\/25 {
  border-color: hsl(var(--success) / 0.25);
}
.border-success\\/30 {
  border-color: hsl(var(--success) / 0.3);
}
.border-success\\/40 {
  border-color: hsl(var(--success) / 0.4);
}
.border-teal-200 {
  --tw-border-opacity: 1;
  border-color: rgb(153 246 228 / var(--tw-border-opacity, 1));
}
.border-teal-400 {
  --tw-border-opacity: 1;
  border-color: rgb(45 212 191 / var(--tw-border-opacity, 1));
}
.border-teal-500 {
  --tw-border-opacity: 1;
  border-color: rgb(20 184 166 / var(--tw-border-opacity, 1));
}
.border-teal-500\\/30 {
  border-color: rgb(20 184 166 / 0.3);
}
.border-transparent {
  border-color: transparent;
}
.border-violet-500 {
  --tw-border-opacity: 1;
  border-color: rgb(139 92 246 / var(--tw-border-opacity, 1));
}
.border-violet-500\\/20 {
  border-color: rgb(139 92 246 / 0.2);
}
.border-violet-500\\/30 {
  border-color: rgb(139 92 246 / 0.3);
}
.border-violet-500\\/40 {
  border-color: rgb(139 92 246 / 0.4);
}
.border-warning\\/25 {
  border-color: hsl(var(--warning) / 0.25);
}
.border-warning\\/30 {
  border-color: hsl(var(--warning) / 0.3);
}
.border-warning\\/40 {
  border-color: hsl(var(--warning) / 0.4);
}
.border-warning\\/50 {
  border-color: hsl(var(--warning) / 0.5);
}
.border-yellow-300 {
  --tw-border-opacity: 1;
  border-color: rgb(253 224 71 / var(--tw-border-opacity, 1));
}
.border-yellow-500\\/25 {
  border-color: rgb(234 179 8 / 0.25);
}
.border-yellow-500\\/30 {
  border-color: rgb(234 179 8 / 0.3);
}
.border-yellow-500\\/40 {
  border-color: rgb(234 179 8 / 0.4);
}
.border-yellow-500\\/50 {
  border-color: rgb(234 179 8 / 0.5);
}
.border-zinc-500\\/40 {
  border-color: rgb(113 113 122 / 0.4);
}
.border-l-\\[hsl\\(var\\(--accent-warm\\)\\)\\] {
  border-left-color: hsl(var(--accent-warm));
}
.border-l-\\[hsl\\(var\\(--success\\)\\)\\] {
  border-left-color: hsl(var(--success));
}
.border-l-border {
  border-left-color: hsl(var(--border));
}
.border-l-border\\/40 {
  border-left-color: hsl(var(--border) / 0.4);
}
.border-l-destructive {
  border-left-color: hsl(var(--destructive));
}
.border-l-file-explorer-selected-border {
  border-left-color: hsl(var(--file-explorer-selected-border));
}
.border-l-primary {
  border-left-color: hsl(var(--primary));
}
.border-l-transparent {
  border-left-color: transparent;
}
.border-l-warning-strong {
  border-left-color: hsl(var(--warning-strong));
}
.border-t-transparent {
  border-top-color: transparent;
}
.\\!bg-amber-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-gray-400 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-green-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-muted-foreground\\/40 {
  background-color: hsl(var(--muted-foreground) / 0.4) !important;
}
.\\!bg-primary {
  background-color: hsl(var(--primary)) !important;
}
.\\!bg-red-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-teal-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#0a0a0a\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(10 10 10 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1E1E1E\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 30 30 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fafafa\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\.\\.\\.\\] {
  background-color: ...;
}
.bg-\\[hsl\\(var\\(--accent-warm\\)\\)\\] {
  background-color: hsl(var(--accent-warm));
}
.bg-\\[hsl\\(var\\(--accent-warm\\)\\)\\]\\/10 {
  background-color: hsl(var(--accent-warm) / 0.1);
}
.bg-\\[hsl\\(var\\(--accent-warm\\)\\)\\]\\/15 {
  background-color: hsl(var(--accent-warm) / 0.15);
}
.bg-\\[hsl\\(var\\(--accent-warm\\)\\/0\\.15\\)\\] {
  background-color: hsl(var(--accent-warm)/0.15);
}
.bg-\\[hsl\\(var\\(--accent-warm-soft\\)\\)\\] {
  background-color: hsl(var(--accent-warm-soft));
}
.bg-\\[hsl\\(var\\(--accent-warm-soft\\)\\)\\]\\/50 {
  background-color: hsl(var(--accent-warm-soft) / 0.5);
}
.bg-\\[hsl\\(var\\(--card\\)\\)\\] {
  background-color: hsl(var(--card));
}
.bg-\\[hsl\\(var\\(--destructive\\)\\/0\\.15\\)\\] {
  background-color: hsl(var(--destructive)/0.15);
}
.bg-\\[hsl\\(var\\(--destructive\\)\\/0\\.7\\)\\] {
  background-color: hsl(var(--destructive)/0.7);
}
.bg-\\[hsl\\(var\\(--muted\\)\\/0\\.6\\)\\] {
  background-color: hsl(var(--muted)/0.6);
}
.bg-\\[hsl\\(var\\(--primary\\)\\)\\] {
  background-color: hsl(var(--primary));
}
.bg-\\[hsl\\(var\\(--primary\\)\\/0\\.08\\)\\] {
  background-color: hsl(var(--primary)/0.08);
}
.bg-\\[hsl\\(var\\(--primary\\)\\/0\\.12\\)\\] {
  background-color: hsl(var(--primary)/0.12);
}
.bg-\\[hsl\\(var\\(--success\\)\\)\\] {
  background-color: hsl(var(--success));
}
.bg-\\[hsl\\(var\\(--success\\)\\)\\]\\/60 {
  background-color: hsl(var(--success) / 0.6);
}
.bg-\\[hsl\\(var\\(--success\\)\\/0\\.03\\)\\] {
  background-color: hsl(var(--success)/0.03);
}
.bg-\\[hsl\\(var\\(--success\\)\\/0\\.6\\)\\] {
  background-color: hsl(var(--success)/0.6);
}
.bg-\\[var\\(--ma-accent-text\\)\\] {
  background-color: var(--ma-accent-text);
}
.bg-\\[var\\(--ma-send-bg\\)\\] {
  background-color: var(--ma-send-bg);
}
.bg-\\[var\\(--ma-state-err-text\\)\\] {
  background-color: var(--ma-state-err-text);
}
.bg-\\[var\\(--ma-state-warn-text\\)\\] {
  background-color: var(--ma-state-warn-text);
}
.bg-\\[var\\(--ma-surface-soft\\)\\] {
  background-color: var(--ma-surface-soft);
}
.bg-\\[var\\(--ma-user-bubble\\)\\] {
  background-color: var(--ma-user-bubble);
}
.bg-\\[var\\(--oa-surface\\)\\] {
  background-color: var(--oa-surface);
}
.bg-\\[var\\(--tst-panel-bg\\)\\] {
  background-color: var(--tst-panel-bg);
}
.bg-accent {
  background-color: hsl(var(--accent));
}
.bg-accent-warm-soft {
  background-color: hsl(var(--accent-warm-soft));
}
.bg-accent-warm\\/10 {
  background-color: hsl(var(--accent-warm) / 0.1);
}
.bg-accent\\/10 {
  background-color: hsl(var(--accent) / 0.1);
}
.bg-accent\\/15 {
  background-color: hsl(var(--accent) / 0.15);
}
.bg-amber-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-200\\/90 {
  background-color: rgb(253 230 138 / 0.9);
}
.bg-amber-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
.bg-amber-400\\/35 {
  background-color: rgb(251 191 36 / 0.35);
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-amber-500\\/10 {
  background-color: rgb(245 158 11 / 0.1);
}
.bg-amber-500\\/15 {
  background-color: rgb(245 158 11 / 0.15);
}
.bg-amber-500\\/25 {
  background-color: rgb(245 158 11 / 0.25);
}
.bg-amber-500\\/5 {
  background-color: rgb(245 158 11 / 0.05);
}
.bg-amber-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.bg-background {
  background-color: hsl(var(--background));
}
.bg-background\\/30 {
  background-color: hsl(var(--background) / 0.3);
}
.bg-background\\/40 {
  background-color: hsl(var(--background) / 0.4);
}
.bg-background\\/50 {
  background-color: hsl(var(--background) / 0.5);
}
.bg-background\\/60 {
  background-color: hsl(var(--background) / 0.6);
}
.bg-background\\/70 {
  background-color: hsl(var(--background) / 0.7);
}
.bg-background\\/85 {
  background-color: hsl(var(--background) / 0.85);
}
.bg-background\\/95 {
  background-color: hsl(var(--background) / 0.95);
}
.bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/60 {
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/80 {
  background-color: rgb(0 0 0 / 0.8);
}
.bg-black\\/90 {
  background-color: rgb(0 0 0 / 0.9);
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-blue-500\\/10 {
  background-color: rgb(59 130 246 / 0.1);
}
.bg-blue-500\\/15 {
  background-color: rgb(59 130 246 / 0.15);
}
.bg-blue-500\\/20 {
  background-color: rgb(59 130 246 / 0.2);
}
.bg-blue-500\\/5 {
  background-color: rgb(59 130 246 / 0.05);
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-blue-600\\/80 {
  background-color: rgb(37 99 235 / 0.8);
}
.bg-border {
  background-color: hsl(var(--border));
}
.bg-border\\/60 {
  background-color: hsl(var(--border) / 0.6);
}
.bg-card {
  background-color: hsl(var(--card));
}
.bg-card\\/30 {
  background-color: hsl(var(--card) / 0.3);
}
.bg-card\\/40 {
  background-color: hsl(var(--card) / 0.4);
}
.bg-card\\/50 {
  background-color: hsl(var(--card) / 0.5);
}
.bg-card\\/60 {
  background-color: hsl(var(--card) / 0.6);
}
.bg-card\\/70 {
  background-color: hsl(var(--card) / 0.7);
}
.bg-card\\/80 {
  background-color: hsl(var(--card) / 0.8);
}
.bg-card\\/90 {
  background-color: hsl(var(--card) / 0.9);
}
.bg-card\\/95 {
  background-color: hsl(var(--card) / 0.95);
}
.bg-charcoal {
  background-color: hsl(var(--charcoal));
}
.bg-current {
  background-color: currentColor;
}
.bg-cyan-500\\/10 {
  background-color: rgb(6 182 212 / 0.1);
}
.bg-destructive {
  background-color: hsl(var(--destructive));
}
.bg-destructive-strong {
  background-color: hsl(var(--destructive-strong));
}
.bg-destructive\\/10 {
  background-color: hsl(var(--destructive) / 0.1);
}
.bg-destructive\\/15 {
  background-color: hsl(var(--destructive) / 0.15);
}
.bg-destructive\\/5 {
  background-color: hsl(var(--destructive) / 0.05);
}
.bg-destructive\\/\\[0\\.06\\] {
  background-color: hsl(var(--destructive) / 0.06);
}
.bg-destructive\\/\\[0\\.08\\] {
  background-color: hsl(var(--destructive) / 0.08);
}
.bg-destructive\\/\\[0\\.13\\] {
  background-color: hsl(var(--destructive) / 0.13);
}
.bg-emerald-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500\\/10 {
  background-color: rgb(16 185 129 / 0.1);
}
.bg-emerald-500\\/15 {
  background-color: rgb(16 185 129 / 0.15);
}
.bg-emerald-500\\/25 {
  background-color: rgb(16 185 129 / 0.25);
}
.bg-emerald-500\\/5 {
  background-color: rgb(16 185 129 / 0.05);
}
.bg-emerald-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-emerald-600\\/80 {
  background-color: rgb(5 150 105 / 0.8);
}
.bg-file-explorer-selected {
  background-color: hsl(var(--file-explorer-selected));
}
.bg-foreground {
  background-color: hsl(var(--foreground));
}
.bg-foreground\\/10 {
  background-color: hsl(var(--foreground) / 0.1);
}
.bg-foreground\\/60 {
  background-color: hsl(var(--foreground) / 0.6);
}
.bg-foreground\\/70 {
  background-color: hsl(var(--foreground) / 0.7);
}
.bg-foreground\\/90 {
  background-color: hsl(var(--foreground) / 0.9);
}
.bg-foreground\\/\\[0\\.08\\] {
  background-color: hsl(var(--foreground) / 0.08);
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.bg-gray-500\\/10 {
  background-color: rgb(107 114 128 / 0.1);
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-green-500\\/10 {
  background-color: rgb(34 197 94 / 0.1);
}
.bg-green-500\\/15 {
  background-color: rgb(34 197 94 / 0.15);
}
.bg-green-500\\/20 {
  background-color: rgb(34 197 94 / 0.2);
}
.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-green-600\\/90 {
  background-color: rgb(22 163 74 / 0.9);
}
.bg-indigo-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(129 140 248 / var(--tw-bg-opacity, 1));
}
.bg-indigo-500\\/10 {
  background-color: rgb(99 102 241 / 0.1);
}
.bg-inherit {
  background-color: inherit;
}
.bg-ma-accent-soft {
  background-color: var(--ma-accent-soft);
}
.bg-ma-err {
  background-color: var(--ma-state-err);
}
.bg-ma-err-soft {
  background-color: var(--ma-state-err-soft);
}
.bg-ma-info {
  background-color: var(--ma-state-info);
}
.bg-ma-info-soft {
  background-color: var(--ma-state-info-soft);
}
.bg-ma-ok {
  background-color: var(--ma-state-ok);
}
.bg-ma-ok-soft {
  background-color: var(--ma-state-ok-soft);
}
.bg-ma-warn {
  background-color: var(--ma-state-warn);
}
.bg-ma-warn-soft {
  background-color: var(--ma-state-warn-soft);
}
.bg-muted {
  background-color: hsl(var(--muted));
}
.bg-muted-foreground {
  background-color: hsl(var(--muted-foreground));
}
.bg-muted-foreground\\/10 {
  background-color: hsl(var(--muted-foreground) / 0.1);
}
.bg-muted-foreground\\/15 {
  background-color: hsl(var(--muted-foreground) / 0.15);
}
.bg-muted-foreground\\/20 {
  background-color: hsl(var(--muted-foreground) / 0.2);
}
.bg-muted-foreground\\/30 {
  background-color: hsl(var(--muted-foreground) / 0.3);
}
.bg-muted-foreground\\/40 {
  background-color: hsl(var(--muted-foreground) / 0.4);
}
.bg-muted-foreground\\/50 {
  background-color: hsl(var(--muted-foreground) / 0.5);
}
.bg-muted-foreground\\/60 {
  background-color: hsl(var(--muted-foreground) / 0.6);
}
.bg-muted-foreground\\/\\[0\\.03\\] {
  background-color: hsl(var(--muted-foreground) / 0.03);
}
.bg-muted-foreground\\/\\[0\\.04\\] {
  background-color: hsl(var(--muted-foreground) / 0.04);
}
.bg-muted-foreground\\/\\[0\\.05\\] {
  background-color: hsl(var(--muted-foreground) / 0.05);
}
.bg-muted-foreground\\/\\[0\\.07\\] {
  background-color: hsl(var(--muted-foreground) / 0.07);
}
.bg-muted\\/10 {
  background-color: hsl(var(--muted) / 0.1);
}
.bg-muted\\/15 {
  background-color: hsl(var(--muted) / 0.15);
}
.bg-muted\\/20 {
  background-color: hsl(var(--muted) / 0.2);
}
.bg-muted\\/25 {
  background-color: hsl(var(--muted) / 0.25);
}
.bg-muted\\/30 {
  background-color: hsl(var(--muted) / 0.3);
}
.bg-muted\\/35 {
  background-color: hsl(var(--muted) / 0.35);
}
.bg-muted\\/40 {
  background-color: hsl(var(--muted) / 0.4);
}
.bg-muted\\/5 {
  background-color: hsl(var(--muted) / 0.05);
}
.bg-muted\\/50 {
  background-color: hsl(var(--muted) / 0.5);
}
.bg-muted\\/60 {
  background-color: hsl(var(--muted) / 0.6);
}
.bg-muted\\/70 {
  background-color: hsl(var(--muted) / 0.7);
}
.bg-muted\\/80 {
  background-color: hsl(var(--muted) / 0.8);
}
.bg-orange-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}
.bg-orange-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity, 1));
}
.bg-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-orange-500\\/10 {
  background-color: rgb(249 115 22 / 0.1);
}
.bg-pink-500\\/10 {
  background-color: rgb(236 72 153 / 0.1);
}
.bg-popover {
  background-color: hsl(var(--popover));
}
.bg-primary {
  background-color: hsl(var(--primary));
}
.bg-primary-foreground {
  background-color: hsl(var(--primary-foreground));
}
.bg-primary-foreground\\/15 {
  background-color: hsl(var(--primary-foreground) / 0.15);
}
.bg-primary\\/10 {
  background-color: hsl(var(--primary) / 0.1);
}
.bg-primary\\/15 {
  background-color: hsl(var(--primary) / 0.15);
}
.bg-primary\\/20 {
  background-color: hsl(var(--primary) / 0.2);
}
.bg-primary\\/25 {
  background-color: hsl(var(--primary) / 0.25);
}
.bg-primary\\/40 {
  background-color: hsl(var(--primary) / 0.4);
}
.bg-primary\\/5 {
  background-color: hsl(var(--primary) / 0.05);
}
.bg-primary\\/60 {
  background-color: hsl(var(--primary) / 0.6);
}
.bg-primary\\/70 {
  background-color: hsl(var(--primary) / 0.7);
}
.bg-primary\\/\\[0\\.05\\] {
  background-color: hsl(var(--primary) / 0.05);
}
.bg-primary\\/\\[0\\.06\\] {
  background-color: hsl(var(--primary) / 0.06);
}
.bg-primary\\/\\[0\\.10\\] {
  background-color: hsl(var(--primary) / 0.10);
}
.bg-purple-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-500\\/10 {
  background-color: rgb(168 85 247 / 0.1);
}
.bg-purple-500\\/20 {
  background-color: rgb(168 85 247 / 0.2);
}
.bg-purple-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/10 {
  background-color: rgb(239 68 68 / 0.1);
}
.bg-red-500\\/15 {
  background-color: rgb(239 68 68 / 0.15);
}
.bg-red-500\\/20 {
  background-color: rgb(239 68 68 / 0.2);
}
.bg-red-500\\/25 {
  background-color: rgb(239 68 68 / 0.25);
}
.bg-red-500\\/5 {
  background-color: rgb(239 68 68 / 0.05);
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-rose-500\\/10 {
  background-color: rgb(244 63 94 / 0.1);
}
.bg-secondary {
  background-color: hsl(var(--secondary));
}
.bg-sidebar {
  background-color: hsl(var(--sidebar-background));
}
.bg-sidebar-accent {
  background-color: hsl(var(--sidebar-accent));
}
.bg-sidebar-accent\\/50 {
  background-color: hsl(var(--sidebar-accent) / 0.5);
}
.bg-sidebar-border {
  background-color: hsl(var(--sidebar-border));
}
.bg-sky-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity, 1));
}
.bg-sky-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(56 189 248 / var(--tw-bg-opacity, 1));
}
.bg-sky-500\\/10 {
  background-color: rgb(14 165 233 / 0.1);
}
.bg-slate-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-slate-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1));
}
.bg-slate-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-slate-50\\/50 {
  background-color: rgb(248 250 252 / 0.5);
}
.bg-slate-500\\/10 {
  background-color: rgb(100 116 139 / 0.1);
}
.bg-slate-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.bg-slate-900\\/80 {
  background-color: rgb(15 23 42 / 0.8);
}
.bg-success {
  background-color: hsl(var(--success));
}
.bg-success\\/10 {
  background-color: hsl(var(--success) / 0.1);
}
.bg-success\\/15 {
  background-color: hsl(var(--success) / 0.15);
}
.bg-success\\/5 {
  background-color: hsl(var(--success) / 0.05);
}
.bg-teal-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(204 251 241 / var(--tw-bg-opacity, 1));
}
.bg-teal-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 250 / var(--tw-bg-opacity, 1));
}
.bg-teal-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity, 1));
}
.bg-teal-500\\/10 {
  background-color: rgb(20 184 166 / 0.1);
}
.bg-transparent {
  background-color: transparent;
}
.bg-violet-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / var(--tw-bg-opacity, 1));
}
.bg-violet-500\\/10 {
  background-color: rgb(139 92 246 / 0.1);
}
.bg-violet-500\\/20 {
  background-color: rgb(139 92 246 / 0.2);
}
.bg-warning {
  background-color: hsl(var(--warning));
}
.bg-warning-strong {
  background-color: hsl(var(--warning-strong));
}
.bg-warning\\/10 {
  background-color: hsl(var(--warning) / 0.1);
}
.bg-warning\\/15 {
  background-color: hsl(var(--warning) / 0.15);
}
.bg-warning\\/20 {
  background-color: hsl(var(--warning) / 0.2);
}
.bg-warning\\/5 {
  background-color: hsl(var(--warning) / 0.05);
}
.bg-warning\\/\\[0\\.06\\] {
  background-color: hsl(var(--warning) / 0.06);
}
.bg-warning\\/\\[0\\.07\\] {
  background-color: hsl(var(--warning) / 0.07);
}
.bg-warning\\/\\[0\\.08\\] {
  background-color: hsl(var(--warning) / 0.08);
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/20 {
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/95 {
  background-color: rgb(255 255 255 / 0.95);
}
.bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-yellow-300\\/40 {
  background-color: rgb(253 224 71 / 0.4);
}
.bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500\\/10 {
  background-color: rgb(234 179 8 / 0.1);
}
.bg-yellow-500\\/15 {
  background-color: rgb(234 179 8 / 0.15);
}
.bg-yellow-500\\/20 {
  background-color: rgb(234 179 8 / 0.2);
}
.bg-yellow-500\\/30 {
  background-color: rgb(234 179 8 / 0.3);
}
.bg-yellow-500\\/5 {
  background-color: rgb(234 179 8 / 0.05);
}
.bg-yellow-500\\/70 {
  background-color: rgb(234 179 8 / 0.7);
}
.bg-zinc-500\\/10 {
  background-color: rgb(113 113 122 / 0.1);
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-black {
  --tw-gradient-from: #000 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500 {
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500\\/20 {
  --tw-gradient-from: rgb(59 130 246 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-600 {
  --tw-gradient-from: #2563eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 99 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-500 {
  --tw-gradient-from: #10b981 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-500 {
  --tw-gradient-from: #6b7280 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(107 114 128 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-500 {
  --tw-gradient-from: #22c55e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-500 {
  --tw-gradient-from: #6366f1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-500 {
  --tw-gradient-from: #f97316 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary {
  --tw-gradient-from: hsl(var(--primary)) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--primary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-500 {
  --tw-gradient-from: #a855f7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-500 {
  --tw-gradient-from: #ef4444 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-50 {
  --tw-gradient-from: #f8fafc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 250 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-950 {
  --tw-gradient-from: #020617 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(2 6 23 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-500 {
  --tw-gradient-from: #14b8a6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(20 184 166 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent {
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-500 {
  --tw-gradient-from: #8b5cf6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(139 92 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-yellow-500 {
  --tw-gradient-from: #eab308 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(234 179 8 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-blue-50\\/50 {
  --tw-gradient-to: rgb(239 246 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(239 246 255 / 0.5) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-blue-500 {
  --tw-gradient-to: rgb(59 130 246 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #3b82f6 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-cyan-500\\/10 {
  --tw-gradient-to: rgb(6 182 212 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(6 182 212 / 0.1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-foreground\\/10 {
  --tw-gradient-to: hsl(var(--foreground) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--foreground) / 0.1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-primary\\/10 {
  --tw-gradient-to: hsl(var(--primary) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--primary) / 0.1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-primary\\/20 {
  --tw-gradient-to: hsl(var(--primary) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--primary) / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-primary\\/25 {
  --tw-gradient-to: hsl(var(--primary) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--primary) / 0.25) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-primary\\/70 {
  --tw-gradient-to: hsl(var(--primary) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--primary) / 0.7) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-slate-900 {
  --tw-gradient-to: rgb(15 23 42 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #0f172a var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-warning\\/25 {
  --tw-gradient-to: hsl(var(--warning) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--warning) / 0.25) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[var\\(--tst-surface-soft\\)\\] {
  --tw-gradient-to: var(--tst-surface-soft) var(--tw-gradient-to-position);
}
.to-accent {
  --tw-gradient-to: hsl(var(--accent)) var(--tw-gradient-to-position);
}
.to-black {
  --tw-gradient-to: #000 var(--tw-gradient-to-position);
}
.to-blue-50\\/50 {
  --tw-gradient-to: rgb(239 246 255 / 0.5) var(--tw-gradient-to-position);
}
.to-blue-950 {
  --tw-gradient-to: #172554 var(--tw-gradient-to-position);
}
.to-cyan-600 {
  --tw-gradient-to: #0891b2 var(--tw-gradient-to-position);
}
.to-emerald-600 {
  --tw-gradient-to: #059669 var(--tw-gradient-to-position);
}
.to-indigo-50 {
  --tw-gradient-to: #eef2ff var(--tw-gradient-to-position);
}
.to-orange-600 {
  --tw-gradient-to: #ea580c var(--tw-gradient-to-position);
}
.to-pink-600 {
  --tw-gradient-to: #db2777 var(--tw-gradient-to-position);
}
.to-purple-600 {
  --tw-gradient-to: #9333ea var(--tw-gradient-to-position);
}
.to-red-600 {
  --tw-gradient-to: #dc2626 var(--tw-gradient-to-position);
}
.to-slate-600 {
  --tw-gradient-to: #475569 var(--tw-gradient-to-position);
}
.to-teal-500 {
  --tw-gradient-to: #14b8a6 var(--tw-gradient-to-position);
}
.to-teal-500\\/20 {
  --tw-gradient-to: rgb(20 184 166 / 0.2) var(--tw-gradient-to-position);
}
.to-teal-600 {
  --tw-gradient-to: #0d9488 var(--tw-gradient-to-position);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.bg-clip-text {
  -webkit-background-clip: text;
          background-clip: text;
}
.fill-\\[hsl\\(var\\(--accent-warm\\)\\)\\] {
  fill: hsl(var(--accent-warm));
}
.fill-amber-400 {
  fill: #fbbf24;
}
.fill-amber-400\\/10 {
  fill: rgb(251 191 36 / 0.1);
}
.fill-current {
  fill: currentColor;
}
.fill-foreground {
  fill: hsl(var(--foreground));
}
.fill-muted\\/30 {
  fill: hsl(var(--muted) / 0.3);
}
.fill-transparent {
  fill: transparent;
}
.stroke-amber-400\\/60 {
  stroke: rgb(251 191 36 / 0.6);
}
.stroke-amber-500 {
  stroke: #f59e0b;
}
.stroke-muted-foreground\\/40 {
  stroke: hsl(var(--muted-foreground) / 0.4);
}
.stroke-transparent {
  stroke: transparent;
}
.stroke-\\[3\\] {
  stroke-width: 3;
}
.object-contain {
  -o-object-fit: contain;
     object-fit: contain;
}
.object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}
.\\!p-0 {
  padding: 0px !important;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-3\\.5 {
  padding: 0.875rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[var\\(--oa-gutter\\)\\] {
  padding: var(--oa-gutter);
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5 {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[var\\(--oa-gutter\\)\\] {
  padding-left: var(--oa-gutter);
  padding-right: var(--oa-gutter);
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-24 {
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-px {
  padding-top: 1px;
  padding-bottom: 1px;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-0\\.5 {
  padding-bottom: 0.125rem;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.pb-14 {
  padding-bottom: 3.5rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-2\\.5 {
  padding-bottom: 0.625rem;
}
.pb-28 {
  padding-bottom: 7rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-1\\.5 {
  padding-left: 0.375rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-14 {
  padding-left: 3.5rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-2\\.5 {
  padding-left: 0.625rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-3\\.5 {
  padding-left: 0.875rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-7 {
  padding-left: 1.75rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-1\\.5 {
  padding-right: 0.375rem;
}
.pr-11 {
  padding-right: 2.75rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-5 {
  padding-right: 1.25rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pr-9 {
  padding-right: 2.25rem;
}
.ps-3 {
  padding-inline-start: 0.75rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-0\\.5 {
  padding-top: 0.125rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-1\\.5 {
  padding-top: 0.375rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-12 {
  padding-top: 3rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-2\\.5 {
  padding-top: 0.625rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-8 {
  padding-top: 2rem;
}
.pt-\\[10vh\\] {
  padding-top: 10vh;
}
.pt-\\[15vh\\] {
  padding-top: 15vh;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.align-baseline {
  vertical-align: baseline;
}
.align-top {
  vertical-align: top;
}
.align-middle {
  vertical-align: middle;
}
.align-bottom {
  vertical-align: bottom;
}
.align-super {
  vertical-align: super;
}
.font-display {
  font-family: "Space Grotesk", Inter, ui-sans-serif, system-ui, sans-serif;
}
.font-fraunces {
  font-family: Fraunces, Georgia, serif;
}
.font-mono {
  font-family: "JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace;
}
.font-sans {
  font-family: Inter, ui-sans-serif, system-ui, sans-serif;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11\\.5px\\] {
  font-size: 11.5px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12\\.5px\\] {
  font-size: 12.5px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[13\\.5px\\] {
  font-size: 13.5px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[14\\.5px\\] {
  font-size: 14.5px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[17px\\] {
  font-size: 17px;
}
.text-\\[19px\\] {
  font-size: 19px;
}
.text-\\[22px\\] {
  font-size: 22px;
}
.text-\\[24px\\] {
  font-size: 24px;
}
.text-\\[26px\\] {
  font-size: 26px;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-\\[34px\\] {
  font-size: 34px;
}
.text-\\[3px\\] {
  font-size: 3px;
}
.text-\\[8px\\] {
  font-size: 8px;
}
.text-\\[9\\.5px\\] {
  font-size: 9.5px;
}
.text-\\[9px\\] {
  font-size: 9px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.normal-case {
  text-transform: none;
}
.italic {
  font-style: italic;
}
.ordinal {
  --tw-ordinal: ordinal;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-3 {
  line-height: .75rem;
}
.leading-4 {
  line-height: 1rem;
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-8 {
  line-height: 2rem;
}
.leading-\\[1\\.3\\] {
  line-height: 1.3;
}
.leading-\\[18px\\] {
  line-height: 18px;
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[-0\\.02em\\] {
  letter-spacing: -0.02em;
}
.tracking-\\[0\\.01em\\] {
  letter-spacing: 0.01em;
}
.tracking-\\[0\\.06em\\] {
  letter-spacing: 0.06em;
}
.tracking-\\[0\\.08em\\] {
  letter-spacing: 0.08em;
}
.tracking-\\[0\\.14em\\] {
  letter-spacing: 0.14em;
}
.tracking-\\[0\\.16em\\] {
  letter-spacing: 0.16em;
}
.tracking-\\[0\\.18em\\] {
  letter-spacing: 0.18em;
}
.tracking-normal {
  letter-spacing: 0em;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.text-\\[hsl\\(var\\(--accent-warm\\)\\)\\] {
  color: hsl(var(--accent-warm));
}
.text-\\[hsl\\(var\\(--accent-warm-foreground\\)\\)\\] {
  color: hsl(var(--accent-warm-foreground));
}
.text-\\[hsl\\(var\\(--destructive\\)\\)\\] {
  color: hsl(var(--destructive));
}
.text-\\[hsl\\(var\\(--destructive\\)\\/0\\.8\\)\\] {
  color: hsl(var(--destructive)/0.8);
}
.text-\\[hsl\\(var\\(--primary\\)\\)\\] {
  color: hsl(var(--primary));
}
.text-\\[hsl\\(var\\(--primary-foreground\\)\\)\\] {
  color: hsl(var(--primary-foreground));
}
.text-\\[hsl\\(var\\(--success\\)\\)\\] {
  color: hsl(var(--success));
}
.text-\\[hsl\\(var\\(--warning\\2c 38_92\\%_50\\%\\)\\)\\] {
  color: hsl(var(--warning,38 92% 50%));
}
.text-\\[var\\(--ma-accent-text\\)\\] {
  color: var(--ma-accent-text);
}
.text-\\[var\\(--ma-send-ink\\)\\] {
  color: var(--ma-send-ink);
}
.text-\\[var\\(--ma-state-err-text\\)\\] {
  color: var(--ma-state-err-text);
}
.text-\\[var\\(--ma-state-ok-text\\)\\] {
  color: var(--ma-state-ok-text);
}
.text-\\[var\\(--ma-state-warn-text\\)\\] {
  color: var(--ma-state-warn-text);
}
.text-accent {
  color: hsl(var(--accent));
}
.text-accent-foreground {
  color: hsl(var(--accent-foreground));
}
.text-accent-warm {
  color: hsl(var(--accent-warm));
}
.text-amber-400 {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.text-amber-400\\/70 {
  color: rgb(251 191 36 / 0.7);
}
.text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-600\\/70 {
  color: rgb(217 119 6 / 0.7);
}
.text-amber-600\\/80 {
  color: rgb(217 119 6 / 0.8);
}
.text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-700\\/90 {
  color: rgb(180 83 9 / 0.9);
}
.text-amber-800 {
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-amber-900 {
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}
.text-amber-950 {
  --tw-text-opacity: 1;
  color: rgb(69 26 3 / var(--tw-text-opacity, 1));
}
.text-background {
  color: hsl(var(--background));
}
.text-blue-200\\/90 {
  color: rgb(191 219 254 / 0.9);
}
.text-blue-400 {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.text-blue-400\\/60 {
  color: rgb(96 165 250 / 0.6);
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.text-card-foreground {
  color: hsl(var(--card-foreground));
}
.text-charcoal-foreground {
  color: hsl(var(--charcoal-foreground));
}
.text-current {
  color: currentColor;
}
.text-cyan-400 {
  --tw-text-opacity: 1;
  color: rgb(34 211 238 / var(--tw-text-opacity, 1));
}
.text-cyan-500 {
  --tw-text-opacity: 1;
  color: rgb(6 182 212 / var(--tw-text-opacity, 1));
}
.text-cyan-600 {
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity, 1));
}
.text-cyan-700 {
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity, 1));
}
.text-destructive {
  color: hsl(var(--destructive));
}
.text-destructive-foreground {
  color: hsl(var(--destructive-foreground));
}
.text-destructive-strong {
  color: hsl(var(--destructive-strong));
}
.text-destructive-strong\\/90 {
  color: hsl(var(--destructive-strong) / 0.9);
}
.text-destructive\\/60 {
  color: hsl(var(--destructive) / 0.6);
}
.text-emerald-200 {
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity, 1));
}
.text-emerald-300 {
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}
.text-emerald-400 {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.text-emerald-500 {
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.text-emerald-600 {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700 {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-800 {
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-emerald-900 {
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}
.text-file-explorer-selected-foreground {
  color: hsl(var(--file-explorer-selected-foreground));
}
.text-foreground {
  color: hsl(var(--foreground));
}
.text-foreground\\/40 {
  color: hsl(var(--foreground) / 0.4);
}
.text-foreground\\/50 {
  color: hsl(var(--foreground) / 0.5);
}
.text-foreground\\/60 {
  color: hsl(var(--foreground) / 0.6);
}
.text-foreground\\/70 {
  color: hsl(var(--foreground) / 0.7);
}
.text-foreground\\/75 {
  color: hsl(var(--foreground) / 0.75);
}
.text-foreground\\/80 {
  color: hsl(var(--foreground) / 0.8);
}
.text-foreground\\/85 {
  color: hsl(var(--foreground) / 0.85);
}
.text-foreground\\/90 {
  color: hsl(var(--foreground) / 0.9);
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-400 {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.text-green-400\\/60 {
  color: rgb(74 222 128 / 0.6);
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-green-700\\/80 {
  color: rgb(21 128 61 / 0.8);
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-indigo-400 {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}
.text-indigo-500 {
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}
.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-ma-accent {
  color: var(--ma-accent);
}
.text-ma-err-text {
  color: var(--ma-state-err-text);
}
.text-ma-info-text {
  color: var(--ma-state-info-text);
}
.text-ma-ok-text {
  color: var(--ma-state-ok-text);
}
.text-ma-warn-text {
  color: var(--ma-state-warn-text);
}
.text-muted {
  color: hsl(var(--muted));
}
.text-muted-foreground {
  color: hsl(var(--muted-foreground));
}
.text-muted-foreground\\/20 {
  color: hsl(var(--muted-foreground) / 0.2);
}
.text-muted-foreground\\/25 {
  color: hsl(var(--muted-foreground) / 0.25);
}
.text-muted-foreground\\/30 {
  color: hsl(var(--muted-foreground) / 0.3);
}
.text-muted-foreground\\/40 {
  color: hsl(var(--muted-foreground) / 0.4);
}
.text-muted-foreground\\/50 {
  color: hsl(var(--muted-foreground) / 0.5);
}
.text-muted-foreground\\/60 {
  color: hsl(var(--muted-foreground) / 0.6);
}
.text-muted-foreground\\/70 {
  color: hsl(var(--muted-foreground) / 0.7);
}
.text-muted-foreground\\/75 {
  color: hsl(var(--muted-foreground) / 0.75);
}
.text-muted-foreground\\/80 {
  color: hsl(var(--muted-foreground) / 0.8);
}
.text-muted-foreground\\/85 {
  color: hsl(var(--muted-foreground) / 0.85);
}
.text-muted-foreground\\/90 {
  color: hsl(var(--muted-foreground) / 0.9);
}
.text-orange-300 {
  --tw-text-opacity: 1;
  color: rgb(253 186 116 / var(--tw-text-opacity, 1));
}
.text-orange-400 {
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity, 1));
}
.text-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.text-orange-600 {
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.text-orange-700 {
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.text-pink-600 {
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity, 1));
}
.text-popover-foreground {
  color: hsl(var(--popover-foreground));
}
.text-primary {
  color: hsl(var(--primary));
}
.text-primary-foreground {
  color: hsl(var(--primary-foreground));
}
.text-primary\\/40 {
  color: hsl(var(--primary) / 0.4);
}
.text-primary\\/80 {
  color: hsl(var(--primary) / 0.8);
}
.text-primary\\/90 {
  color: hsl(var(--primary) / 0.9);
}
.text-purple-400 {
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}
.text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}
.text-purple-600 {
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}
.text-red-300 {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-800 {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-rose-400 {
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}
.text-rose-400\\/80 {
  color: rgb(251 113 133 / 0.8);
}
.text-rose-500 {
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1));
}
.text-rose-600 {
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.text-secondary-foreground {
  color: hsl(var(--secondary-foreground));
}
.text-sidebar-accent-foreground {
  color: hsl(var(--sidebar-accent-foreground));
}
.text-sidebar-foreground {
  color: hsl(var(--sidebar-foreground));
}
.text-sidebar-foreground\\/70 {
  color: hsl(var(--sidebar-foreground) / 0.7);
}
.text-sky-400 {
  --tw-text-opacity: 1;
  color: rgb(56 189 248 / var(--tw-text-opacity, 1));
}
.text-sky-600 {
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity, 1));
}
.text-sky-800 {
  --tw-text-opacity: 1;
  color: rgb(7 89 133 / var(--tw-text-opacity, 1));
}
.text-slate-300 {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.text-slate-400 {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600 {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-slate-700 {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-slate-800 {
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.text-success {
  color: hsl(var(--success));
}
.text-success-foreground {
  color: hsl(var(--success-foreground));
}
.text-success-strong {
  color: hsl(var(--success-strong));
}
.text-success-strong\\/60 {
  color: hsl(var(--success-strong) / 0.6);
}
.text-teal-600 {
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / var(--tw-text-opacity, 1));
}
.text-teal-700 {
  --tw-text-opacity: 1;
  color: rgb(15 118 110 / var(--tw-text-opacity, 1));
}
.text-transparent {
  color: transparent;
}
.text-violet-400 {
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity, 1));
}
.text-violet-500 {
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity, 1));
}
.text-violet-600 {
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity, 1));
}
.text-violet-800 {
  --tw-text-opacity: 1;
  color: rgb(91 33 182 / var(--tw-text-opacity, 1));
}
.text-warning {
  color: hsl(var(--warning));
}
.text-warning-strong {
  color: hsl(var(--warning-strong));
}
.text-warning-strong\\/80 {
  color: hsl(var(--warning-strong) / 0.8);
}
.text-warning-strong\\/90 {
  color: hsl(var(--warning-strong) / 0.9);
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/50 {
  color: rgb(255 255 255 / 0.5);
}
.text-white\\/70 {
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/90 {
  color: rgb(255 255 255 / 0.9);
}
.text-white\\/95 {
  color: rgb(255 255 255 / 0.95);
}
.text-yellow-200 {
  --tw-text-opacity: 1;
  color: rgb(254 240 138 / var(--tw-text-opacity, 1));
}
.text-yellow-300 {
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / var(--tw-text-opacity, 1));
}
.text-yellow-400 {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}
.text-yellow-500\\/70 {
  color: rgb(234 179 8 / 0.7);
}
.text-yellow-600 {
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.text-zinc-400 {
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.line-through {
  text-decoration-line: line-through;
}
.decoration-dotted {
  text-decoration-style: dotted;
}
.underline-offset-2 {
  text-underline-offset: 2px;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.accent-\\[hsl\\(var\\(--primary\\)\\)\\] {
  accent-color: hsl(var(--primary));
}
.accent-primary {
  accent-color: hsl(var(--primary));
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-30 {
  opacity: 0.3;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-45 {
  opacity: 0.45;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-55 {
  opacity: 0.55;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-90 {
  opacity: 0.9;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_1px_hsl\\(var\\(--primary\\)\\/0\\.18\\)\\] {
  --tw-shadow: 0 0 0 1px hsl(var(--primary)/0.18);
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_1px_hsl\\(var\\(--sidebar-border\\)\\)\\] {
  --tw-shadow: 0 0 0 1px hsl(var(--sidebar-border));
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_12px_rgba\\(59\\2c 130\\2c 246\\2c 0\\.35\\)\\] {
  --tw-shadow: 0 0 12px rgba(59,130,246,0.35);
  --tw-shadow-colored: 0 0 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_20px_rgba\\(59\\2c 130\\2c 246\\2c 0\\.25\\)\\] {
  --tw-shadow: 0 0 20px rgba(59,130,246,0.25);
  --tw-shadow-colored: 0 0 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_16px_48px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.45\\)\\] {
  --tw-shadow: 0 16px 48px rgba(0,0,0,0.45);
  --tw-shadow-colored: 0 16px 48px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_16px_48px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\] {
  --tw-shadow: 0 16px 48px rgba(0,0,0,0.5);
  --tw-shadow-colored: 0 16px 48px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_24px_64px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\] {
  --tw-shadow: 0 24px 64px rgba(0,0,0,0.5);
  --tw-shadow-colored: 0 24px 64px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_8px_hsl\\(var\\(--foreground\\)\\/0\\.15\\)\\] {
  --tw-shadow: 0 2px 8px hsl(var(--foreground)/0.15);
  --tw-shadow-colored: 0 2px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_16px_hsl\\(var\\(--foreground\\)\\/0\\.08\\)\\] {
  --tw-shadow: 0 4px 16px hsl(var(--foreground)/0.08);
  --tw-shadow-colored: 0 4px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_16px_hsl\\(var\\(--foreground\\)\\/0\\.1\\)\\] {
  --tw-shadow: 0 4px 16px hsl(var(--foreground)/0.1);
  --tw-shadow-colored: 0 4px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_24px_hsl\\(var\\(--foreground\\)\\/0\\.12\\)\\] {
  --tw-shadow: 0 8px 24px hsl(var(--foreground)/0.12);
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_32px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.45\\)\\] {
  --tw-shadow: 0 8px 32px rgba(0,0,0,0.45);
  --tw-shadow-colored: 0 8px 32px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_32px_rgba\\(59\\2c 130\\2c 246\\2c 0\\.45\\)\\] {
  --tw-shadow: 0 8px 32px rgba(59,130,246,0.45);
  --tw-shadow-colored: 0 8px 32px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_2px_0_0_hsl\\(var\\(--primary\\)\\)\\] {
  --tw-shadow: inset 2px 0 0 hsl(var(--primary));
  --tw-shadow-colored: inset 2px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-emerald-900\\/10 {
  --tw-shadow-color: rgb(6 78 59 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset {
  --tw-ring-inset: inset;
}
.ring-\\[hsl\\(var\\(--primary\\)\\/0\\.3\\)\\] {
  --tw-ring-color: hsl(var(--primary)/0.3);
}
.ring-amber-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 191 36 / var(--tw-ring-opacity, 1));
}
.ring-amber-500\\/20 {
  --tw-ring-color: rgb(245 158 11 / 0.2);
}
.ring-black\\/10 {
  --tw-ring-color: rgb(0 0 0 / 0.1);
}
.ring-border\\/45 {
  --tw-ring-color: hsl(var(--border) / 0.45);
}
.ring-foreground {
  --tw-ring-color: hsl(var(--foreground));
}
.ring-primary {
  --tw-ring-color: hsl(var(--primary));
}
.ring-primary\\/20 {
  --tw-ring-color: hsl(var(--primary) / 0.2);
}
.ring-red-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity, 1));
}
.ring-red-500\\/20 {
  --tw-ring-color: rgb(239 68 68 / 0.2);
}
.ring-sidebar-ring {
  --tw-ring-color: hsl(var(--sidebar-ring));
}
.ring-teal-500\\/20 {
  --tw-ring-color: rgb(20 184 166 / 0.2);
}
.ring-offset-1 {
  --tw-ring-offset-width: 1px;
}
.ring-offset-background {
  --tw-ring-offset-color: hsl(var(--background));
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-2xl {
  --tw-blur: blur(40px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl {
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-xl {
  --tw-blur: blur(24px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.brightness-110 {
  --tw-brightness: brightness(1.1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_0_8px_rgba\\(59\\2c 130\\2c 246\\2c 0\\.6\\)\\] {
  --tw-drop-shadow: drop-shadow(0 0 8px rgba(59,130,246,0.6));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_8px_32px_rgba\\(30\\2c 64\\2c 175\\2c 0\\.4\\)\\] {
  --tw-drop-shadow: drop-shadow(0 8px 32px rgba(30,64,175,0.4));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-md {
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-sm {
  --tw-drop-shadow: drop-shadow(0 1px 1px rgb(0 0 0 / 0.05));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\!filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur {
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[1px\\] {
  --tw-backdrop-blur: blur(1px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[2px\\] {
  --tw-backdrop-blur: blur(2px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md {
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-filter {
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[background\\2c color\\] {
  transition-property: background,color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[background-color\\2c border-color\\2c box-shadow\\] {
  transition-property: background-color,border-color,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[background-color\\2c box-shadow\\2c color\\] {
  transition-property: background-color,box-shadow,color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[background-color\\2c color\\2c border-color\\2c filter\\] {
  transition-property: background-color,color,border-color,filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[background-color\\2c opacity\\] {
  transition-property: background-color,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[border-color\\2c background\\] {
  transition-property: border-color,background;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[color\\2c background-color\\] {
  transition-property: color,background-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[filter\\2c background\\] {
  transition-property: filter,background;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[height\\] {
  transition-property: height;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[left\\2c right\\2c width\\] {
  transition-property: left,right,width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[margin\\2c opacity\\] {
  transition-property: margin,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\2c height\\2c padding\\] {
  transition-property: width,height,padding;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\] {
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-75 {
  transition-duration: 75ms;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-linear {
  transition-timing-function: linear;
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
@keyframes enter {

  from {
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit {

  to {
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in {
  --tw-enter-opacity: 0;
}
.fade-in-0 {
  --tw-enter-opacity: 0;
}
.fade-in-80 {
  --tw-enter-opacity: 0.8;
}
.zoom-in-95 {
  --tw-enter-scale: .95;
}
.slide-in-from-bottom-2 {
  --tw-enter-translate-y: 0.5rem;
}
.duration-100 {
  animation-duration: 100ms;
}
.duration-150 {
  animation-duration: 150ms;
}
.duration-200 {
  animation-duration: 200ms;
}
.duration-300 {
  animation-duration: 300ms;
}
.duration-500 {
  animation-duration: 500ms;
}
.duration-75 {
  animation-duration: 75ms;
}
.ease-in {
  animation-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out {
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-linear {
  animation-timing-function: linear;
}
.ease-out {
  animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.\\!running {
  animation-play-state: running !important;
}
.running {
  animation-play-state: running;
}
.paused {
  animation-play-state: paused;
}
.\\[animation-delay\\:0ms\\] {
  animation-delay: 0ms;
}
.\\[animation-delay\\:150ms\\] {
  animation-delay: 150ms;
}
.\\[animation-delay\\:300ms\\] {
  animation-delay: 300ms;
}
.\\[grid-template-columns\\:repeat\\(auto-fill\\2c minmax\\(240px\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(auto-fill,minmax(240px,1fr));
}
.\\[grid-template-columns\\:repeat\\(auto-fill\\2c minmax\\(min\\(260px\\2c 100\\%\\)\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(auto-fill,minmax(min(260px,100%),1fr));
}
.\\[grid-template-columns\\:repeat\\(auto-fit\\2c minmax\\(104px\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(auto-fit,minmax(104px,1fr));
}
.\\[grid-template-columns\\:repeat\\(auto-fit\\2c minmax\\(120px\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(auto-fit,minmax(120px,1fr));
}
.\\[grid-template-columns\\:repeat\\(auto-fit\\2c minmax\\(136px\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(auto-fit,minmax(136px,1fr));
}
.\\[grid-template-columns\\:repeat\\(auto-fit\\2c minmax\\(min\\(104px\\2c 100\\%\\)\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(auto-fit,minmax(min(104px,100%),1fr));
}
.\\[grid-template-columns\\:repeat\\(auto-fit\\2c minmax\\(min\\(150px\\2c 100\\%\\)\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(auto-fit,minmax(min(150px,100%),1fr));
}
.\\[grid-template-columns\\:repeat\\(auto-fit\\2c minmax\\(min\\(220px\\2c 100\\%\\)\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(auto-fit,minmax(min(220px,100%),1fr));
}
.\\[grid-template-columns\\:repeat\\(auto-fit\\2c minmax\\(min\\(240px\\2c 100\\%\\)\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(auto-fit,minmax(min(240px,100%),1fr));
}
.\\[overflow-wrap\\:anywhere\\] {
  overflow-wrap: anywhere;
}
.\\[overflow\\:clip\\] {
  overflow: clip;
}
.\\[scrollbar-color\\:hsl\\(var\\(--muted-foreground\\)\\/0\\.55\\)_hsl\\(var\\(--muted\\)\\/0\\.35\\)\\] {
  scrollbar-color: hsl(var(--muted-foreground)/0.55) hsl(var(--muted)/0.35);
}
.\\[scrollbar-width\\:none\\] {
  scrollbar-width: none;
}
.\\[scrollbar-width\\:thin\\] {
  scrollbar-width: thin;
}

/* Shimmer sweep — used on the currently-executing step row in ExecutionFeed */
@keyframes shimmer {
  0%   { transform: translateX(-100%); }
  100% { transform: translateX(200%); }
}

/* Text-shimmer for an agent warm-up caption — a gradient sweeps across the glyphs so the line reads
   as part of the loading skeleton rather than a separate static label below it.
   \`.ma-weave-shimmer\` is Weave's original name, kept so its markup is untouched; \`.shimmer-text\` is
   the neutral alias every other module (Testing) uses, so there is one implementation. */
@keyframes ma-weave-shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
.ma-weave-shimmer,
.shimmer-text {
  background: linear-gradient(
    90deg,
    hsl(var(--muted-foreground)) 0%,
    hsl(var(--primary)) 50%,
    hsl(var(--muted-foreground)) 100%
  );
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: ma-weave-shimmer 2.6s linear infinite;
}

@media (prefers-reduced-motion: reduce) {
  .ma-weave-shimmer,
  .shimmer-text {
    animation: none;
    background: none;
    -webkit-background-clip: initial;
    background-clip: initial;
    color: hsl(var(--muted-foreground));
  }
}

/* Salesforce AI IDE Design System - Clean and Professional */

.poweredBy {
  display: none !important;
  visibility: hidden !important;
}

/* ─────────────────────────────────────────────────────────────────────────
   rs-theme: opt-in Templates.html design wrapper.
   Wrap a route subtree with class="rs-theme" (or via <PaperTheme>) to remap
   the standard CSS tokens to the --rs-* palette. Components using
   bg-card / text-foreground / border / etc. inherit the cream-paper look
   automatically — no per-component edits.
   Works in both light and dark because --rs-* themselves are split by mode.
   ─────────────────────────────────────────────────────────────────────────*/
.rs-theme {
  --background: var(--rs-paper);
  --foreground: var(--rs-ink);

  --card: var(--rs-card);
  --card-foreground: var(--rs-ink);
  --card-elevated: var(--rs-card);

  --popover: var(--rs-card);
  --popover-foreground: var(--rs-ink);

  --muted: var(--rs-paper-edge);
  --muted-foreground: var(--rs-ink-mute);

  --secondary: var(--rs-paper-edge);
  --secondary-foreground: var(--rs-ink);

  --border: var(--rs-card-edge);
  --input: var(--rs-card-edge);
  --ring: var(--rs-warm);

  --primary: var(--rs-warm);
  --primary-foreground: 0 0% 100%;
  --primary-glow: var(--rs-warm);

  /* Semantic status colors stay native — destructive must read as red on
     ANY page, success as green, warning as amber. Only the brand surfaces
     shift to the warm palette. */

  --accent: var(--rs-plum);
  --accent-foreground: 0 0% 100%;
  --accent-warm: var(--rs-warm);
  --accent-warm-foreground: 0 0% 100%;
  --accent-warm-soft: var(--rs-warm-soft);

  /* Sidebar — slightly warmer surface to separate from the main paper */
  --sidebar-background: var(--rs-paper-edge);
  --sidebar-foreground: var(--rs-ink);
  --sidebar-primary: var(--rs-warm);
  --sidebar-primary-foreground: 0 0% 100%;
  --sidebar-accent: var(--rs-warm-soft);
  --sidebar-accent-foreground: var(--rs-ink);
  --sidebar-border: var(--rs-card-edge);
  --sidebar-ring: var(--rs-warm);
}

.rs-theme h1,
.rs-theme h2,
.rs-theme h3,
.rs-theme h4 {
  font-family: "Space Grotesk", Inter, ui-sans-serif, system-ui, sans-serif;
  letter-spacing: 0;
}

.studio-shell.rs-theme {
  --background: 220 22% 97%;
  --foreground: 225 20% 10%;
  --card: 0 0% 100%;
  --card-foreground: 225 20% 10%;
  --card-elevated: 220 19% 94%;
  --popover: 0 0% 100%;
  --popover-foreground: 225 20% 10%;
  --muted: 220 18% 92%;
  --muted-foreground: 220 10% 39%;
  --secondary: 220 18% 92%;
  --secondary-foreground: 225 20% 10%;
  --border: 220 14% 81%;
  --input: 220 14% 81%;
  --ring: 224 17% 24%;
  --primary: 224 17% 24%;
  --primary-foreground: 0 0% 100%;
  --primary-glow: 224 14% 36%;
  --accent: 35 84% 54%;
  --accent-foreground: 225 20% 10%;
  --accent-warm: 35 84% 54%;
  --accent-warm-foreground: 225 20% 10%;
  --accent-warm-soft: 35 86% 91%;
  --studio-line: 220 14% 81%;
  --studio-line-strong: 224 17% 24%;
  height: 100vh;
  width: 100%;
  overflow: clip;
  background:
    linear-gradient(145deg, hsl(var(--primary) / 0.07), transparent 34%),
    linear-gradient(315deg, hsl(var(--accent) / 0.055), transparent 38%),
    hsl(var(--background));
  color: hsl(var(--foreground));
  font-family: Inter, ui-sans-serif, system-ui, sans-serif;
}

.dark .studio-shell.rs-theme {
  --background: 228 22% 6%;
  --foreground: 210 35% 94%;
  --card: 226 20% 10%;
  --card-foreground: 210 35% 94%;
  --card-elevated: 226 18% 13%;
  --popover: 226 20% 10%;
  --popover-foreground: 210 35% 94%;
  --muted: 226 17% 15%;
  --muted-foreground: 213 15% 69%;
  --secondary: 226 17% 15%;
  --secondary-foreground: 210 35% 94%;
  --border: 221 16% 24%;
  --input: 221 16% 24%;
  --ring: 220 24% 72%;
  --primary: 220 24% 72%;
  --primary-foreground: 228 22% 6%;
  --primary-glow: 220 30% 80%;
  --accent: 224 14% 22%;
  --accent-foreground: 210 35% 94%;
  --accent-warm: 31 82% 66%;
  --accent-warm-foreground: 228 22% 6%;
  --accent-warm-soft: 30 32% 14%;
  --studio-line: 220 16% 24%;
  --studio-line-strong: 220 24% 72%;
}

.studio-sidebar {
  position: sticky;
  top: 0;
  height: 100vh;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-right: 1px solid hsl(var(--border));
  background:
    linear-gradient(180deg, hsl(var(--card) / 0.92), hsl(var(--muted) / 0.64)),
    linear-gradient(90deg, hsl(var(--primary) / 0.08), transparent 52%);
  padding: 20px 14px;
}

.studio-sidebar::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    linear-gradient(180deg, hsl(var(--primary) / 0.16), transparent 34%),
    linear-gradient(90deg, transparent calc(100% - 1px), hsl(var(--primary) / 0.34) calc(100% - 1px));
}

.studio-sidebar > * {
  position: relative;
}

/* Override bg-sidebar solid color with the branded gradient for @ncoder/ui Sidebar */
.studio-shell [data-sidebar="sidebar"] {
  background:
    linear-gradient(180deg, hsl(var(--card) / 0.92), hsl(var(--muted) / 0.64)),
    linear-gradient(90deg, hsl(var(--primary) / 0.08), transparent 52%);
}

.studio-shell [data-sidebar="sidebar"]::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    linear-gradient(180deg, hsl(var(--primary) / 0.16), transparent 34%),
    linear-gradient(90deg, transparent calc(100% - 1px), hsl(var(--primary) / 0.34) calc(100% - 1px));
}

.dark .studio-shell [data-sidebar="sidebar"] {
  background:
    linear-gradient(180deg, hsl(var(--card) / 0.96), hsl(var(--background) / 0.94)),
    linear-gradient(90deg, hsl(var(--primary) / 0.14), transparent 58%);
}

.dark .studio-sidebar {
  background:
    linear-gradient(180deg, hsl(var(--card) / 0.96), hsl(var(--background) / 0.94)),
    linear-gradient(90deg, hsl(var(--primary) / 0.14), transparent 58%);
}

.studio-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  padding: 6px 8px;
  border-radius: 8px;
  color: hsl(var(--foreground));
  font-size: 18px;
  font-weight: 800;
  font-family: "Space Grotesk", Inter, ui-sans-serif, system-ui, sans-serif;
  text-decoration: none;
  letter-spacing: 0;
}

.studio-brand > span:last-child {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.studio-brand-mark {
  display: grid;
  place-items: center;
  width: 26px;
  height: 26px;
  border-radius: 8px;
  background:
    linear-gradient(135deg, hsl(var(--primary)), hsl(var(--accent)));
  color: hsl(var(--primary-foreground));
  font-family: "JetBrains Mono", ui-monospace, monospace;
  font-size: 14px;
}

/* Collapsed sidebar: brand — icon only, centered */
[data-collapsible="icon"] .studio-brand {
  justify-content: center;
  padding: 6px 0;
  gap: 0;
}

[data-collapsible="icon"] .studio-brand > span:last-child {
  display: none;
}

/* Collapsed sidebar: org dropdown — pop out to the right of the rail */
[data-collapsible="icon"] .studio-org-menu {
  left: calc(100% + 8px);
  right: auto;
  top: 0;
  min-width: 220px;
}

/* Collapsed sidebar: org card — badge only, centered */
[data-collapsible="icon"] .studio-org-card {
  justify-content: center;
  padding: 8px;
  border: none;
  background: transparent;
  box-shadow: none;
  transform: none;
}

[data-collapsible="icon"] .studio-org-card:hover {
  background: hsl(var(--muted) / 0.68);
  transform: none;
}

[data-collapsible="icon"] .studio-org-card > *:not(:first-child) {
  display: none;
  width: 0;
  overflow: hidden;
}

.studio-nav {
  flex: 1;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  scrollbar-color: hsl(var(--muted-foreground) / 0.32) transparent;
  padding: 18px 0;
}

.studio-nav::-webkit-scrollbar {
  width: 10px;
}

.studio-nav::-webkit-scrollbar-track {
  margin: 6px 0;
  background: transparent;
  border-radius: 999px;
}

.studio-nav::-webkit-scrollbar-thumb {
  background: hsl(var(--muted-foreground) / 0.28);
  border: 2px solid transparent;
  background-clip: padding-box;
  border-radius: 999px;
}

.studio-nav::-webkit-scrollbar-thumb:hover {
  background: hsl(var(--muted-foreground) / 0.45);
  border: 2px solid transparent;
  background-clip: padding-box;
}

.studio-nav-group {
  margin-bottom: 24px;
  min-width: 0;
}

.studio-nav-label {
  padding: 0 6px 10px;
  color: hsl(var(--muted-foreground));
  font-family: "JetBrains Mono", ui-monospace, monospace;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.studio-nav-link {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 38px;
  padding: 9px 12px;
  border-radius: 8px;
  box-sizing: border-box;
  color: hsl(var(--foreground) / 0.78);
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  transition: background 140ms ease, color 140ms ease;
}

.studio-nav-link:hover {
  background: hsl(var(--muted) / 0.68);
  color: hsl(var(--foreground));
}

.studio-nav-link svg {
  flex-shrink: 0;
}

.studio-nav-link-active {
  background:
    linear-gradient(90deg, hsl(var(--primary)), color-mix(in oklab, hsl(var(--primary)), hsl(var(--accent)) 28%));
  color: hsl(var(--primary-foreground));
  box-shadow: inset 3px 0 0 hsl(var(--accent));
  padding-right: 26px;
}

.studio-nav-link-active:has(.studio-nav-count) {
  padding-right: 12px;
}

.studio-nav-link-active::after {
  content: "";
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 5px;
  height: 5px;
  border-radius: 999px;
  background: hsl(var(--primary-foreground));
  opacity: 0.78;
  pointer-events: none;
}

.studio-nav-count {
  flex-shrink: 0;
  min-width: 28px;
  border-radius: 5px;
  background: hsl(var(--muted));
  color: hsl(var(--muted-foreground));
  padding: 2px 6px;
  text-align: center;
  font-family: "JetBrains Mono", ui-monospace, monospace;
  font-size: 10px;
}

.studio-nav-link-active .studio-nav-count {
  background: hsl(var(--primary-foreground) / 0.16);
  color: hsl(var(--primary-foreground));
}

/* @ncoder/ui SidebarMenuButton — match studio-nav-link visual style */
.studio-nav [data-sidebar="group-label"] {
  font-family: "JetBrains Mono", ui-monospace, monospace;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: hsl(var(--muted-foreground));
}

.studio-nav [data-sidebar="menu-button"] {
  color: hsl(var(--foreground) / 0.78);
  font-size: 14px;
  font-weight: 500;
  min-height: 38px;
  border-radius: 8px;
  gap: 10px;
  transition: background 140ms ease, color 140ms ease;
}

.studio-nav [data-sidebar="menu-button"]:hover {
  background: hsl(var(--muted) / 0.68);
  color: hsl(var(--foreground));
}

.studio-nav [data-sidebar="menu-button"][data-active="true"] {
  background:
    linear-gradient(90deg, hsl(var(--primary)), color-mix(in oklab, hsl(var(--primary)), hsl(var(--accent)) 28%));
  color: hsl(var(--primary-foreground));
  box-shadow: inset 3px 0 0 hsl(var(--accent));
}

[data-collapsible="icon"] .studio-nav [data-sidebar="menu-button"][data-active="true"] {
  box-shadow: none;
}

[data-collapsible="icon"] .studio-nav {
  overflow-y: auto !important;
}

.studio-org-select {
  position: relative;
  z-index: 60;
  min-width: 0;
}

.studio-org-card {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid hsl(var(--border));
  border-radius: 8px;
  background:
    linear-gradient(135deg, hsl(var(--card) / 0.92), hsl(var(--muted) / 0.7));
  padding: 8px;
  box-shadow: inset 0 1px 0 hsl(var(--foreground) / 0.04);
  color: hsl(var(--foreground));
  cursor: pointer;
  text-align: left;
  transition: border-color 160ms ease, background 160ms ease, transform 160ms ease;
}

.studio-org-card:hover {
  border-color: hsl(var(--foreground) / 0.24);
  background:
    linear-gradient(135deg, hsl(var(--card)), hsl(var(--muted) / 0.9));
  transform: translateY(-1px);
}

.studio-org-menu {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 8px);
  z-index: 80;
  max-height: min(360px, calc(100vh - 180px));
  overflow: auto;
  border: 1px solid hsl(var(--border));
  border-radius: 10px;
  background: hsl(var(--popover));
  box-shadow:
    0 18px 46px hsl(var(--background) / 0.42),
    inset 0 1px 0 hsl(var(--foreground) / 0.05);
  padding: 6px;
}

.studio-org-menu-label {
  padding: 6px 8px 8px;
  color: hsl(var(--muted-foreground));
  font-family: "JetBrains Mono", ui-monospace, monospace;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.studio-org-menu-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: hsl(var(--foreground));
  padding: 8px;
  cursor: pointer;
  text-align: left;
}

.studio-org-menu-item:hover {
  background: hsl(var(--muted));
}

.studio-org-menu-item-active {
  background: hsl(var(--foreground));
  color: hsl(var(--background));
}

.studio-org-menu-item-active:hover {
  background: hsl(var(--foreground));
}

.studio-org-menu-item-active .text-muted-foreground {
  color: hsl(var(--background) / 0.68) !important;
}

.studio-org-menu-mark {
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 7px;
  background: hsl(var(--muted));
  color: hsl(var(--foreground));
  font-size: 10px;
  font-weight: 800;
}

.studio-org-menu-item-active .studio-org-menu-mark {
  background: hsl(var(--background) / 0.16);
  color: hsl(var(--background));
}

.studio-main {
  position: relative;
  flex: 1;
  min-width: 0;
  min-height: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  isolation: isolate;
}

.studio-topbar {
  position: sticky;
  top: 0;
  z-index: 40;
  display: grid;
  grid-template-columns: minmax(180px, 1fr) minmax(280px, 520px) minmax(180px, 1fr);
  align-items: center;
  gap: 18px;
  min-height: 62px;
  border-bottom: 1px solid hsl(var(--border));
  background:
    linear-gradient(90deg, hsl(var(--background) / 0.94), hsl(var(--card) / 0.9)),
    linear-gradient(90deg, hsl(var(--primary) / 0.08), transparent 40%, hsl(var(--accent) / 0.07));
  padding: 0 28px;
  backdrop-filter: blur(12px);
}

@media (max-width: 1280px) {
  .studio-topbar {
    padding: 0 16px;
  }
}

@media (max-width: 768px) {
  .studio-topbar {
    grid-template-columns: 1fr auto;
    padding: 0 12px;
  }

  .studio-topbar--no-search {
    grid-template-columns: 1fr auto;
  }
}

/* Search hidden in StudioLayout — crumbs left, actions right */
.studio-topbar--no-search {
  grid-template-columns: minmax(0, 1fr) auto;
}

.studio-topbar::after {
  content: "";
  position: absolute;
  right: 28px;
  bottom: -1px;
  left: 28px;
  height: 1px;
  background: linear-gradient(90deg, transparent, hsl(var(--primary) / 0.42), hsl(var(--accent) / 0.36), transparent);
}

.studio-crumbs {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
  font-size: 14px;
}

.studio-search {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 34px;
  border: 1px solid hsl(var(--border));
  border-radius: 8px;
  background: hsl(var(--card) / 0.86);
  padding: 0 10px;
  box-shadow: inset 0 1px 0 hsl(var(--foreground) / 0.04);
}

.studio-search:focus-within {
  border-color: hsl(var(--primary) / 0.58);
  box-shadow: 0 0 0 3px hsl(var(--primary) / 0.11);
}

.studio-search input {
  min-width: 0;
  flex: 1;
  border: 0;
  outline: 0;
  background: transparent;
  color: hsl(var(--foreground));
  font-size: 13px;
}

.studio-search kbd {
  border-radius: 5px;
  background: hsl(var(--muted));
  color: hsl(var(--muted-foreground));
  padding: 1px 5px;
  font-family: "JetBrains Mono", ui-monospace, monospace;
  font-size: 10px;
}

.studio-actions {
  display: flex;
  flex-shrink: 0;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}

.studio-icon-button {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border: 1px solid hsl(var(--border));
  border-radius: 8px;
  background: hsl(var(--card) / 0.88);
  color: hsl(var(--foreground));
}

.studio-content {
  flex: 1;
  width: 100%;
  max-width: none;
  min-height: 0;
  margin: 0 auto;
  padding: 14px;
}

.studio-content-full {
  flex: 1;
  max-width: none;
  min-height: 0;
  min-width: 0;
  padding: 0;
}

.studio-hero {
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 24px;
  padding-bottom: 18px;
}

.studio-hero::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 1px;
  background: linear-gradient(90deg, hsl(var(--primary) / 0.32), hsl(var(--accent) / 0.26), transparent 72%);
}

.studio-eyebrow {
  display: flex;
  align-items: center;
  gap: 8px;
  color: hsl(var(--muted-foreground));
  font-family: "JetBrains Mono", ui-monospace, monospace;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}

.studio-eyebrow::before {
  content: "";
  width: 18px;
  height: 2px;
  border-radius: 999px;
  background: linear-gradient(90deg, hsl(var(--primary)), hsl(var(--accent)));
}

.studio-title {
  margin-top: 10px;
  color: hsl(var(--foreground));
  font-family: "Space Grotesk", Inter, ui-sans-serif, system-ui, sans-serif;
  font-size: clamp(32px, 4.2vw, 48px);
  line-height: 1.02;
  font-weight: 700;
  text-wrap: balance;
}

.studio-title em {
  background: linear-gradient(90deg, hsl(var(--primary)), hsl(var(--accent)));
  -webkit-background-clip: text;
          background-clip: text;
  color: transparent;
  font-style: normal;
}

.studio-subtitle {
  margin-top: 10px;
  max-width: 680px;
  color: hsl(var(--muted-foreground));
  font-size: 15px;
  line-height: 1.55;
}

.studio-card {
  position: relative;
  border: 1px solid hsl(var(--border));
  border-radius: 8px;
  background:
    linear-gradient(180deg, hsl(var(--card) / 0.98), hsl(var(--card-elevated) / 0.84));
  box-shadow:
    inset 0 1px 0 hsl(var(--foreground) / 0.04),
    0 1px 1px hsl(var(--foreground) / 0.04);
}

/* .studio-card::before {
  content: "";
  position: absolute;
  inset: 0 0 auto;
  height: 2px;
  background: linear-gradient(90deg, hsl(var(--primary) / 0.64), hsl(var(--accent) / 0.42), transparent);
  opacity: 0.72;
  pointer-events: none;
} */

.studio-card-hover {
  transition: transform 140ms ease, border-color 140ms ease, box-shadow 140ms ease;
}

.studio-card-hover:hover {
  transform: translateY(-1px);
  border-color: hsl(var(--primary) / 0.42);
  box-shadow:
    inset 0 1px 0 hsl(var(--foreground) / 0.05),
    0 12px 28px hsl(var(--primary) / 0.12);
}

/* Legacy route panels still use raw Tailwind bg-card/border boxes. In Studio,
   soften those so old pages blend into the new shell instead of looking like
   stacked square blocks. */
.studio-shell :where(.bg-card.border, .border.bg-card):not(.studio-card):not(.term-window):not(.term-window-flat) {
  border-color: hsl(var(--border) / 0.72) !important;
  background:
    linear-gradient(180deg, hsl(var(--card) / 0.82), hsl(var(--card-elevated) / 0.58)) !important;
  box-shadow:
    inset 0 1px 0 hsl(var(--foreground) / 0.035),
    0 1px 2px hsl(var(--foreground) / 0.035) !important;
}

.studio-shell :where([class*="bg-muted/"][class*="border"], [class*="bg-background/"][class*="border"]) {
  border-color: hsl(var(--border) / 0.62) !important;
  background: hsl(var(--muted) / 0.34) !important;
}

.studio-shell :where(.shadow-sm, .shadow-md):not(.studio-card) {
  box-shadow: 0 1px 2px hsl(var(--foreground) / 0.04) !important;
}

.studio-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 30px;
  border: 1px solid hsl(var(--border));
  border-radius: 999px;
  background: hsl(var(--card));
  padding: 0 12px;
  color: hsl(var(--foreground) / 0.78);
  font-size: 12px;
  font-weight: 500;
}

.studio-pill-active {
  border-color: hsl(var(--foreground));
  background: hsl(var(--foreground));
  color: hsl(var(--background));
}

.studio-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 36px;
  border: 1px solid var(--studio-button-border, hsl(var(--border)));
  border-radius: 8px;
  background: var(--studio-button-bg, hsl(var(--card)));
  color: var(--studio-button-color, hsl(var(--foreground)));
  padding: var(--studio-button-padding, 0 14px);
  font-size: var(--studio-button-font-size, 13px);
  font-weight: 600;
  text-decoration: none;
  box-shadow: var(--studio-button-shadow, none);
  transition: transform 140ms ease, border-color 140ms ease, box-shadow 140ms ease, background 140ms ease, color 140ms ease;
}

.studio-button-sm {
  height: 32px;
  padding: 0 12px;
  font-size: 12px;
}

.studio-button-lg {
  height: 44px;
  padding: 0 20px;
}

.studio-button-xl {
  height: 48px;
  padding: 0 32px;
  font-size: 16px;
}

.studio-button-icon {
  width: 36px;
  height: 36px;
  padding: 0;
}

.studio-button:hover {
  border-color: var(--studio-button-hover-border, hsl(var(--primary) / 0.45));
  background: var(--studio-button-hover-bg, var(--studio-button-bg, hsl(var(--card))));
  color: var(--studio-button-hover-color, var(--studio-button-color, hsl(var(--foreground))));
}

.studio-button-primary {
  --studio-button-border: hsl(var(--primary));
  --studio-button-bg:
    linear-gradient(135deg, hsl(var(--primary)), color-mix(in oklab, hsl(var(--primary)), hsl(var(--accent)) 32%));
  --studio-button-color: hsl(var(--primary-foreground));
  --studio-button-shadow: 0 8px 20px hsl(var(--primary) / 0.18);
}

.studio-button-primary:hover {
  --studio-button-hover-shadow: 0 12px 28px hsl(var(--primary) / 0.24);
}

.studio-button-secondary {
  --studio-button-border: hsl(var(--secondary));
  --studio-button-bg: hsl(var(--secondary));
  --studio-button-color: hsl(var(--secondary-foreground));
  --studio-button-hover-bg: hsl(var(--secondary) / 0.84);
}

.studio-button-destructive {
  --studio-button-border: hsl(var(--destructive));
  --studio-button-bg: hsl(var(--destructive));
  --studio-button-color: hsl(var(--destructive-foreground));
  --studio-button-hover-bg: hsl(var(--destructive) / 0.9);
  --studio-button-hover-border: hsl(var(--destructive));
}

.studio-button-ghost {
  --studio-button-border: transparent;
  --studio-button-bg: transparent;
  --studio-button-shadow: none;
  --studio-button-hover-bg: hsl(var(--muted));
  --studio-button-hover-shadow: none;
}

.studio-button-link {
  height: auto;
  border-color: transparent;
  background: transparent;
  color: hsl(var(--primary));
  padding: 0;
  box-shadow: none;
  text-decoration: none;
  text-underline-offset: 4px;
}

.studio-button-link:hover {
  transform: none;
  border-color: transparent;
  background: transparent;
  color: hsl(var(--primary));
  box-shadow: none;
  text-decoration: underline;
}

.studio-primary-action {
  --studio-button-border: hsl(var(--primary));
  --studio-button-bg:
    linear-gradient(135deg, hsl(var(--primary)), color-mix(in oklab, hsl(var(--primary)), hsl(var(--accent-warm)) 38%));
  --studio-button-color: hsl(var(--primary-foreground));
  --studio-button-shadow: 0 8px 20px hsl(var(--primary) / 0.18);
}

.studio-primary-action:hover {
  --studio-button-hover-border: hsl(var(--primary));
  --studio-button-hover-shadow:
    0 12px 28px hsl(var(--primary) / 0.24),
    0 0 0 4px hsl(var(--primary) / 0.10);
}

.loading-parallax,
.studio-shell :where([class*="animate-pulse"][class*="bg-muted"]) {
  position: relative;
  overflow: hidden;
  isolation: isolate;
  background:
    linear-gradient(135deg, hsl(var(--muted) / 0.72), hsl(var(--muted) / 0.42)) !important;
}

.loading-parallax::before,
.studio-shell :where([class*="animate-pulse"][class*="bg-muted"])::before {
  content: "";
  position: absolute;
  inset: -45% -70%;
  z-index: 1;
  background:
    linear-gradient(110deg, transparent 22%, hsl(var(--background) / 0.48) 46%, hsl(var(--accent-warm) / 0.22) 52%, transparent 70%);
  transform: translateX(-55%) skewX(-12deg);
  animation: loadingParallaxSweep 1.8s cubic-bezier(.22, .61, .36, 1) infinite;
}

.loading-parallax::after,
.studio-shell :where([class*="animate-pulse"][class*="bg-muted"])::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  background:
    radial-gradient(circle at 18% 20%, hsl(var(--primary) / 0.10), transparent 28%),
    radial-gradient(circle at 82% 78%, hsl(var(--accent-warm) / 0.10), transparent 30%);
  animation: loadingParallaxDrift 3.2s ease-in-out infinite alternate;
}

@keyframes loadingParallaxSweep {
  0% { transform: translateX(-58%) skewX(-12deg); }
  100% { transform: translateX(58%) skewX(-12deg); }
}

@keyframes loadingParallaxDrift {
  0% { transform: translate3d(-8px, -4px, 0) scale(1); opacity: .58; }
  100% { transform: translate3d(8px, 5px, 0) scale(1.04); opacity: .9; }
}

.floating-chat-launcher {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 999;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  height: 48px;
  border: 1px solid hsl(var(--border) / 0.78);
  border-radius: 999px;
  background:
    linear-gradient(135deg, hsl(var(--foreground)), hsl(var(--foreground) / 0.88)),
    linear-gradient(135deg, hsl(var(--primary) / 0.2), hsl(var(--accent-warm) / 0.24));
  color: hsl(var(--background));
  padding: 0 12px 0 8px;
  box-shadow:
    0 16px 38px hsl(var(--foreground) / 0.18),
    inset 0 1px 0 hsl(var(--background) / 0.16);
  transition: transform 150ms ease, box-shadow 150ms ease, border-color 150ms ease;
}

.floating-chat-launcher:hover {
  transform: translateY(-2px);
  border-color: hsl(var(--accent-warm) / 0.72);
  box-shadow:
    0 22px 48px hsl(var(--foreground) / 0.22),
    0 0 0 4px hsl(var(--accent-warm) / 0.13),
    inset 0 1px 0 hsl(var(--background) / 0.18);
}

.floating-chat-launcher__mark {
  position: relative;
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 999px;
  background: linear-gradient(135deg, hsl(var(--primary)), hsl(var(--accent-warm)));
  color: hsl(var(--primary-foreground));
}

.floating-chat-launcher__spark {
  position: absolute;
  right: -3px;
  top: -3px;
  width: 11px;
  height: 11px;
  border-radius: 999px;
  color: hsl(var(--accent-warm));
  filter: drop-shadow(0 1px 2px hsl(var(--foreground) / 0.22));
}

.floating-chat-launcher__copy {
  display: grid;
  gap: 1px;
  text-align: left;
  line-height: 1;
}

.floating-chat-launcher__copy span:first-child {
  font-size: 12px;
  font-weight: 700;
}

.floating-chat-launcher__copy span:last-child {
  color: hsl(var(--background) / 0.68);
  font-family: "JetBrains Mono", ui-monospace, monospace;
  font-size: 10px;
  text-transform: uppercase;
}

.floating-chat-launcher__send {
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  background: hsl(var(--background) / 0.14);
  color: currentColor;
  opacity: 0.78;
}

.dark .floating-chat-launcher {
  background:
    linear-gradient(135deg, hsl(226 22% 11% / 0.98), hsl(230 20% 7% / 0.98)),
    linear-gradient(135deg, hsl(var(--primary) / 0.22), hsl(var(--accent-warm) / 0.28));
  color: hsl(var(--foreground));
  box-shadow:
    0 18px 42px hsl(0 0% 0% / 0.42),
    inset 0 1px 0 hsl(var(--foreground) / 0.09);
}

.dark .floating-chat-launcher__copy span:last-child {
  color: hsl(var(--foreground) / 0.58);
}


.metadata-studio-page {
  display: flex;
  flex: 1;
  min-height: 0;
  flex-direction: column;
  gap: 16px;
  background: hsl(var(--background));
  padding: 24px 28px 28px;
}

.metadata-studio-editor {
  flex: 1;
  min-height: max(320px, 40vh);
}

.metadata-studio-editor > div {
  height: 100%;
}

@media (max-width: 960px) {
  .studio-sidebar {
    position: relative;
    height: auto;
    border-right: 0;
    border-bottom: 1px solid hsl(var(--border));
  }

  .studio-nav {
    display: grid;
    grid-template-columns: 1fr;
  }

  .studio-topbar {
    grid-template-columns: 1fr;
    padding: 12px 18px;
  }

  .studio-topbar--no-search {
    grid-template-columns: 1fr;
  }

  .studio-actions {
    justify-content: flex-start;
  }

  .studio-content {
    padding: 24px 18px 40px;
  }

  .studio-title {
    font-size: 32px;
  }

  .studio-hero {
    align-items: flex-start;
    flex-direction: column;
  }

}

/* Indeterminate progress bar animation */
@keyframes progress-indeterminate {
  0% {
    transform: translateX(-100%);
    width: 50%;
  }
  50% {
    transform: translateX(50%);
    width: 30%;
  }
  100% {
    transform: translateX(200%);
    width: 50%;
  }
}

.animate-progress-indeterminate {
  animation: progress-indeterminate 1.5s ease-in-out infinite;
}

.dark\\:prose-invert:is(.dark *) {
  --tw-prose-body: var(--tw-prose-invert-body);
  --tw-prose-headings: var(--tw-prose-invert-headings);
  --tw-prose-lead: var(--tw-prose-invert-lead);
  --tw-prose-links: var(--tw-prose-invert-links);
  --tw-prose-bold: var(--tw-prose-invert-bold);
  --tw-prose-counters: var(--tw-prose-invert-counters);
  --tw-prose-bullets: var(--tw-prose-invert-bullets);
  --tw-prose-hr: var(--tw-prose-invert-hr);
  --tw-prose-quotes: var(--tw-prose-invert-quotes);
  --tw-prose-quote-borders: var(--tw-prose-invert-quote-borders);
  --tw-prose-captions: var(--tw-prose-invert-captions);
  --tw-prose-kbd: var(--tw-prose-invert-kbd);
  --tw-prose-kbd-shadows: var(--tw-prose-invert-kbd-shadows);
  --tw-prose-code: var(--tw-prose-invert-code);
  --tw-prose-pre-code: var(--tw-prose-invert-pre-code);
  --tw-prose-pre-bg: var(--tw-prose-invert-pre-bg);
  --tw-prose-th-borders: var(--tw-prose-invert-th-borders);
  --tw-prose-td-borders: var(--tw-prose-invert-td-borders);
}

.marker\\:text-muted-foreground *::marker {
  color: hsl(var(--muted-foreground));
}

.marker\\:text-muted-foreground::marker {
  color: hsl(var(--muted-foreground));
}

.file\\:border-0::file-selector-button {
  border-width: 0px;
}

.file\\:bg-transparent::file-selector-button {
  background-color: transparent;
}

.file\\:text-sm::file-selector-button {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.file\\:font-medium::file-selector-button {
  font-weight: 500;
}

.file\\:text-foreground::file-selector-button {
  color: hsl(var(--foreground));
}

.placeholder\\:text-muted-foreground::-moz-placeholder {
  color: hsl(var(--muted-foreground));
}

.placeholder\\:text-muted-foreground::placeholder {
  color: hsl(var(--muted-foreground));
}

.placeholder\\:text-muted-foreground\\/40::-moz-placeholder {
  color: hsl(var(--muted-foreground) / 0.4);
}

.placeholder\\:text-muted-foreground\\/40::placeholder {
  color: hsl(var(--muted-foreground) / 0.4);
}

.placeholder\\:text-muted-foreground\\/50::-moz-placeholder {
  color: hsl(var(--muted-foreground) / 0.5);
}

.placeholder\\:text-muted-foreground\\/50::placeholder {
  color: hsl(var(--muted-foreground) / 0.5);
}

.placeholder\\:text-muted-foreground\\/60::-moz-placeholder {
  color: hsl(var(--muted-foreground) / 0.6);
}

.placeholder\\:text-muted-foreground\\/60::placeholder {
  color: hsl(var(--muted-foreground) / 0.6);
}

.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}

.after\\:-inset-2::after {
  content: var(--tw-content);
  inset: -0.5rem;
}

.after\\:inset-y-0::after {
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}

.after\\:left-1\\/2::after {
  content: var(--tw-content);
  left: 50%;
}

.after\\:w-\\[2px\\]::after {
  content: var(--tw-content);
  width: 2px;
}

.first\\:mt-3:first-child {
  margin-top: 0.75rem;
}

.first\\:border-t-0:first-child {
  border-top-width: 0px;
}

.first\\:pl-\\[var\\(--oa-gutter\\)\\]:first-child {
  padding-left: var(--oa-gutter);
}

.last\\:mb-0:last-child {
  margin-bottom: 0px;
}

.last\\:border-0:last-child {
  border-width: 0px;
}

.last\\:border-b-0:last-child {
  border-bottom-width: 0px;
}

.last\\:pb-0:last-child {
  padding-bottom: 0px;
}

.last\\:pr-\\[var\\(--oa-gutter\\)\\]:last-child {
  padding-right: var(--oa-gutter);
}

.odd\\:bg-background:nth-child(odd) {
  background-color: hsl(var(--background));
}

.even\\:bg-muted\\/20:nth-child(even) {
  background-color: hsl(var(--muted) / 0.2);
}

.open\\:basis-full[open] {
  flex-basis: 100%;
}

.focus-within\\:border-\\[color\\:var\\(--ma-send-bg\\)\\]:focus-within {
  border-color: var(--ma-send-bg);
}

.focus-within\\:border-\\[hsl\\(var\\(--primary\\)\\/0\\.55\\)\\]:focus-within {
  border-color: hsl(var(--primary)/0.55);
}

.focus-within\\:border-\\[hsl\\(var\\(--primary\\)\\/0\\.7\\)\\]:focus-within {
  border-color: hsl(var(--primary)/0.7);
}

.focus-within\\:border-primary\\/40:focus-within {
  border-color: hsl(var(--primary) / 0.4);
}

.focus-within\\:bg-muted\\/30:focus-within {
  background-color: hsl(var(--muted) / 0.3);
}

.focus-within\\:bg-transparent:focus-within {
  background-color: transparent;
}

.focus-within\\:ring-1:focus-within {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-within\\:ring-2:focus-within {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-within\\:ring-\\[hsl\\(var\\(--primary\\)\\/0\\.15\\)\\]:focus-within {
  --tw-ring-color: hsl(var(--primary)/0.15);
}

.focus-within\\:ring-\\[hsl\\(var\\(--primary\\)\\/0\\.2\\)\\]:focus-within {
  --tw-ring-color: hsl(var(--primary)/0.2);
}

.focus-within\\:ring-ring:focus-within {
  --tw-ring-color: hsl(var(--ring));
}

.focus-within\\:\\[outline-offset\\:0px\\]:focus-within {
  outline-offset: 0px;
}

.focus-within\\:\\[outline\\:3px_solid_rgba\\(11\\2c 96\\2c 234\\2c 0\\.22\\)\\]:focus-within {
  outline: 3px solid rgba(11,96,234,0.22);
}

.hover\\:-translate-y-1:hover {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:translate-x-1:hover {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes pulse {

  50% {
    opacity: .5;
  }
}

.hover\\:animate-pulse:hover {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.hover\\:border-amber-500\\/30:hover {
  border-color: rgb(245 158 11 / 0.3);
}

.hover\\:border-amber-500\\/50:hover {
  border-color: rgb(245 158 11 / 0.5);
}

.hover\\:border-blue-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}

.hover\\:border-blue-500\\/40:hover {
  border-color: rgb(59 130 246 / 0.4);
}

.hover\\:border-blue-500\\/50:hover {
  border-color: rgb(59 130 246 / 0.5);
}

.hover\\:border-blue-500\\/60:hover {
  border-color: rgb(59 130 246 / 0.6);
}

.hover\\:border-border:hover {
  border-color: hsl(var(--border));
}

.hover\\:border-border\\/30:hover {
  border-color: hsl(var(--border) / 0.3);
}

.hover\\:border-border\\/60:hover {
  border-color: hsl(var(--border) / 0.6);
}

.hover\\:border-border\\/80:hover {
  border-color: hsl(var(--border) / 0.8);
}

.hover\\:border-cyan-500\\/50:hover {
  border-color: rgb(6 182 212 / 0.5);
}

.hover\\:border-destructive\\/50:hover {
  border-color: hsl(var(--destructive) / 0.5);
}

.hover\\:border-emerald-500\\/30:hover {
  border-color: rgb(16 185 129 / 0.3);
}

.hover\\:border-emerald-500\\/50:hover {
  border-color: rgb(16 185 129 / 0.5);
}

.hover\\:border-foreground\\/25:hover {
  border-color: hsl(var(--foreground) / 0.25);
}

.hover\\:border-foreground\\/30:hover {
  border-color: hsl(var(--foreground) / 0.3);
}

.hover\\:border-foreground\\/35:hover {
  border-color: hsl(var(--foreground) / 0.35);
}

.hover\\:border-gray-500\\/50:hover {
  border-color: rgb(107 114 128 / 0.5);
}

.hover\\:border-green-500\\/50:hover {
  border-color: rgb(34 197 94 / 0.5);
}

.hover\\:border-indigo-500\\/50:hover {
  border-color: rgb(99 102 241 / 0.5);
}

.hover\\:border-muted-foreground\\/50:hover {
  border-color: hsl(var(--muted-foreground) / 0.5);
}

.hover\\:border-muted-foreground\\/60:hover {
  border-color: hsl(var(--muted-foreground) / 0.6);
}

.hover\\:border-orange-500\\/50:hover {
  border-color: rgb(249 115 22 / 0.5);
}

.hover\\:border-pink-500\\/50:hover {
  border-color: rgb(236 72 153 / 0.5);
}

.hover\\:border-primary:hover {
  border-color: hsl(var(--primary));
}

.hover\\:border-primary\\/30:hover {
  border-color: hsl(var(--primary) / 0.3);
}

.hover\\:border-primary\\/40:hover {
  border-color: hsl(var(--primary) / 0.4);
}

.hover\\:border-primary\\/50:hover {
  border-color: hsl(var(--primary) / 0.5);
}

.hover\\:border-purple-500\\/50:hover {
  border-color: rgb(168 85 247 / 0.5);
}

.hover\\:border-red-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}

.hover\\:border-red-500\\/20:hover {
  border-color: rgb(239 68 68 / 0.2);
}

.hover\\:border-red-500\\/40:hover {
  border-color: rgb(239 68 68 / 0.4);
}

.hover\\:border-red-500\\/50:hover {
  border-color: rgb(239 68 68 / 0.5);
}

.hover\\:border-rose-500\\/50:hover {
  border-color: rgb(244 63 94 / 0.5);
}

.hover\\:border-sky-500\\/50:hover {
  border-color: rgb(14 165 233 / 0.5);
}

.hover\\:border-teal-500\\/50:hover {
  border-color: rgb(20 184 166 / 0.5);
}

.hover\\:border-violet-500\\/50:hover {
  border-color: rgb(139 92 246 / 0.5);
}

.hover\\:border-yellow-500\\/50:hover {
  border-color: rgb(234 179 8 / 0.5);
}

.hover\\:bg-\\[hsl\\(var\\(--muted\\)\\/0\\.6\\)\\]:hover {
  background-color: hsl(var(--muted)/0.6);
}

.hover\\:bg-accent:hover {
  background-color: hsl(var(--accent));
}

.hover\\:bg-accent\\/50:hover {
  background-color: hsl(var(--accent) / 0.5);
}

.hover\\:bg-amber-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-amber-300\\/90:hover {
  background-color: rgb(252 211 77 / 0.9);
}

.hover\\:bg-amber-500\\/15:hover {
  background-color: rgb(245 158 11 / 0.15);
}

.hover\\:bg-amber-500\\/20:hover {
  background-color: rgb(245 158 11 / 0.2);
}

.hover\\:bg-amber-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-background:hover {
  background-color: hsl(var(--background));
}

.hover\\:bg-background\\/60:hover {
  background-color: hsl(var(--background) / 0.6);
}

.hover\\:bg-blue-50\\/40:hover {
  background-color: rgb(239 246 255 / 0.4);
}

.hover\\:bg-blue-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-500\\/10:hover {
  background-color: rgb(59 130 246 / 0.1);
}

.hover\\:bg-blue-500\\/20:hover {
  background-color: rgb(59 130 246 / 0.2);
}

.hover\\:bg-blue-500\\/25:hover {
  background-color: rgb(59 130 246 / 0.25);
}

.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-card:hover {
  background-color: hsl(var(--card));
}

.hover\\:bg-card\\/80:hover {
  background-color: hsl(var(--card) / 0.8);
}

.hover\\:bg-charcoal\\/90:hover {
  background-color: hsl(var(--charcoal) / 0.9);
}

.hover\\:bg-cyan-500\\/20:hover {
  background-color: rgb(6 182 212 / 0.2);
}

.hover\\:bg-destructive-strong\\/90:hover {
  background-color: hsl(var(--destructive-strong) / 0.9);
}

.hover\\:bg-destructive\\/10:hover {
  background-color: hsl(var(--destructive) / 0.1);
}

.hover\\:bg-destructive\\/20:hover {
  background-color: hsl(var(--destructive) / 0.2);
}

.hover\\:bg-destructive\\/80:hover {
  background-color: hsl(var(--destructive) / 0.8);
}

.hover\\:bg-destructive\\/90:hover {
  background-color: hsl(var(--destructive) / 0.9);
}

.hover\\:bg-emerald-500\\/10:hover {
  background-color: rgb(16 185 129 / 0.1);
}

.hover\\:bg-emerald-500\\/15:hover {
  background-color: rgb(16 185 129 / 0.15);
}

.hover\\:bg-emerald-500\\/20:hover {
  background-color: rgb(16 185 129 / 0.2);
}

.hover\\:bg-emerald-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-file-explorer-hover:hover {
  background-color: hsl(var(--file-explorer-hover));
}

.hover\\:bg-gray-500\\/20:hover {
  background-color: rgb(107 114 128 / 0.2);
}

.hover\\:bg-green-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-500\\/20:hover {
  background-color: rgb(34 197 94 / 0.2);
}

.hover\\:bg-green-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-500\\/10:hover {
  background-color: rgb(99 102 241 / 0.1);
}

.hover\\:bg-indigo-500\\/20:hover {
  background-color: rgb(99 102 241 / 0.2);
}

.hover\\:bg-inherit:hover {
  background-color: inherit;
}

.hover\\:bg-ma-err-soft:hover {
  background-color: var(--ma-state-err-soft);
}

.hover\\:bg-ma-info-soft:hover {
  background-color: var(--ma-state-info-soft);
}

.hover\\:bg-ma-ok-soft:hover {
  background-color: var(--ma-state-ok-soft);
}

.hover\\:bg-ma-warn-soft:hover {
  background-color: var(--ma-state-warn-soft);
}

.hover\\:bg-muted:hover {
  background-color: hsl(var(--muted));
}

.hover\\:bg-muted\\/20:hover {
  background-color: hsl(var(--muted) / 0.2);
}

.hover\\:bg-muted\\/25:hover {
  background-color: hsl(var(--muted) / 0.25);
}

.hover\\:bg-muted\\/30:hover {
  background-color: hsl(var(--muted) / 0.3);
}

.hover\\:bg-muted\\/40:hover {
  background-color: hsl(var(--muted) / 0.4);
}

.hover\\:bg-muted\\/50:hover {
  background-color: hsl(var(--muted) / 0.5);
}

.hover\\:bg-muted\\/60:hover {
  background-color: hsl(var(--muted) / 0.6);
}

.hover\\:bg-muted\\/65:hover {
  background-color: hsl(var(--muted) / 0.65);
}

.hover\\:bg-muted\\/70:hover {
  background-color: hsl(var(--muted) / 0.7);
}

.hover\\:bg-muted\\/80:hover {
  background-color: hsl(var(--muted) / 0.8);
}

.hover\\:bg-orange-500\\/20:hover {
  background-color: rgb(249 115 22 / 0.2);
}

.hover\\:bg-pink-500\\/20:hover {
  background-color: rgb(236 72 153 / 0.2);
}

.hover\\:bg-primary:hover {
  background-color: hsl(var(--primary));
}

.hover\\:bg-primary\\/10:hover {
  background-color: hsl(var(--primary) / 0.1);
}

.hover\\:bg-primary\\/15:hover {
  background-color: hsl(var(--primary) / 0.15);
}

.hover\\:bg-primary\\/20:hover {
  background-color: hsl(var(--primary) / 0.2);
}

.hover\\:bg-primary\\/25:hover {
  background-color: hsl(var(--primary) / 0.25);
}

.hover\\:bg-primary\\/5:hover {
  background-color: hsl(var(--primary) / 0.05);
}

.hover\\:bg-primary\\/50:hover {
  background-color: hsl(var(--primary) / 0.5);
}

.hover\\:bg-primary\\/80:hover {
  background-color: hsl(var(--primary) / 0.8);
}

.hover\\:bg-primary\\/90:hover {
  background-color: hsl(var(--primary) / 0.9);
}

.hover\\:bg-purple-500\\/10:hover {
  background-color: rgb(168 85 247 / 0.1);
}

.hover\\:bg-purple-500\\/20:hover {
  background-color: rgb(168 85 247 / 0.2);
}

.hover\\:bg-purple-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(126 34 206 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-500\\/10:hover {
  background-color: rgb(239 68 68 / 0.1);
}

.hover\\:bg-red-500\\/15:hover {
  background-color: rgb(239 68 68 / 0.15);
}

.hover\\:bg-red-500\\/20:hover {
  background-color: rgb(239 68 68 / 0.2);
}

.hover\\:bg-red-500\\/30:hover {
  background-color: rgb(239 68 68 / 0.3);
}

.hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-rose-500\\/10:hover {
  background-color: rgb(244 63 94 / 0.1);
}

.hover\\:bg-rose-500\\/20:hover {
  background-color: rgb(244 63 94 / 0.2);
}

.hover\\:bg-secondary:hover {
  background-color: hsl(var(--secondary));
}

.hover\\:bg-secondary\\/80:hover {
  background-color: hsl(var(--secondary) / 0.8);
}

.hover\\:bg-sidebar-accent:hover {
  background-color: hsl(var(--sidebar-accent));
}

.hover\\:bg-sidebar-accent\\/50:hover {
  background-color: hsl(var(--sidebar-accent) / 0.5);
}

.hover\\:bg-sky-500\\/20:hover {
  background-color: rgb(14 165 233 / 0.2);
}

.hover\\:bg-success\\/10:hover {
  background-color: hsl(var(--success) / 0.1);
}

.hover\\:bg-success\\/15:hover {
  background-color: hsl(var(--success) / 0.15);
}

.hover\\:bg-teal-500\\/20:hover {
  background-color: rgb(20 184 166 / 0.2);
}

.hover\\:bg-transparent:hover {
  background-color: transparent;
}

.hover\\:bg-violet-500\\/20:hover {
  background-color: rgb(139 92 246 / 0.2);
}

.hover\\:bg-warning-strong\\/90:hover {
  background-color: hsl(var(--warning-strong) / 0.9);
}

.hover\\:bg-warning\\/10:hover {
  background-color: hsl(var(--warning) / 0.1);
}

.hover\\:bg-white\\/10:hover {
  background-color: rgb(255 255 255 / 0.1);
}

.hover\\:bg-white\\/20:hover {
  background-color: rgb(255 255 255 / 0.2);
}

.hover\\:bg-yellow-500\\/20:hover {
  background-color: rgb(234 179 8 / 0.2);
}

.hover\\:from-blue-500:hover {
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-blue-700:hover {
  --tw-gradient-from: #1d4ed8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(29 78 216 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-emerald-600:hover {
  --tw-gradient-from: #059669 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(5 150 105 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-violet-600:hover {
  --tw-gradient-from: #7c3aed var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(124 58 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:via-blue-400:hover {
  --tw-gradient-to: rgb(96 165 250 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #60a5fa var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.hover\\:to-purple-700:hover {
  --tw-gradient-to: #7e22ce var(--tw-gradient-to-position);
}

.hover\\:to-teal-400:hover {
  --tw-gradient-to: #2dd4bf var(--tw-gradient-to-position);
}

.hover\\:to-teal-700:hover {
  --tw-gradient-to: #0f766e var(--tw-gradient-to-position);
}

.hover\\:text-\\[hsl\\(var\\(--accent-warm\\)\\)\\]:hover {
  color: hsl(var(--accent-warm));
}

.hover\\:text-accent-foreground:hover {
  color: hsl(var(--accent-foreground));
}

.hover\\:text-amber-500:hover {
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-300:hover {
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-800:hover {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}

.hover\\:text-destructive:hover {
  color: hsl(var(--destructive));
}

.hover\\:text-destructive-strong:hover {
  color: hsl(var(--destructive-strong));
}

.hover\\:text-emerald-300:hover {
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}

.hover\\:text-emerald-400:hover {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}

.hover\\:text-emerald-500:hover {
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}

.hover\\:text-file-explorer-hover-foreground:hover {
  color: hsl(var(--file-explorer-hover-foreground));
}

.hover\\:text-foreground:hover {
  color: hsl(var(--foreground));
}

.hover\\:text-foreground\\/90:hover {
  color: hsl(var(--foreground) / 0.9);
}

.hover\\:text-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.hover\\:text-green-300:hover {
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity, 1));
}

.hover\\:text-green-400:hover {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}

.hover\\:text-indigo-300:hover {
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}

.hover\\:text-indigo-400:hover {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}

.hover\\:text-ma-err-text:hover {
  color: var(--ma-state-err-text);
}

.hover\\:text-muted-foreground:hover {
  color: hsl(var(--muted-foreground));
}

.hover\\:text-primary:hover {
  color: hsl(var(--primary));
}

.hover\\:text-primary-foreground:hover {
  color: hsl(var(--primary-foreground));
}

.hover\\:text-purple-300:hover {
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-300:hover {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-400:hover {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-500:hover {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}

.hover\\:text-rose-300:hover {
  --tw-text-opacity: 1;
  color: rgb(253 164 175 / var(--tw-text-opacity, 1));
}

.hover\\:text-rose-400:hover {
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}

.hover\\:text-sidebar-accent-foreground:hover {
  color: hsl(var(--sidebar-accent-foreground));
}

.hover\\:text-slate-300:hover {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}

.hover\\:text-success-strong:hover {
  color: hsl(var(--success-strong));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:no-underline:hover {
  text-decoration-line: none;
}

.hover\\:opacity-100:hover {
  opacity: 1;
}

.hover\\:opacity-80:hover {
  opacity: 0.8;
}

.hover\\:opacity-90:hover {
  opacity: 0.9;
}

.hover\\:shadow:hover {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_0_0_1px_hsl\\(var\\(--sidebar-accent\\)\\)\\]:hover {
  --tw-shadow: 0 0 0 1px hsl(var(--sidebar-accent));
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_0_8px_rgba\\(59\\2c 130\\2c 246\\2c 0\\.15\\)\\]:hover {
  --tw-shadow: 0 0 8px rgba(59,130,246,0.15);
  --tw-shadow-colored: 0 0 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_12px_40px_rgba\\(59\\2c 130\\2c 246\\2c 0\\.6\\)\\]:hover {
  --tw-shadow: 0 12px 40px rgba(59,130,246,0.6);
  --tw-shadow-colored: 0 12px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-xl:hover {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:ring-primary\\/45:hover {
  --tw-ring-color: hsl(var(--primary) / 0.45);
}

.hover\\:brightness-110:hover {
  --tw-brightness: brightness(1.1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.hover\\:after\\:bg-sidebar-border:hover::after {
  content: var(--tw-content);
  background-color: hsl(var(--sidebar-border));
}

.focus\\:border-destructive\\/60:focus {
  border-color: hsl(var(--destructive) / 0.6);
}

.focus\\:border-primary:focus {
  border-color: hsl(var(--primary));
}

.focus\\:border-primary\\/60:focus {
  border-color: hsl(var(--primary) / 0.6);
}

.focus\\:border-transparent:focus {
  border-color: transparent;
}

.focus\\:bg-accent:focus {
  background-color: hsl(var(--accent));
}

.focus\\:bg-background:focus {
  background-color: hsl(var(--background));
}

.focus\\:text-accent-foreground:focus {
  color: hsl(var(--accent-foreground));
}

.focus\\:opacity-100:focus {
  opacity: 1;
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-\\[hsl\\(var\\(--primary\\)\\)\\]:focus {
  --tw-ring-color: hsl(var(--primary));
}

.focus\\:ring-\\[hsl\\(var\\(--primary\\)\\/0\\.4\\)\\]:focus {
  --tw-ring-color: hsl(var(--primary)/0.4);
}

.focus\\:ring-destructive:focus {
  --tw-ring-color: hsl(var(--destructive));
}

.focus\\:ring-destructive\\/20:focus {
  --tw-ring-color: hsl(var(--destructive) / 0.2);
}

.focus\\:ring-primary:focus {
  --tw-ring-color: hsl(var(--primary));
}

.focus\\:ring-primary\\/20:focus {
  --tw-ring-color: hsl(var(--primary) / 0.2);
}

.focus\\:ring-primary\\/50:focus {
  --tw-ring-color: hsl(var(--primary) / 0.5);
}

.focus\\:ring-ring:focus {
  --tw-ring-color: hsl(var(--ring));
}

.focus\\:ring-white\\/50:focus {
  --tw-ring-color: rgb(255 255 255 / 0.5);
}

.focus\\:ring-offset-1:focus {
  --tw-ring-offset-width: 1px;
}

.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:border-primary\\/50:focus-visible {
  border-color: hsl(var(--primary) / 0.5);
}

.focus-visible\\:border-ring:focus-visible {
  border-color: hsl(var(--ring));
}

.focus-visible\\:opacity-100:focus-visible {
  opacity: 1;
}

.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:outline:focus-visible {
  outline-style: solid;
}

.focus-visible\\:outline-2:focus-visible {
  outline-width: 2px;
}

.focus-visible\\:outline-offset-2:focus-visible {
  outline-offset: 2px;
}

.focus-visible\\:outline-blue-600:focus-visible {
  outline-color: #2563eb;
}

.focus-visible\\:ring-0:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-1:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-inset:focus-visible {
  --tw-ring-inset: inset;
}

.focus-visible\\:ring-primary:focus-visible {
  --tw-ring-color: hsl(var(--primary));
}

.focus-visible\\:ring-ring:focus-visible {
  --tw-ring-color: hsl(var(--ring));
}

.focus-visible\\:ring-ring\\/50:focus-visible {
  --tw-ring-color: hsl(var(--ring) / 0.5);
}

.focus-visible\\:ring-ring\\/60:focus-visible {
  --tw-ring-color: hsl(var(--ring) / 0.6);
}

.focus-visible\\:ring-sidebar-ring:focus-visible {
  --tw-ring-color: hsl(var(--sidebar-ring));
}

.focus-visible\\:ring-offset-1:focus-visible {
  --tw-ring-offset-width: 1px;
}

.focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:ring-offset-background:focus-visible {
  --tw-ring-offset-color: hsl(var(--background));
}

.active\\:scale-\\[0\\.98\\]:active {
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-\\[0\\.995\\]:active {
  --tw-scale-x: 0.995;
  --tw-scale-y: 0.995;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:cursor-grabbing:active {
  cursor: grabbing;
}

.active\\:bg-accent:active {
  background-color: hsl(var(--accent));
}

.active\\:bg-sidebar-accent:active {
  background-color: hsl(var(--sidebar-accent));
}

.active\\:text-sidebar-accent-foreground:active {
  color: hsl(var(--sidebar-accent-foreground));
}

.active\\:shadow-md:active {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.enabled\\:hover\\:bg-amber-500\\/15:hover:enabled {
  background-color: rgb(245 158 11 / 0.15);
}

.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}

.disabled\\:cursor-default:disabled {
  cursor: default;
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:bg-muted:disabled {
  background-color: hsl(var(--muted));
}

.disabled\\:text-muted-foreground:disabled {
  color: hsl(var(--muted-foreground));
}

.disabled\\:no-underline:disabled {
  text-decoration-line: none;
}

.disabled\\:opacity-100:disabled {
  opacity: 1;
}

.disabled\\:opacity-30:disabled {
  opacity: 0.3;
}

.disabled\\:opacity-40:disabled {
  opacity: 0.4;
}

.disabled\\:opacity-45:disabled {
  opacity: 0.45;
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}

.disabled\\:opacity-70:disabled {
  opacity: 0.7;
}

.disabled\\:shadow-none:disabled {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.disabled\\:hover\\:bg-transparent:hover:disabled {
  background-color: transparent;
}

.disabled\\:hover\\:brightness-100:hover:disabled {
  --tw-brightness: brightness(1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.group[open] .group-open\\:inline {
  display: inline;
}

.group[open] .group-open\\:hidden {
  display: none;
}

.group[open] .group-open\\:rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group\\/menu-item:focus-within .group-focus-within\\/menu-item\\:opacity-100 {
  opacity: 1;
}

.group:hover .group-hover\\:visible {
  visibility: visible;
}

.group:hover .group-hover\\:translate-y-0\\.5 {
  --tw-translate-y: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:bg-background {
  background-color: hsl(var(--background));
}

.group:hover .group-hover\\:bg-muted\\/20 {
  background-color: hsl(var(--muted) / 0.2);
}

.group:hover .group-hover\\:bg-primary\\/10 {
  background-color: hsl(var(--primary) / 0.1);
}

.group:hover .group-hover\\:bg-primary\\/60 {
  background-color: hsl(var(--primary) / 0.6);
}

.group:hover .group-hover\\:text-foreground {
  color: hsl(var(--foreground));
}

.group:hover .group-hover\\:text-primary {
  color: hsl(var(--primary));
}

.group:hover .group-hover\\:underline {
  text-decoration-line: underline;
}

.group\\/menu-item:hover .group-hover\\/menu-item\\:opacity-100 {
  opacity: 1;
}

.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}

.group:focus-visible .group-focus-visible\\:bg-primary {
  background-color: hsl(var(--primary));
}

.group:focus-visible .group-focus-visible\\:opacity-100 {
  opacity: 1;
}

.group:active .group-active\\:bg-primary {
  background-color: hsl(var(--primary));
}

.peer\\/menu-button:hover ~ .peer-hover\\/menu-button\\:text-sidebar-accent-foreground {
  color: hsl(var(--sidebar-accent-foreground));
}

.peer:disabled ~ .peer-disabled\\:cursor-not-allowed {
  cursor: not-allowed;
}

.peer:disabled ~ .peer-disabled\\:opacity-70 {
  opacity: 0.7;
}

.has-\\[\\[data-variant\\=inset\\]\\]\\:bg-sidebar:has([data-variant=inset]) {
  background-color: hsl(var(--sidebar-background));
}

.group\\/menu-item:has([data-sidebar=menu-action]) .group-has-\\[\\[data-sidebar\\=menu-action\\]\\]\\/menu-item\\:pr-8 {
  padding-right: 2rem;
}

.aria-disabled\\:pointer-events-none[aria-disabled="true"] {
  pointer-events: none;
}

.aria-disabled\\:opacity-50[aria-disabled="true"] {
  opacity: 0.5;
}

.aria-pressed\\:bg-primary\\/10[aria-pressed="true"] {
  background-color: hsl(var(--primary) / 0.1);
}

.aria-pressed\\:text-foreground[aria-pressed="true"] {
  color: hsl(var(--foreground));
}

.aria-\\[invalid\\=true\\]\\:border-destructive[aria-invalid="true"] {
  border-color: hsl(var(--destructive));
}

.aria-\\[invalid\\=true\\]\\:focus-visible\\:ring-destructive:focus-visible[aria-invalid="true"] {
  --tw-ring-color: hsl(var(--destructive));
}

.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"] {
  pointer-events: none;
}

.data-\\[disabled\\]\\:pointer-events-none[data-disabled] {
  pointer-events: none;
}

.data-\\[state\\=inactive\\]\\:hidden[data-state="inactive"] {
  display: none;
}

.data-\\[state\\=checked\\]\\:translate-x-4[data-state="checked"] {
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"] {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"] {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=end\\]\\:translate-x-\\[100\\%\\][data-swipe="end"] {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"] {
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=start\\]\\:translate-x-0[data-swipe="start"] {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=checked\\]\\:border-primary[data-state="checked"] {
  border-color: hsl(var(--primary));
}

.data-\\[active\\=true\\]\\:bg-sidebar-accent[data-active="true"] {
  background-color: hsl(var(--sidebar-accent));
}

.data-\\[selected\\=true\\]\\:bg-accent[data-selected="true"] {
  background-color: hsl(var(--accent));
}

.data-\\[state\\=active\\]\\:bg-background[data-state="active"] {
  background-color: hsl(var(--background));
}

.data-\\[state\\=active\\]\\:bg-transparent[data-state="active"] {
  background-color: transparent;
}

.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"] {
  background-color: hsl(var(--primary));
}

.data-\\[state\\=open\\]\\:bg-accent[data-state="open"] {
  background-color: hsl(var(--accent));
}

.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"] {
  background-color: hsl(var(--secondary));
}

.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"] {
  background-color: hsl(var(--muted));
}

.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"] {
  background-color: hsl(var(--input));
}

.data-\\[active\\=true\\]\\:font-medium[data-active="true"] {
  font-weight: 500;
}

.data-\\[active\\=true\\]\\:text-sidebar-accent-foreground[data-active="true"] {
  color: hsl(var(--sidebar-accent-foreground));
}

.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"] {
  color: hsl(var(--accent-foreground));
}

.data-\\[state\\=active\\]\\:text-foreground[data-state="active"] {
  color: hsl(var(--foreground));
}

.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"] {
  color: hsl(var(--primary-foreground));
}

.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"] {
  color: hsl(var(--muted-foreground));
}

.data-\\[state\\=open\\]\\:text-sidebar-foreground[data-state="open"] {
  color: hsl(var(--sidebar-foreground));
}

.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"] {
  opacity: 0.5;
}

.data-\\[disabled\\]\\:opacity-50[data-disabled] {
  opacity: 0.5;
}

.data-\\[state\\=open\\]\\:opacity-100[data-state="open"] {
  opacity: 1;
}

.data-\\[state\\=active\\]\\:shadow-none[data-state="active"] {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\\[state\\=active\\]\\:shadow-sm[data-state="active"] {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\\[state\\=closed\\]\\:duration-200[data-state="closed"] {
  transition-duration: 200ms;
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"] {
  transition-duration: 300ms;
}

.data-\\[state\\=open\\]\\:duration-300[data-state="open"] {
  transition-duration: 300ms;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"] {
  transition-duration: 500ms;
}

.data-\\[state\\=closed\\]\\:ease-in[data-state="closed"] {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}

.data-\\[state\\=open\\]\\:ease-out[data-state="open"] {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.data-\\[state\\=open\\]\\:animate-in[data-state="open"] {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"] {
  --tw-exit-opacity: 0;
}

.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"] {
  --tw-exit-opacity: 0.8;
}

.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"] {
  --tw-enter-opacity: 0;
}

.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"] {
  --tw-exit-scale: .95;
}

.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"] {
  --tw-enter-scale: .95;
}

.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"] {
  --tw-enter-translate-y: -0.5rem;
}

.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"] {
  --tw-enter-translate-x: 0.5rem;
}

.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"] {
  --tw-enter-translate-x: -0.5rem;
}

.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"] {
  --tw-enter-translate-y: 0.5rem;
}

.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"] {
  --tw-exit-translate-y: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"] {
  --tw-exit-translate-x: -100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"] {
  --tw-exit-translate-x: -50%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"] {
  --tw-exit-translate-x: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"] {
  --tw-exit-translate-x: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"] {
  --tw-exit-translate-y: -100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"] {
  --tw-exit-translate-y: -48%;
}

.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"] {
  --tw-enter-translate-y: 100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"] {
  --tw-enter-translate-x: -100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"] {
  --tw-enter-translate-x: -50%;
}

.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"] {
  --tw-enter-translate-x: 100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"] {
  --tw-enter-translate-y: -100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-5[data-state="open"] {
  --tw-enter-translate-y: -1.25rem;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"] {
  --tw-enter-translate-y: -48%;
}

.data-\\[state\\=closed\\]\\:duration-200[data-state="closed"] {
  animation-duration: 200ms;
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"] {
  animation-duration: 300ms;
}

.data-\\[state\\=open\\]\\:duration-300[data-state="open"] {
  animation-duration: 300ms;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"] {
  animation-duration: 500ms;
}

.data-\\[state\\=closed\\]\\:ease-in[data-state="closed"] {
  animation-timing-function: cubic-bezier(0.4, 0, 1, 1);
}

.data-\\[state\\=open\\]\\:ease-out[data-state="open"] {
  animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.data-\\[state\\=open\\]\\:hover\\:bg-sidebar-accent:hover[data-state="open"] {
  background-color: hsl(var(--sidebar-accent));
}

.data-\\[state\\=open\\]\\:hover\\:text-sidebar-accent-foreground:hover[data-state="open"] {
  color: hsl(var(--sidebar-accent-foreground));
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:left-\\[calc\\(var\\(--sidebar-width\\)\\*-1\\)\\] {
  left: calc(var(--sidebar-width) * -1);
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:right-\\[calc\\(var\\(--sidebar-width\\)\\*-1\\)\\] {
  right: calc(var(--sidebar-width) * -1);
}

.group[data-side="left"] .group-data-\\[side\\=left\\]\\:-right-4 {
  right: -1rem;
}

.group[data-side="right"] .group-data-\\[side\\=right\\]\\:left-0 {
  left: 0px;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:-mt-8 {
  margin-top: -2rem;
}

.group\\/chat[data-cw-md] .group-data-\\[cw-md\\]\\/chat\\:inline-flex {
  display: inline-flex;
}

.group\\/chat[data-cw-md] .group-data-\\[cw-md\\]\\/chat\\:table-cell {
  display: table-cell;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:hidden {
  display: none;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:\\!size-8 {
  width: 2rem !important;
  height: 2rem !important;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:w-\\[--sidebar-width-icon\\] {
  width: var(--sidebar-width-icon);
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:w-\\[calc\\(var\\(--sidebar-width-icon\\)_\\+_theme\\(spacing\\.4\\)\\)\\] {
  width: calc(var(--sidebar-width-icon) + 1rem);
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:w-\\[calc\\(var\\(--sidebar-width-icon\\)_\\+_theme\\(spacing\\.4\\)_\\+2px\\)\\] {
  width: calc(var(--sidebar-width-icon) + 1rem + 2px);
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:w-0 {
  width: 0px;
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-side="right"] .group-data-\\[side\\=right\\]\\:rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group\\/chat[data-cw-lg] .group-data-\\[cw-lg\\]\\/chat\\:grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.group\\/chat[data-cw-md] .group-data-\\[cw-md\\]\\/chat\\:grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:overflow-hidden {
  overflow: hidden;
}

.group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:rounded-lg {
  border-radius: var(--radius);
}

.group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:border {
  border-width: 1px;
}

.group[data-side="left"] .group-data-\\[side\\=left\\]\\:border-r {
  border-right-width: 1px;
}

.group[data-side="right"] .group-data-\\[side\\=right\\]\\:border-l {
  border-left-width: 1px;
}

.group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:border-sidebar-border {
  border-color: hsl(var(--sidebar-border));
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:\\!p-0 {
  padding: 0px !important;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:\\!p-2 {
  padding: 0.5rem !important;
}

.group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:opacity-0 {
  opacity: 0;
}

.group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:after\\:left-full::after {
  content: var(--tw-content);
  left: 100%;
}

.group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:hover\\:bg-sidebar:hover {
  background-color: hsl(var(--sidebar-background));
}

.peer\\/menu-button[data-size="default"] ~ .peer-data-\\[size\\=default\\]\\/menu-button\\:top-1\\.5 {
  top: 0.375rem;
}

.peer\\/menu-button[data-size="lg"] ~ .peer-data-\\[size\\=lg\\]\\/menu-button\\:top-2\\.5 {
  top: 0.625rem;
}

.peer\\/menu-button[data-size="sm"] ~ .peer-data-\\[size\\=sm\\]\\/menu-button\\:top-1 {
  top: 0.25rem;
}

.peer\\/menu-button[data-active="true"] ~ .peer-data-\\[active\\=true\\]\\/menu-button\\:text-sidebar-accent-foreground {
  color: hsl(var(--sidebar-accent-foreground));
}

@supports (backdrop-filter: var(--tw)) {

  .supports-\\[backdrop-filter\\]\\:bg-background\\/60 {
    background-color: hsl(var(--background) / 0.6);
  }

  .supports-\\[backdrop-filter\\]\\:bg-background\\/70 {
    background-color: hsl(var(--background) / 0.7);
  }

  .supports-\\[backdrop-filter\\]\\:bg-background\\/80 {
    background-color: hsl(var(--background) / 0.8);
  }
}

@media (prefers-reduced-motion: reduce) {

  .motion-reduce\\:animate-none {
    animation: none;
  }

  .motion-reduce\\:transition-none {
    transition-property: none;
  }
}

.dark\\:border-amber-300\\/40:is(.dark *) {
  border-color: rgb(252 211 77 / 0.4);
}

.dark\\:border-amber-400\\/50:is(.dark *) {
  border-color: rgb(251 191 36 / 0.5);
}

.dark\\:border-amber-500\\/20:is(.dark *) {
  border-color: rgb(245 158 11 / 0.2);
}

.dark\\:border-amber-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(146 64 14 / var(--tw-border-opacity, 1));
}

.dark\\:border-amber-900\\/50:is(.dark *) {
  border-color: rgb(120 53 15 / 0.5);
}

.dark\\:border-blue-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(30 64 175 / var(--tw-border-opacity, 1));
}

.dark\\:border-destructive:is(.dark *) {
  border-color: hsl(var(--destructive));
}

.dark\\:border-emerald-400\\/50:is(.dark *) {
  border-color: rgb(52 211 153 / 0.5);
}

.dark\\:border-emerald-500\\/45:is(.dark *) {
  border-color: rgb(16 185 129 / 0.45);
}

.dark\\:border-gray-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}

.dark\\:border-green-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(22 101 52 / var(--tw-border-opacity, 1));
}

.dark\\:border-green-900\\/50:is(.dark *) {
  border-color: rgb(20 83 45 / 0.5);
}

.dark\\:border-purple-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(107 33 168 / var(--tw-border-opacity, 1));
}

.dark\\:border-red-400\\/50:is(.dark *) {
  border-color: rgb(248 113 113 / 0.5);
}

.dark\\:border-red-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(153 27 27 / var(--tw-border-opacity, 1));
}

.dark\\:border-red-900\\/50:is(.dark *) {
  border-color: rgb(127 29 29 / 0.5);
}

.dark\\:border-teal-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(17 94 89 / var(--tw-border-opacity, 1));
}

.dark\\:bg-amber-500\\/20:is(.dark *) {
  background-color: rgb(245 158 11 / 0.2);
}

.dark\\:bg-amber-500\\/25:is(.dark *) {
  background-color: rgb(245 158 11 / 0.25);
}

.dark\\:bg-amber-900\\/30:is(.dark *) {
  background-color: rgb(120 53 15 / 0.3);
}

.dark\\:bg-amber-950:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(69 26 3 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-amber-950\\/20:is(.dark *) {
  background-color: rgb(69 26 3 / 0.2);
}

.dark\\:bg-amber-950\\/30:is(.dark *) {
  background-color: rgb(69 26 3 / 0.3);
}

.dark\\:bg-blue-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-blue-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 58 138 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-blue-900\\/20:is(.dark *) {
  background-color: rgb(30 58 138 / 0.2);
}

.dark\\:bg-blue-950:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(23 37 84 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-blue-950\\/30:is(.dark *) {
  background-color: rgb(23 37 84 / 0.3);
}

.dark\\:bg-emerald-500\\/15:is(.dark *) {
  background-color: rgb(16 185 129 / 0.15);
}

.dark\\:bg-emerald-900\\/30:is(.dark *) {
  background-color: rgb(6 78 59 / 0.3);
}

.dark\\:bg-emerald-950:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(2 44 34 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-green-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(20 83 45 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-green-900\\/30:is(.dark *) {
  background-color: rgb(20 83 45 / 0.3);
}

.dark\\:bg-green-950:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(5 46 22 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-green-950\\/20:is(.dark *) {
  background-color: rgb(5 46 22 / 0.2);
}

.dark\\:bg-green-950\\/30:is(.dark *) {
  background-color: rgb(5 46 22 / 0.3);
}

.dark\\:bg-muted\\/35:is(.dark *) {
  background-color: hsl(var(--muted) / 0.35);
}

.dark\\:bg-orange-900\\/30:is(.dark *) {
  background-color: rgb(124 45 18 / 0.3);
}

.dark\\:bg-purple-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(88 28 135 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-purple-950:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(59 7 100 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-purple-950\\/30:is(.dark *) {
  background-color: rgb(59 7 100 / 0.3);
}

.dark\\:bg-red-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(127 29 29 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-red-900\\/20:is(.dark *) {
  background-color: rgb(127 29 29 / 0.2);
}

.dark\\:bg-red-900\\/30:is(.dark *) {
  background-color: rgb(127 29 29 / 0.3);
}

.dark\\:bg-red-950\\/20:is(.dark *) {
  background-color: rgb(69 10 10 / 0.2);
}

.dark\\:bg-red-950\\/30:is(.dark *) {
  background-color: rgb(69 10 10 / 0.3);
}

.dark\\:bg-sky-950:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(8 47 73 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-slate-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-slate-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-teal-900\\/30:is(.dark *) {
  background-color: rgb(19 78 74 / 0.3);
}

.dark\\:bg-teal-950\\/20:is(.dark *) {
  background-color: rgb(4 47 46 / 0.2);
}

.dark\\:bg-violet-950:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(46 16 101 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-yellow-400\\/30:is(.dark *) {
  background-color: rgb(250 204 21 / 0.3);
}

.dark\\:bg-yellow-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(113 63 18 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-yellow-900\\/20:is(.dark *) {
  background-color: rgb(113 63 18 / 0.2);
}

.dark\\:bg-yellow-900\\/30:is(.dark *) {
  background-color: rgb(113 63 18 / 0.3);
}

.dark\\:text-amber-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(254 243 199 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}

.dark\\:text-cyan-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(103 232 249 / var(--tw-text-opacity, 1));
}

.dark\\:text-cyan-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(34 211 238 / var(--tw-text-opacity, 1));
}

.dark\\:text-emerald-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity, 1));
}

.dark\\:text-emerald-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}

.dark\\:text-emerald-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.dark\\:text-green-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(187 247 208 / var(--tw-text-opacity, 1));
}

.dark\\:text-green-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity, 1));
}

.dark\\:text-green-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}

.dark\\:text-green-400\\/70:is(.dark *) {
  color: rgb(74 222 128 / 0.7);
}

.dark\\:text-green-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}

.dark\\:text-indigo-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}

.dark\\:text-indigo-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}

.dark\\:text-orange-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(253 186 116 / var(--tw-text-opacity, 1));
}

.dark\\:text-orange-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity, 1));
}

.dark\\:text-pink-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(244 114 182 / var(--tw-text-opacity, 1));
}

.dark\\:text-primary\\/80:is(.dark *) {
  color: hsl(var(--primary) / 0.8);
}

.dark\\:text-purple-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-purple-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}

.dark\\:text-rose-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}

.dark\\:text-sky-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(186 230 253 / var(--tw-text-opacity, 1));
}

.dark\\:text-sky-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(56 189 248 / var(--tw-text-opacity, 1));
}

.dark\\:text-slate-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}

.dark\\:text-slate-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}

.dark\\:text-teal-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(94 234 212 / var(--tw-text-opacity, 1));
}

.dark\\:text-teal-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(45 212 191 / var(--tw-text-opacity, 1));
}

.dark\\:text-violet-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(221 214 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-violet-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity, 1));
}

.dark\\:text-yellow-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(254 240 138 / var(--tw-text-opacity, 1));
}

.dark\\:text-yellow-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / var(--tw-text-opacity, 1));
}

.dark\\:text-yellow-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}

.dark\\:shadow-emerald-950\\/30:is(.dark *) {
  --tw-shadow-color: rgb(2 44 34 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.dark\\:hover\\:bg-amber-500\\/30:hover:is(.dark *) {
  background-color: rgb(245 158 11 / 0.3);
}

.dark\\:hover\\:bg-amber-900\\/30:hover:is(.dark *) {
  background-color: rgb(120 53 15 / 0.3);
}

.dark\\:hover\\:bg-blue-600:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-green-900\\/30:hover:is(.dark *) {
  background-color: rgb(20 83 45 / 0.3);
}

.dark\\:hover\\:bg-muted\\/50:hover:is(.dark *) {
  background-color: hsl(var(--muted) / 0.5);
}

.dark\\:hover\\:bg-red-900\\/30:hover:is(.dark *) {
  background-color: rgb(127 29 29 / 0.3);
}

.dark\\:hover\\:bg-red-950\\/30:hover:is(.dark *) {
  background-color: rgb(69 10 10 / 0.3);
}

.dark\\:hover\\:text-amber-400:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-blue-300:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-emerald-400:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}

@media not all and (min-width: 1280px) {

  .max-xl\\:hidden {
    display: none;
  }
}

@media not all and (min-width: 1024px) {

  .max-lg\\:hidden {
    display: none;
  }
}

@media (min-width: 640px) {

  .sm\\:bottom-0 {
    bottom: 0px;
  }

  .sm\\:right-0 {
    right: 0px;
  }

  .sm\\:top-auto {
    top: auto;
  }

  .sm\\:mb-8 {
    margin-bottom: 2rem;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:inline-block {
    display: inline-block;
  }

  .sm\\:inline {
    display: inline;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:inline-flex {
    display: inline-flex;
  }

  .sm\\:h-11 {
    height: 2.75rem;
  }

  .sm\\:h-14 {
    height: 3.5rem;
  }

  .sm\\:h-3 {
    height: 0.75rem;
  }

  .sm\\:h-4 {
    height: 1rem;
  }

  .sm\\:min-h-0 {
    min-height: 0px;
  }

  .sm\\:w-3 {
    width: 0.75rem;
  }

  .sm\\:w-4 {
    width: 1rem;
  }

  .sm\\:w-56 {
    width: 14rem;
  }

  .sm\\:w-72 {
    width: 18rem;
  }

  .sm\\:w-80 {
    width: 20rem;
  }

  .sm\\:w-\\[480px\\] {
    width: 480px;
  }

  .sm\\:min-w-\\[280px\\] {
    min-width: 280px;
  }

  .sm\\:max-w-\\[1040px\\] {
    max-width: 1040px;
  }

  .sm\\:max-w-\\[340px\\] {
    max-width: 340px;
  }

  .sm\\:max-w-\\[400px\\] {
    max-width: 400px;
  }

  .sm\\:max-w-\\[420px\\] {
    max-width: 420px;
  }

  .sm\\:max-w-\\[425px\\] {
    max-width: 425px;
  }

  .sm\\:max-w-\\[440px\\] {
    max-width: 440px;
  }

  .sm\\:max-w-\\[460px\\] {
    max-width: 460px;
  }

  .sm\\:max-w-\\[480px\\] {
    max-width: 480px;
  }

  .sm\\:max-w-\\[500px\\] {
    max-width: 500px;
  }

  .sm\\:max-w-\\[520px\\] {
    max-width: 520px;
  }

  .sm\\:max-w-\\[560px\\] {
    max-width: 560px;
  }

  .sm\\:max-w-\\[600px\\] {
    max-width: 600px;
  }

  .sm\\:max-w-\\[680px\\] {
    max-width: 680px;
  }

  .sm\\:max-w-\\[700px\\] {
    max-width: 700px;
  }

  .sm\\:max-w-\\[780px\\] {
    max-width: 780px;
  }

  .sm\\:max-w-md {
    max-width: 28rem;
  }

  .sm\\:max-w-none {
    max-width: none;
  }

  .sm\\:max-w-sm {
    max-width: 24rem;
  }

  .sm\\:max-w-xl {
    max-width: 36rem;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-col {
    flex-direction: column;
  }

  .sm\\:flex-wrap {
    flex-wrap: wrap;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:gap-0 {
    gap: 0px;
  }

  .sm\\:gap-1 {
    gap: 0.25rem;
  }

  .sm\\:gap-2 {
    gap: 0.5rem;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:p-2 {
    padding: 0.5rem;
  }

  .sm\\:p-4 {
    padding: 1rem;
  }

  .sm\\:p-8 {
    padding: 2rem;
  }

  .sm\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .sm\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .sm\\:text-left {
    text-align: left;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-5[data-state="open"] {
    --tw-enter-translate-y: 1.25rem;
  }
}

@media (min-width: 768px) {

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .md\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-full {
    height: 100%;
  }

  .md\\:min-h-0 {
    min-height: 0px;
  }

  .md\\:w-72 {
    width: 18rem;
  }

  .md\\:max-w-\\[420px\\] {
    max-width: 420px;
  }

  .md\\:flex-1 {
    flex: 1 1 0%;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .md\\:grid-cols-\\[auto_1fr_1fr\\] {
    grid-template-columns: auto 1fr 1fr;
  }

  .md\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_180px_auto\\] {
    grid-template-columns: minmax(0,1fr) 180px auto;
  }

  .md\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_auto\\] {
    grid-template-columns: minmax(0,1fr) auto;
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:items-start {
    align-items: flex-start;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-center {
    justify-content: center;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:space-y-6 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
  }

  .md\\:border-l {
    border-left-width: 1px;
  }

  .md\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:opacity-0 {
    opacity: 0;
  }

  .md\\:shadow-sm {
    --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .after\\:md\\:hidden::after {
    content: var(--tw-content);
    display: none;
  }

  .peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:m-2 {
    margin: 0.5rem;
  }

  .peer[data-state="collapsed"][data-variant="inset"] ~ .md\\:peer-data-\\[state\\=collapsed\\]\\:peer-data-\\[variant\\=inset\\]\\:ml-2 {
    margin-left: 0.5rem;
  }

  .peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:ml-0 {
    margin-left: 0px;
  }

  .peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:rounded-xl {
    border-radius: 0.75rem;
  }

  .peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:shadow {
    --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

@media (min-width: 1024px) {

  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .lg\\:mb-3 {
    margin-bottom: 0.75rem;
  }

  .lg\\:mt-0 {
    margin-top: 0px;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:inline {
    display: inline;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:grid {
    display: grid;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-32 {
    height: 8rem;
  }

  .lg\\:h-6 {
    height: 1.5rem;
  }

  .lg\\:h-8 {
    height: 2rem;
  }

  .lg\\:w-56 {
    width: 14rem;
  }

  .lg\\:w-6 {
    width: 1.5rem;
  }

  .lg\\:w-64 {
    width: 16rem;
  }

  .lg\\:w-8 {
    width: 2rem;
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[140px_minmax\\(180px\\2c 1\\.1fr\\)_minmax\\(240px\\2c 1\\.5fr\\)_minmax\\(180px\\2c 1fr\\)_112px\\] {
    grid-template-columns: 140px minmax(180px,1.1fr) minmax(240px,1.5fr) minmax(180px,1fr) 112px;
  }

  .lg\\:grid-cols-\\[1fr_1fr\\] {
    grid-template-columns: 1fr 1fr;
  }

  .lg\\:grid-cols-\\[22rem_minmax\\(0\\2c 1fr\\)\\] {
    grid-template-columns: 22rem minmax(0,1fr);
  }

  .lg\\:grid-cols-\\[24rem_minmax\\(0\\2c 1fr\\)\\] {
    grid-template-columns: 24rem minmax(0,1fr);
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 0\\.9fr\\)_minmax\\(0\\2c 1\\.1fr\\)\\] {
    grid-template-columns: minmax(0,0.9fr) minmax(0,1.1fr);
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_minmax\\(300px\\2c 380px\\)\\] {
    grid-template-columns: minmax(0,1fr) minmax(300px,380px);
  }

  .lg\\:grid-cols-\\[minmax\\(200px\\2c 1fr\\)_minmax\\(260px\\2c 1\\.6fr\\)_minmax\\(160px\\2c 0\\.8fr\\)\\] {
    grid-template-columns: minmax(200px,1fr) minmax(260px,1.6fr) minmax(160px,0.8fr);
  }

  .lg\\:grid-cols-\\[minmax\\(200px\\2c 1fr\\)_minmax\\(260px\\2c 1\\.6fr\\)_minmax\\(160px\\2c 0\\.8fr\\)_100px\\] {
    grid-template-columns: minmax(200px,1fr) minmax(260px,1.6fr) minmax(160px,0.8fr) 100px;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:items-end {
    align-items: flex-end;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:justify-end {
    justify-content: flex-end;
  }

  .lg\\:justify-between {
    justify-content: space-between;
  }

  .lg\\:gap-3 {
    gap: 0.75rem;
  }

  .lg\\:gap-4 {
    gap: 1rem;
  }

  .lg\\:p-4 {
    padding: 1rem;
  }

  .lg\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .lg\\:text-right {
    text-align: right;
  }

  .lg\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .lg\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .lg\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

@media (min-width: 1280px) {

  .xl\\:sticky {
    position: sticky;
  }

  .xl\\:top-5 {
    top: 1.25rem;
  }

  .xl\\:order-1 {
    order: 1;
  }

  .xl\\:order-2 {
    order: 2;
  }

  .xl\\:inline {
    display: inline;
  }

  .xl\\:h-40 {
    height: 10rem;
  }

  .xl\\:max-h-\\[520px\\] {
    max-height: 520px;
  }

  .xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .xl\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .xl\\:grid-cols-\\[17rem_minmax\\(26rem\\2c 1fr\\)_21rem\\] {
    grid-template-columns: 17rem minmax(26rem,1fr) 21rem;
  }

  .xl\\:grid-cols-\\[1fr_20rem\\] {
    grid-template-columns: 1fr 20rem;
  }

  .xl\\:grid-cols-\\[1fr_22rem\\] {
    grid-template-columns: 1fr 22rem;
  }

  .xl\\:grid-cols-\\[1fr_420px\\] {
    grid-template-columns: 1fr 420px;
  }

  .xl\\:grid-cols-\\[28rem_minmax\\(0\\2c 1fr\\)\\] {
    grid-template-columns: 28rem minmax(0,1fr);
  }

  .xl\\:grid-cols-\\[minmax\\(0\\2c 0\\.8fr\\)_minmax\\(380px\\2c 0\\.7fr\\)\\] {
    grid-template-columns: minmax(0,0.8fr) minmax(380px,0.7fr);
  }

  .xl\\:grid-cols-\\[minmax\\(0\\2c 0\\.9fr\\)_minmax\\(360px\\2c 0\\.7fr\\)\\] {
    grid-template-columns: minmax(0,0.9fr) minmax(360px,0.7fr);
  }

  .xl\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_360px\\] {
    grid-template-columns: minmax(0,1fr) 360px;
  }

  .xl\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_minmax\\(280px\\2c 0\\.75fr\\)\\] {
    grid-template-columns: minmax(0,1fr) minmax(280px,0.75fr);
  }

  .xl\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_minmax\\(360px\\2c 0\\.75fr\\)\\] {
    grid-template-columns: minmax(0,1fr) minmax(360px,0.75fr);
  }

  .xl\\:self-start {
    align-self: flex-start;
  }

  .xl\\:border-b-0 {
    border-bottom-width: 0px;
  }

  .xl\\:border-l {
    border-left-width: 1px;
  }

  .xl\\:border-r {
    border-right-width: 1px;
  }

  .xl\\:border-t-0 {
    border-top-width: 0px;
  }
}

@media (min-width: 1536px) {

  .\\32xl\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
}

.\\[\\&\\:\\:-webkit-details-marker\\]\\:hidden::-webkit-details-marker {
  display: none;
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:min-h-\\[6px\\]::-webkit-scrollbar-thumb {
  min-height: 6px;
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:rounded-full::-webkit-scrollbar-thumb {
  border-radius: 9999px;
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-muted-foreground\\/20::-webkit-scrollbar-thumb {
  background-color: hsl(var(--muted-foreground) / 0.2);
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-muted-foreground\\/25::-webkit-scrollbar-thumb {
  background-color: hsl(var(--muted-foreground) / 0.25);
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-muted-foreground\\/30::-webkit-scrollbar-thumb {
  background-color: hsl(var(--muted-foreground) / 0.3);
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-muted-foreground\\/40::-webkit-scrollbar-thumb {
  background-color: hsl(var(--muted-foreground) / 0.4);
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-muted-foreground\\/50::-webkit-scrollbar-thumb {
  background-color: hsl(var(--muted-foreground) / 0.5);
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:hover\\:bg-muted-foreground\\/40:hover::-webkit-scrollbar-thumb {
  background-color: hsl(var(--muted-foreground) / 0.4);
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:hover\\:bg-muted-foreground\\/45:hover::-webkit-scrollbar-thumb {
  background-color: hsl(var(--muted-foreground) / 0.45);
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:hover\\:bg-muted-foreground\\/50:hover::-webkit-scrollbar-thumb {
  background-color: hsl(var(--muted-foreground) / 0.5);
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:hover\\:bg-muted-foreground\\/60:hover::-webkit-scrollbar-thumb {
  background-color: hsl(var(--muted-foreground) / 0.6);
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:hover\\:bg-muted-foreground\\/65:hover::-webkit-scrollbar-thumb {
  background-color: hsl(var(--muted-foreground) / 0.65);
}

.\\[\\&\\:\\:-webkit-scrollbar-track\\]\\:rounded-full::-webkit-scrollbar-track {
  border-radius: 9999px;
}

.\\[\\&\\:\\:-webkit-scrollbar-track\\]\\:bg-muted\\/40::-webkit-scrollbar-track {
  background-color: hsl(var(--muted) / 0.4);
}

.\\[\\&\\:\\:-webkit-scrollbar-track\\]\\:bg-transparent::-webkit-scrollbar-track {
  background-color: transparent;
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar {
  display: none;
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:h-2::-webkit-scrollbar {
  height: 0.5rem;
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:w-1::-webkit-scrollbar {
  width: 0.25rem;
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:w-1\\.5::-webkit-scrollbar {
  width: 0.375rem;
}

.\\[\\&\\:\\:-webkit-search-cancel-button\\]\\:appearance-none::-webkit-search-cancel-button {
  -webkit-appearance: none;
          appearance: none;
}

.\\[\\&\\:disabled\\]\\:cursor-default:disabled {
  cursor: default;
}

.\\[\\&\\:disabled\\]\\:cursor-wait:disabled {
  cursor: wait;
}

.\\[\\&\\:disabled\\]\\:opacity-100:disabled {
  opacity: 1;
}

.\\[\\&\\:disabled\\]\\:opacity-60:disabled {
  opacity: 0.6;
}

.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]) {
  padding-right: 0px;
}

.\\[\\&\\>button\\]\\:hidden>button {
  display: none;
}

.\\[\\&\\>p\\]\\:inline>p {
  display: inline;
}

.\\[\\&\\>span\\:last-child\\]\\:truncate>span:last-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.\\[\\&\\>span\\]\\:min-w-0>span {
  min-width: 0px;
}

.\\[\\&\\>span\\]\\:truncate>span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.\\[\\&\\>span\\]\\:last\\:truncate:last-child>span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div {
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\>svg\\]\\:pointer-events-auto>svg {
  pointer-events: auto;
}

.\\[\\&\\>svg\\]\\:absolute>svg {
  position: absolute;
}

.\\[\\&\\>svg\\]\\:left-4>svg {
  left: 1rem;
}

.\\[\\&\\>svg\\]\\:top-4>svg {
  top: 1rem;
}

.\\[\\&\\>svg\\]\\:size-4>svg {
  width: 1rem;
  height: 1rem;
}

.\\[\\&\\>svg\\]\\:size-5>svg {
  width: 1.25rem;
  height: 1.25rem;
}

.\\[\\&\\>svg\\]\\:shrink-0>svg {
  flex-shrink: 0;
}

.\\[\\&\\>svg\\]\\:text-destructive>svg {
  color: hsl(var(--destructive));
}

.\\[\\&\\>svg\\]\\:text-foreground>svg {
  color: hsl(var(--foreground));
}

.\\[\\&\\>svg\\]\\:text-sidebar-accent-foreground>svg {
  color: hsl(var(--sidebar-accent-foreground));
}

.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~* {
  padding-left: 1.75rem;
}

.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr {
  border-bottom-width: 0px;
}

.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-90[data-state=open]>svg {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading] {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading] {
  font-size: 0.75rem;
  line-height: 1rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading] {
  font-weight: 500;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading] {
  color: hsl(var(--muted-foreground));
}

.\\[\\&_p\\]\\:leading-relaxed p {
  line-height: 1.625;
}

.\\[\\&_svg\\]\\:pointer-events-none svg {
  pointer-events: none;
}

.\\[\\&_svg\\]\\:pointer-events-auto svg {
  pointer-events: auto;
}

.\\[\\&_svg\\]\\:invisible svg {
  visibility: hidden;
}

.\\[\\&_svg\\]\\:size-3\\.5 svg {
  width: 0.875rem;
  height: 0.875rem;
}

.\\[\\&_svg\\]\\:size-4 svg {
  width: 1rem;
  height: 1rem;
}

.\\[\\&_svg\\]\\:shrink-0 svg {
  flex-shrink: 0;
}

.\\[\\&_table\\]\\:text-\\[11px\\] table {
  font-size: 11px;
}

.\\[\\&_td\\]\\:border-primary\\/20 td {
  border-color: hsl(var(--primary) / 0.2);
}

.\\[\\&_td\\]\\:px-2 td {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_td\\]\\:py-0\\.5 td {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}

.\\[\\&_th\\]\\:border-primary\\/20 th {
  border-color: hsl(var(--primary) / 0.2);
}

.\\[\\&_th\\]\\:px-2 th {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_th\\]\\:py-0\\.5 th {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}

.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child {
  border-width: 0px;
}

.\\[\\&_tr\\]\\:border-b tr {
  border-bottom-width: 1px;
}

[data-side=left][data-collapsible=offcanvas] .\\[\\[data-side\\=left\\]\\[data-collapsible\\=offcanvas\\]_\\&\\]\\:-right-2 {
  right: -0.5rem;
}

[data-side=left][data-state=collapsed] .\\[\\[data-side\\=left\\]\\[data-state\\=collapsed\\]_\\&\\]\\:cursor-e-resize {
  cursor: e-resize;
}

[data-side=left] .\\[\\[data-side\\=left\\]_\\&\\]\\:cursor-w-resize {
  cursor: w-resize;
}

[data-side=right][data-collapsible=offcanvas] .\\[\\[data-side\\=right\\]\\[data-collapsible\\=offcanvas\\]_\\&\\]\\:-left-2 {
  left: -0.5rem;
}

[data-side=right][data-state=collapsed] .\\[\\[data-side\\=right\\]\\[data-state\\=collapsed\\]_\\&\\]\\:cursor-w-resize {
  cursor: w-resize;
}

[data-side=right] .\\[\\[data-side\\=right\\]_\\&\\]\\:cursor-e-resize {
  cursor: e-resize;
}

li .\\[li_\\&\\]\\:pl-6 {
  padding-left: 1.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/globals.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,wDAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,6EAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;EAAd;IAAA,+CAAc;IAAd,yBAAc;IAAd,+EAAc;IAAd,wBAAc;;IAAd,4BAAc;IAAd,iBAAc;IAAd,6BAAc;IAAd,4BAAc;;IAAd,mBAAc;IAAd,oBAAc;IAAd,gCAAc;;IAAd,iFAAc;IAAd,uBAAc;IAAd,+BAAc;IAAd,4BAAc;;IAAd,qBAAc;IAAd,wBAAc;IAAd,kCAAc;;IAAd,qFAAc;IAAd,oBAAc;IAAd,+BAAc;;IAAd,oEAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,mCAAc;IAAd,8BAAc;IAAd,uBAAc;IAAd,gCAAc;;IAAd,kBAAc;IAAd,wBAAc;IAAd,mCAAc;IAAd,sBAAc;IAAd,+BAAc;IAAd,qBAAc;IAAd,+BAAc;IAAd;;mGAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,+BAAc;;IAAd,2EAAc;IAAd,qBAAc;IAAd,oBAAc;IAAd,oBAAc;;IAAd,oEAAc;IAAd,6BAAc;IAAd,iCAAc;IAAd,8BAAc;IAAd,uBAAc;IAAd,4BAAc;IAAd,2BAAc;;IAAd,8BAAc;IAAd,kCAAc;IAAd,6CAAc;IAAd,sCAAc;IAAd,gDAAc;IAAd,6CAAc;;IAAd,mBAAc;IAAd,iCAAc;IAAd,gCAAc;IAAd,+BAAc;IAAd,uCAAc;IAAd,6BAAc;IAAd,uCAAc;IAAd,6BAAc;IAAd,4BAAc;;IAAd,2EAAc;IAAd,iFAAc;IAAd,uEAAc;IAAd,gFAAc;;IAAd,YAAc;IAAd,gFAAc;IAAd,+CAAc;IAAd,uFAAc;;IAAd,wBAAc;IAAd,0DAAc;;IAAd,iBAAc;;IAAd;;yBAAc;IAAd,uBAAc;IAAd,4BAAc;IAAd,oBAAc;IAAd,2BAAc;IAAd,oBAAc;IAAd,0BAAc;IAAd,0BAAc;IAAd,sBAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,2BAAc;EAAA;;EAAd;IAAA,2BAAc;IAAd,yBAAc;IAAd,yBAAc;;IAAd,4BAAc;IAAd,mBAAc;IAAd,8BAAc;IAAd,4BAAc;;IAAd,mBAAc;IAAd,sBAAc;IAAd,iCAAc;;IAAd,4BAAc;IAAd,uBAAc;IAAd,+BAAc;IAAd,4BAAc;;IAAd,qBAAc;IAAd,wBAAc;IAAd,mCAAc;;IAAd,iBAAc;IAAd,oBAAc;IAAd,+BAAc;;IAAd,kBAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,mCAAc;IAAd,8BAAc;IAAd,sBAAc;IAAd,gCAAc;;IAAd,kBAAc;IAAd,wBAAc;IAAd,mCAAc;IAAd,sBAAc;IAAd,+BAAc;IAAd,qBAAc;IAAd,gCAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,+BAAc;;IAAd,4BAAc;IAAd,qBAAc;IAAd,oBAAc;IAAd,oBAAc;;IAAd,sBAAc;IAAd,8BAAc;IAAd,iCAAc;IAAd,8BAAc;IAAd,wBAAc;IAAd,4BAAc;IAAd,2BAAc;;IAAd,mCAAc;IAAd,kCAAc;IAAd,6CAAc;IAAd,qCAAc;IAAd,gDAAc;IAAd,6CAAc;;IAAd,mBAAc;IAAd,gCAAc;IAAd,iCAAc;IAAd,+BAAc;IAAd,uCAAc;IAAd,6BAAc;IAAd,wCAAc;IAAd,6BAAc;IAAd,4BAAc;;IAAd,cAAc;IAAd,iFAAc;IAAd,4EAAc;IAAd,gFAAc;;IAAd,YAAc;IAAd,oDAAc;IAAd,+CAAc;IAAd,wDAAc;;IAAd,sBAAc;IAAd,4BAAc;IAAd,sBAAc;IAAd,2BAAc;IAAd,qBAAc;IAAd,0BAAc;IAAd,0BAAc;IAAd,sBAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,2BAAc;IAAd,sBAAc,cAAd,YAAc;IAAd,2BAAc;EAAA;EAAd;EAAA;AAAc;;EAAd;;;EAAA,WAAc;EAAd,YAAc;EAAd;AAAc;;EAAd;EAAA,wCAAc;EAAd,6BAAc;EAAd,mCAAc;EAAd,kCAAc;IAAd;AAAc;;EAAd,gCAAc;;EAAd,mBAAc;;EAAd;IAAA,8BAAc;EAAA;;EAAd,uBAAc;;EAAd,qEAAc;EAAd;IAAA,kBAAc;IAAd,wBAAc;IAAd,qBAAc;IAAd,gEAAc;EAAA;;EAAd;IAAA,WAAc;EAAA;;EAAd;IAAA,aAAc;IAAd,uBAAc;IAAd,oBAAc;EAAA;;EAAd;IAAA,+CAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,oBAAc;EAAA;;EAAd;IAAA,+CAAc;IAAd,6BAAc;IAAd,4BAAc;EAAA;;EAAd,kEAAc;EAAd;IAAA,qBAAc;IAAd,gEAAc;EAAA;EAAd;IAAA,WAAc;EAAA;EAAd;IAAA,uBAAc;EAAA;EAAd;IAAA,+CAAc;IAAd,qBAAc;EAAA;EAAd;IAAA,8CAAc;EAAA;EAAd;EAAA;AAAc;EAAd;EAAA,wCAAc;EAAd;AAAc;AACd;EAAA,sBAAoB;EAApB,6BAAoB;EAApB,4BAAoB;EAApB,8BAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA,2BAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB,iBAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA,4BAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,wBAAoB;EAApB,kBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,qBAAoB;EAApB,kBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,gCAAoB;EAApB,qBAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,kBAAoB;EAApB,6BAAoB;EAApB,kCAAoB;EAApB,wDAAoB;EAApB,oCAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB,aAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,eAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,oBAAoB;EAApB,0BAAoB;EAApB,sFAAoB;EAApB,kBAAoB;EAApB,wBAAoB;EAApB,qBAAoB;EAApB,2BAAoB;EAApB,wBAAoB;EAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,cAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB,wCAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,kBAAoB;EAApB,sBAAoB;EAApB,uBAAoB;EAApB,0BAAoB;EAApB,uBAAoB;EAApB,wBAAoB;EAApB,+BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA,6BAAoB;EAApB,eAAoB;EAApB,gBAAoB;EAApB,UAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB,kBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,eAAoB;EAApB,kBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,wBAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,sBAAoB;EAApB,+BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA,wBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,qBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,kBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,wBAAoB;EAApB,4BAAoB;EAApB,wBAAoB;EAApB,yBAAoB;EAApB,wBAAoB;EAApB,4BAAoB;EAApB,2BAAoB;EAApB,sBAAoB;EAApB,0BAAoB;EAApB,iCAAoB;EAApB,4BAAoB;EAApB,uBAAoB;EAApB,2CAAoB;EAApB,wBAAoB;EAApB,4BAAoB;EAApB,0BAAoB;EAApB,8BAAoB;EAApB,8BAAoB;EAApB,+BAAoB;EAApB,gCAAoB;EAApB,+BAAoB;EAApB,6BAAoB;EAApB,4BAAoB;EAApB,mCAAoB;EAApB,kCAAoB;EAApB,6BAAoB;EAApB,iCAAoB;EAApB,wCAAoB;EAApB,mCAAoB;EAApB,2BAAoB;EAApB,qDAAoB;EAApB,4BAAoB;EAApB,mCAAoB;EAApB,0CAAoB;EAApB,qCAAoB;EAApB,qCAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,wBAAoB;EAApB,+BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,mBAAoB;EAApB,sBAAoB;AAAA;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sBAAoB;EAApB,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,aAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,wBAAoB;EAApB,wBAAoB;EAApB,+BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sBAAoB;EAApB,uBAAoB;EAApB,0BAAoB;EAApB,sBAAoB;EAApB,wBAAoB;EAApB,uBAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,wBAAoB;EAApB,uBAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,mBAAoB;EAApB,sBAAoB;AAAA;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sBAAoB;EAApB,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,aAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,wBAAoB;EAApB,wBAAoB;EAApB,+BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB,iBAAoB;EAApB,eAAoB;EAApB,kBAAoB;EAApB,uBAAoB;EAApB,gBAAoB;EAApB,yBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA,0BAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,mBAAoB;EAApB,0BAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;EAw9ChB;EAAA,iBAAiE;EAAjE,4BAAiE;EAAjE,iBAAiE;EAAjE,gCAAiE;EAAjE,0CAAiE;EAAjE,uDAAiE;EAAjE;AAAiE;EAAjE;EAAA,uCAAiE;EAAjE;sFAAiE;EAAjE;;4CAAiE;AAAA;EAAjE;EAAA,mDAAiE;AAAA;EADnE;IAEE,kBAAkB;IAClB;wFACoF;IACpF;;6CAEyC;EAC3C;;EAGE;EAAA,iBAAuD;EAAvD,4BAAuD;EAAvD,iBAAuD;EAAvD;AAAuD;;EAAvD;EAAA,uCAAuD;EAAvD;sFAAuD;EAAvD;;4CAAuD;AAAA;;EADzD;IAEE;wFACoF;EACtF;;EAGE;EAAA,aAAyE;EAAzE,mBAAyE;EAAzE,8BAAyE;EAAzE,wBAAyE;EAAzE,gCAAyE;EAAzE,qBAAyE;EAAzE,sBAAyE;EAAzE,mBAAyE;EAAzE,sBAAyE;IACzE,gBAAgB;IAChB;;AAFyE;;EA8BzE;EAAA,gBAAuD;EAAvD,uBAAuD;EAAvD,mBAAuD;EAAvD,6EAAuD;EAAvD,kBAAuD;EAAvD,iBAAuD;EAAvD;AAAuD;;EAAvD;EAAA,oCAAuD;AAAA;;EADzD;IAEE,sBAAsB;EACxB;;EAGE;EAAA,6EAAsE;EAAtE,kBAAsE;EAAtE,iBAAsE;EAAtE,yBAAsE;EAAtE,uBAAsE;EAAtE;AAAsE;;EAAtE;EAAA,oCAAsE;AAAA;;EAGxE;IACE,8BAA8B;EAChC;;EAGE;EAAA;AAAc;;EAAd;EAAA,uCAAc;EAAd;sFAAc;EAAd;;4CAAc;AAAA;;EAId;EAAA,aAA2F;EAA3F,mBAA2F;EAA3F,8BAA2F;EAA3F,YAA2F;EAA3F,wBAA2F;EAA3F,gCAA2F;EAA3F,yCAA2F;EAA3F,kBAA2F;EAA3F,mBAA2F;EAA3F,oBAA2F;EAA3F;AAA2F;;EAI3F;EAAA,oBAAmI;EAAnI,mBAAmI;EAAnI,wCAAmI;EAAnI,iBAAmI;EAAnI,gCAAmI;EAAnI,wCAAmI;EAAnI,oBAAmI;EAAnI,qBAAmI;EAAnI,oBAAmI;EAAnI,uBAAmI;EAAnI,6EAAmI;EAAnI,eAAmI;EAAnI;AAAmI;;EAAnI;EAAA,oCAAmI;AAAA;;EAAnI;EAAA,uCAAmI;EAAnI;sFAAmI;EAAnI;;4CAAmI;AAAA;;EAInI;EAAA,kBAAgB;EAAhB,mBAAgB;EAAhB,iBAAgB;EAAhB;AAAgB;;EAIhB;EAAA,mBAAwC;EAAxC,mBAAwC;EAAxC;AAAwC;;EAG1C,yBAAyB;;EAYvB;EAAA,kBAA4B;EAA5B,oBAA4B;EAA5B,gBAA4B;IAC5B;AAD4B;;EAK5B;EAAA,qEAA8G;EAA9G,wEAA8G;EAA9G,wEAA8G;EAA9G,mEAA8G;EAA9G,mEAA8G;EAA9G,6BAA8G;UAA9G,qBAA8G;EAA9G,kBAA8G;EAA9G,mBAA8G;EAA9G,gBAA8G;EAA9G,wBAA8G;EAA9G;AAA8G;;EAI9G;EAAA,mBAA4B;EAA5B,oBAA4B;EAA5B,gBAA4B;IAC5B;AAD4B;;EAQ9B;IACE,gCAAgC;EAClC;;EAGE;EAAA,mBAAc;EAAd,oBAAc;IACd;AADc;;EAIhB,4BAA4B;;EAgB5B,uBAAuB;;EAKvB,kCAAkC;AAhmDpC;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,UAAmB;IAAnB;EAAmB;;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;OAAnB;AAAmB;AAAnB;EAAA,sBAAmB;OAAnB;AAAmB;AAAnB;EAAA,qBAAmB;OAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;OAAnB;AAAmB;AAAnB;EAAA,yBAAmB;OAAnB;AAAmB;AAAnB;EAAA,uBAAmB;OAAnB;AAAmB;AAAnB;EAAA,uBAAmB;OAAnB;AAAmB;AAAnB;EAAA,yBAAmB;OAAnB;AAAmB;AAAnB;EAAA,wBAAmB;OAAnB;AAAmB;AAAnB;EAAA,qBAAmB;OAAnB;AAAmB;AAAnB;EAAA,wBAAmB;OAAnB;AAAmB;AAAnB;EAAA,uBAAmB;OAAnB;AAAmB;AAAnB;EAAA,wBAAmB;OAAnB;AAAmB;AAAnB;EAAA,qBAAmB;OAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4EAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;KAAnB;AAAmB;AAAnB;EAAA,oBAAmB;KAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,yDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6DAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sDAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+DAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB,8EAA8E;AAC9E;EACE,OAAO,4BAA4B,EAAE;EACrC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;;;yFAGyF;AACzF;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,4BAA4B,EAAE;AACvC;AACA;;EAEE;;;;;GAKC;EACD,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE;;IAEE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,wBAAwB;IACxB,mCAAmC;EACrC;AACF;;AAEA,6DAA6D;;AAoU7D;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;;;;;;;6EAO6E;AAC7E;EACE,6BAA6B;EAC7B,2BAA2B;;EAE3B,sBAAsB;EACtB,gCAAgC;EAChC,+BAA+B;;EAE/B,yBAAyB;EACzB,mCAAmC;;EAEnC,6BAA6B;EAC7B,sCAAsC;;EAEtC,iCAAiC;EACjC,qCAAqC;;EAErC,6BAA6B;EAC7B,4BAA4B;EAC5B,sBAAsB;;EAEtB,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;;EAE9B;;iCAE+B;;EAE/B,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;EAC7B,mCAAmC;EACnC,uCAAuC;;EAEvC,sEAAsE;EACtE,0CAA0C;EAC1C,mCAAmC;EACnC,iCAAiC;EACjC,uCAAuC;EACvC,qCAAqC;EACrC,0CAA0C;EAC1C,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;;;;EAIE,yEAAyE;EACzE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,8BAA8B;EAC9B,4BAA4B;EAC5B,oBAAoB;EACpB,iCAAiC;EACjC,oBAAoB;EACpB,+BAA+B;EAC/B,wBAAwB;EACxB,mCAAmC;EACnC,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;EAC/B,2BAA2B;EAC3B,oBAAoB;EACpB,gCAAgC;EAChC,yBAAyB;EACzB,qCAAqC;EACrC,8BAA8B;EAC9B,0BAA0B;EAC1B,iCAAiC;EACjC,aAAa;EACb,WAAW;EACX,cAAc;EACd;;;0BAGwB;EACxB,6BAA6B;EAC7B,wDAAwD;AAC1D;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,sBAAsB;EACtB,iCAAiC;EACjC,oBAAoB;EACpB,+BAA+B;EAC/B,wBAAwB;EACxB,mCAAmC;EACnC,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;EAChC,2BAA2B;EAC3B,qBAAqB;EACrB,gCAAgC;EAChC,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;EAC9B,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;EAC1C;;uEAEqE;EACrE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB;;qGAEmG;AACrG;;AAEA;EACE,kBAAkB;AACpB;;AAEA,qFAAqF;AACrF;EACE;;uEAEqE;AACvE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB;;qGAEmG;AACrG;;AAEA;EACE;;uEAEqE;AACvE;;AAEA;EACE;;uEAEqE;AACvE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,yEAAyE;EACzE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB;oEACkE;EAClE,qCAAqC;EACrC,sDAAsD;EACtD,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE,uBAAuB;EACvB,cAAc;EACd,MAAM;AACR;;AAEA;EACE,aAAa;AACf;;AAEA,uEAAuE;AACvE;EACE,sBAAsB;EACtB,WAAW;EACX,MAAM;EACN,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;EACxB,qBAAqB;EACrB,gEAAgE;EAChE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,+CAA+C;EAC/C,6BAA6B;EAC7B,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,+CAA+C;EAC/C,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,sDAAsD;EACtD,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;iHAC+G;EAC/G,qCAAqC;EACrC,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,0CAA0C;EAC1C,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,sDAAsD;EACtD,eAAe;AACjB;;AAEA;EACE,iDAAiD;EACjD,qCAAqC;AACvC;;AAEA,sEAAsE;AACtE;EACE,sDAAsD;EACtD,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,mDAAmD;AACrD;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE;iHAC+G;EAC/G,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oCAAoC;EACpC,kBAAkB;EAClB;6EAC2E;EAC3E,YAAY;EACZ,uDAAuD;EACvD,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,gFAAgF;AAClF;;AAEA;EACE,2CAA2C;EAC3C;sEACoE;EACpE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,qBAAqB;EACrB,WAAW;EACX,2CAA2C;EAC3C,cAAc;EACd,oCAAoC;EACpC,mBAAmB;EACnB,+BAA+B;EAC/B;;+CAE6C;EAC7C,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mCAAmC;EACnC,sDAAsD;EACtD,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;EACb,iFAAiF;EACjF,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,2CAA2C;EAC3C;;kGAEgG;EAChG,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,+BAA+B;IAC/B,eAAe;EACjB;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA,+DAA+D;AAC/D;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,WAAW;EACX,mHAAmH;AACrH;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,wCAAwC;EACxC,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mCAAmC;EACnC,gBAAgB;EAChB,sDAAsD;EACtD,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,WAAW;EACX,eAAe;EACf,aAAa;EACb,cAAc;EACd,aAAa;AACf;;AAEA;EACE,OAAO;EACP,eAAe;EACf,aAAa;EACb,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,0GAA0G;AAC5G;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,sDAAsD;EACtD,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,2EAA2E;AAC7E;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,yEAAyE;EACzE,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2EAA2E;EAC3E,6BAAqB;UAArB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB;sFACoF;EACpF;;2CAEyC;AAC3C;;AAEA;;;;;;;;GAQG;;AAEH;EACE,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC;;0CAEwC;AAC1C;;AAEA;;2BAE2B;AAC3B;EACE,kDAAkD;EAClD;iGAC+F;EAC/F;;uDAEqD;AACvD;;AAEA;EACE,kDAAkD;EAClD,+CAA+C;AACjD;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oCAAoC;EACpC,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;EACf,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,iEAAiE;EACjE,kBAAkB;EAClB,qDAAqD;EACrD,yDAAyD;EACzD,6CAA6C;EAC7C,+CAA+C;EAC/C,gBAAgB;EAChB,qBAAqB;EACrB,6CAA6C;EAC7C,yHAAyH;AAC3H;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,2EAA2E;EAC3E,oFAAoF;EACpF,2FAA2F;AAC7F;;AAEA;EACE,2CAA2C;EAC3C;kHACgH;EAChH,qDAAqD;EACrD,6DAA6D;AAC/D;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,6CAA6C;EAC7C,yCAAyC;EACzC,uDAAuD;EACvD,sDAAsD;AACxD;;AAEA;EACE,+CAA+C;EAC/C,2CAA2C;EAC3C,yDAAyD;EACzD,uDAAuD;EACvD,qDAAqD;AACvD;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,4BAA4B;EAC5B,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,0BAA0B;EAC1B,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,2CAA2C;EAC3C;uHACqH;EACrH,qDAAqD;EACrD,6DAA6D;AAC/D;;AAEA;EACE,iDAAiD;EACjD;;wCAEsC;AACxC;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;0FACwF;AAC1F;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV;oIACkI;EAClI,yCAAyC;EACzC,4EAA4E;AAC9E;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV;;uFAEqF;EACrF,mEAAmE;AACrE;;AAEA;EACE,KAAK,yCAAyC,EAAE;EAChD,OAAO,wCAAwC,EAAE;AACnD;;AAEA;EACE,KAAK,8CAA8C,EAAE,YAAY,EAAE;EACnE,OAAO,+CAA+C,EAAE,WAAW,EAAE;AACvE;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,2CAA2C;EAC3C,oBAAoB;EACpB;;sFAEoF;EACpF,6BAA6B;EAC7B,qBAAqB;EACrB;;+CAE6C;EAC7C,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C;;;+CAG6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iFAAiF;EACjF,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,8BAA8B;EAC9B,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,sDAAsD;EACtD,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;;uFAEqF;EACrF,6BAA6B;EAC7B;;+CAE6C;AAC/C;;AAEA;EACE,oCAAoC;AACtC;;;AAGA;EACE,aAAa;EACb,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,2CAA2C;EAC7C;;EAEA;IACE,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;AAEF;;AA+JA,yCAAyC;AACzC;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,0BAA0B;IAC1B,UAAU;EACZ;EACA;IACE,2BAA2B;IAC3B,UAAU;EACZ;AACF;;AAEA;EACE,2DAA2D;AAC7D;;AAroDA;EAAA,4CAgpDA;EAhpDA,oDAgpDA;EAhpDA,4CAgpDA;EAhpDA,8CAgpDA;EAhpDA,4CAgpDA;EAhpDA,oDAgpDA;EAhpDA,kDAgpDA;EAhpDA,wCAgpDA;EAhpDA,gDAgpDA;EAhpDA,8DAgpDA;EAhpDA,oDAgpDA;EAhpDA,0CAgpDA;EAhpDA,0DAgpDA;EAhpDA,4CAgpDA;EAhpDA,oDAgpDA;EAhpDA,gDAgpDA;EAhpDA,wDAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,mBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,0BAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,0BAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,0BAgpDA;EAhpDA,QAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,0BAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,0BAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,2GAgpDA;EAhpDA,yGAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,2GAgpDA;EAhpDA,yGAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,0BAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,yBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,iBAgpDA;EAhpDA,iBAgpDA;EAhpDA;AAgpDA;;AAhpDA;;EAAA;IAAA;EAgpDA;AAAA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,sBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,sBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,4DAgpDA;EAhpDA,oEAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,4DAgpDA;EAhpDA,mEAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,4DAgpDA;EAhpDA,mEAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,4DAgpDA;EAhpDA,oEAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,qEAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,0EAgpDA;EAhpDA,8FAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,iDAgpDA;EAhpDA,qDAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,0CAgpDA;EAhpDA,mDAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,6CAgpDA;EAhpDA,uDAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,+EAgpDA;EAhpDA,mGAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,6EAgpDA;EAhpDA,iGAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,gFAgpDA;EAhpDA,oGAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,gCAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,0BAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,8BAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,2GAgpDA;EAhpDA,yGAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,2GAgpDA;EAhpDA,yGAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,2GAgpDA;EAhpDA,yGAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,8BAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,2GAgpDA;EAhpDA,yGAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,2GAgpDA;EAhpDA,yGAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,2GAgpDA;EAhpDA,yGAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,mBAgpDA;EAhpDA,mBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,6EAgpDA;EAhpDA,iGAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,sBAgpDA;EAhpDA,8BAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,8BAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,0BAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,sBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,qBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,qBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,sBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,iDAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,qBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,sBAgpDA;EAhpDA,8BAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,0CAgpDA;EAhpDA,uDAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,qBAgpDA;EAhpDA,yBAgpDA;EAhpDA,2BAgpDA;EAhpDA,yBAgpDA;EAhpDA,0BAgpDA;EAhpDA,+BAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA,yBAgpDA;EAhpDA,0BAgpDA;EAhpDA,wBAgpDA;EAhpDA,yBAgpDA;EAhpDA,8BAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,sBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,qBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,mBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,0EAgpDA;EAhpDA,8FAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,0BAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;;EAAA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;AAAA;;AAhpDA;;EAAA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;AAAA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,sBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,sBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,sBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,sBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,sBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,sBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,sBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,qCAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;;EAAA;IAAA;EAgpDA;AAAA;;AAhpDA;;EAAA;IAAA;EAgpDA;AAAA;;AAhpDA;;EAAA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA,uBAgpDA;IAhpDA,sDAgpDA;IAhpDA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA,qBAgpDA;IAhpDA;EAgpDA;;EAhpDA;IAAA,kBAgpDA;IAhpDA;EAgpDA;;EAhpDA;IAAA,oBAgpDA;IAhpDA;EAgpDA;;EAhpDA;IAAA,iBAgpDA;IAhpDA;EAgpDA;;EAhpDA;IAAA,mBAgpDA;IAhpDA;EAgpDA;;EAhpDA;IAAA,iBAgpDA;IAhpDA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA,iBAgpDA;IAhpDA;EAgpDA;;EAhpDA;IAAA,mBAgpDA;IAhpDA;EAgpDA;;EAhpDA;IAAA,kBAgpDA;IAhpDA;EAgpDA;;EAhpDA;IAAA,kBAgpDA;IAhpDA;EAgpDA;;EAhpDA;IAAA,mBAgpDA;IAhpDA;EAgpDA;;EAhpDA;IAAA;EAgpDA;AAAA;;AAhpDA;;EAAA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA,uBAgpDA;IAhpDA,8DAgpDA;IAhpDA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA,kBAgpDA;IAhpDA;EAgpDA;;EAhpDA;IAAA,mBAgpDA;IAhpDA;EAgpDA;;EAhpDA;IAAA,iBAgpDA;IAhpDA;EAgpDA;;EAhpDA;IAAA,eAgpDA;IAhpDA;EAgpDA;;EAhpDA;IAAA,mBAgpDA;IAhpDA;EAgpDA;;EAhpDA;IAAA,mBAgpDA;IAhpDA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA,0CAgpDA;IAhpDA,uDAgpDA;IAhpDA;EAgpDA;;EAhpDA;IAAA,0BAgpDA;IAhpDA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA,0EAgpDA;IAhpDA,8FAgpDA;IAhpDA;EAgpDA;AAAA;;AAhpDA;;EAAA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA,kBAgpDA;IAhpDA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA,kBAgpDA;IAhpDA;EAgpDA;;EAhpDA;IAAA,mBAgpDA;IAhpDA;EAgpDA;;EAhpDA;IAAA,mBAgpDA;IAhpDA;EAgpDA;AAAA;;AAhpDA;;EAAA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;;EAhpDA;IAAA;EAgpDA;AAAA;;AAhpDA;;EAAA;IAAA;EAgpDA;AAAA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,wBAgpDA;UAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,gBAgpDA;EAhpDA,uBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,gBAgpDA;EAhpDA,uBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,gBAgpDA;EAhpDA,uBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,sBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,WAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,cAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,qBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,kBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,eAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,WAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,qBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA,oBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA,qBAgpDA;EAhpDA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA;;AAhpDA;EAAA;AAgpDA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* Shimmer sweep — used on the currently-executing step row in ExecutionFeed */\n@keyframes shimmer {\n  0%   { transform: translateX(-100%); }\n  100% { transform: translateX(200%); }\n}\n\n/* Text-shimmer for an agent warm-up caption — a gradient sweeps across the glyphs so the line reads\n   as part of the loading skeleton rather than a separate static label below it.\n   `.ma-weave-shimmer` is Weave's original name, kept so its markup is untouched; `.shimmer-text` is\n   the neutral alias every other module (Testing) uses, so there is one implementation. */\n@keyframes ma-weave-shimmer {\n  0%   { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n.ma-weave-shimmer,\n.shimmer-text {\n  background: linear-gradient(\n    90deg,\n    hsl(var(--muted-foreground)) 0%,\n    hsl(var(--primary)) 50%,\n    hsl(var(--muted-foreground)) 100%\n  );\n  background-size: 200% 100%;\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  animation: ma-weave-shimmer 2.6s linear infinite;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .ma-weave-shimmer,\n  .shimmer-text {\n    animation: none;\n    background: none;\n    -webkit-background-clip: initial;\n    background-clip: initial;\n    color: hsl(var(--muted-foreground));\n  }\n}\n\n/* Salesforce AI IDE Design System - Clean and Professional */\n\n@layer base {\n  :root {\n    /* Light theme base colors — subtle warm gray */\n    --background: 220 10% 98%;\n    /* Slightly darker body text improves contrast vs soft backgrounds (WCAG AA). */\n    --foreground: 222 24% 9%;\n\n    /* Card and surface colors */\n    --card: 0 0% 100%;\n    --card-foreground: 222 24% 9%;\n    --card-elevated: 220 14% 98%;\n\n    /* Popover colors */\n    --popover: 0 0% 100%;\n    --popover-foreground: 222 24% 9%;\n\n    /* Salesforce Brand — ~43% L keeps blue on white ≥4.5:1 for normal links/labels */\n    --primary: 214 100% 43%;\n    --primary-foreground: 0 0% 100%;\n    --primary-glow: 214 100% 52%;\n\n    /* Secondary colors */\n    --secondary: 220 14% 92%;\n    --secondary-foreground: 222 24% 9%;\n\n    /* Muted — darker muted-foreground so helper text passes AA on white AND on --muted */\n    --muted: 220 14% 92%;\n    --muted-foreground: 215 22% 30%;\n\n    /* Accent fills use white text — keep L ≤ ~48% for ≥4.5:1 vs white */\n    --accent: 214 100% 47%;\n    --accent-foreground: 0 0% 100%;\n    --accent-glow: 214 100% 56%;\n    --accent-warm: 16 76% 44%;\n    --accent-warm-foreground: 0 0% 100%;\n    --accent-warm-soft: 22 75% 90%;\n    --charcoal: 220 10% 14%;\n    --charcoal-foreground: 0 0% 100%;\n\n    /* Status colors */\n    --destructive: 0 84% 55%;\n    --destructive-foreground: 0 0% 100%;\n    --success: 142 76% 36%;\n    --success-foreground: 0 0% 100%;\n    --warning: 32 95% 44%;\n    --warning-foreground: 0 0% 100%;\n    /* Text-safe state colours. The base --success/--warning are tuned as FILLS; used as text on\n       their own 10% tint they measure 2.1:1 and 2.8:1 against a light card — well under WCAG AA.\n       These darker/lighter counterparts clear 4.5:1 in both themes and are what text should use. */\n    --success-strong: 142 76% 26%;\n    --warning-strong: 32 95% 27%;\n    --destructive-strong: 0 74% 38%;\n\n    /* Border / input — a bit stronger vs white for focus outlines & dividers */\n    --border: 214 18% 76%;\n    --input: 214 18% 80%;\n    --ring: 214 100% 43%;\n\n    /* Typography — subtitles/captions must pass AA on --muted (92% L) */\n    --heading-primary: 222 24% 7%;\n    --heading-secondary: 214 100% 43%;\n    --heading-accent: 214 100% 47%;\n    --body-text: 222 24% 7%;\n    --subtitle-text: 215 18% 34%;\n    --caption-text: 215 18% 34%;\n\n    /* File Explorer Tree colors */\n    --file-explorer-hover: 210 40% 93%;\n    --file-explorer-hover-foreground: 222 47% 11%;\n    --file-explorer-selected: 214 100% 96%;\n    --file-explorer-selected-foreground: 222 47% 11%;\n    --file-explorer-selected-border: 214 100% 60%;\n\n    /* Sidebar colors */\n    --sidebar-background: 220 14% 93%;\n    --sidebar-foreground: 222 24% 9%;\n    --sidebar-primary: 214 100% 43%;\n    --sidebar-primary-foreground: 0 0% 100%;\n    --sidebar-accent: 220 14% 90%;\n    --sidebar-accent-foreground: 222 24% 9%;\n    --sidebar-border: 214 18% 76%;\n    --sidebar-ring: 214 100% 43%;\n\n    /* Gradients — aligned with light-mode primary for readable gradient text */\n    --gradient-primary: linear-gradient(135deg, hsl(214 100% 48%), hsl(195 100% 58%));\n    --gradient-card: linear-gradient(145deg, hsl(0 0% 100%), hsl(0 0% 98%));\n    --gradient-accent: linear-gradient(120deg, hsl(214 100% 56%), hsl(214 100% 64%));\n\n    /* Shadows */\n    --shadow-card: 0 1px 3px 0 hsl(0 0% 0% / 0.1), 0 1px 2px -1px hsl(0 0% 0% / 0.1);\n    --shadow-glow: 0 0 20px hsl(214 100% 60% / 0.3);\n    --shadow-elevated: 0 4px 6px -1px hsl(0 0% 0% / 0.1), 0 2px 4px -2px hsl(0 0% 0% / 0.1);\n\n    /* Animation variables */\n    --transition-smooth: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n\n    --radius: 0.75rem;\n\n    /* Studio paper theme tokens. Namespaced --rs-* so route-level theme wrappers\n       can remap stock bg-card/text-foreground/border classes without touching\n       every component. */\n    --rs-paper: 220 23% 98%;\n    --rs-paper-edge: 216 28% 94%;\n    --rs-card: 0 0% 100%;\n    --rs-card-edge: 216 24% 88%;\n    --rs-ink: 222 20% 8%;\n    --rs-ink-soft: 222 13% 28%;\n    --rs-ink-mute: 217 13% 43%;\n    --rs-warm: 217 91% 48%;\n    --rs-warm-soft: 214 95% 93%;\n    --rs-plum: 176 84% 32%;\n    --rs-plum-soft: 174 48% 90%;\n    --rs-leaf: 158 64% 32%;\n    --rs-leaf-soft: 152 35% 90%;\n    --rs-amber: 32 95% 44%;\n    --rs-amber-soft: 40 80% 92%;\n  }\n\n  .dark {\n    /* Dark theme base colors */\n    --background: 222 20% 12%;\n    --foreground: 210 40% 95%;\n\n    /* Card and surface colors */\n    --card: 222 18% 15%;\n    --card-foreground: 210 40% 95%;\n    --card-elevated: 222 16% 18%;\n\n    /* Popover colors */\n    --popover: 222 20% 10%;\n    --popover-foreground: 210 40% 95%;\n\n    /* Salesforce Brand Colors */\n    --primary: 214 100% 60%;\n    --primary-foreground: 0 0% 100%;\n    --primary-glow: 214 100% 70%;\n\n    /* Secondary colors */\n    --secondary: 222 16% 15%;\n    --secondary-foreground: 210 40% 90%;\n\n    /* Muted colors */\n    --muted: 222 14% 12%;\n    --muted-foreground: 215 16% 65%;\n\n    /* Accent colors */\n    --accent: 214 100% 65%;\n    --accent-foreground: 0 0% 100%;\n    --accent-glow: 214 100% 75%;\n    --accent-warm: 16 80% 58%;\n    --accent-warm-foreground: 0 0% 100%;\n    --accent-warm-soft: 22 35% 22%;\n    --charcoal: 220 10% 8%;\n    --charcoal-foreground: 0 0% 100%;\n\n    /* Status colors */\n    --destructive: 0 75% 60%;\n    --destructive-foreground: 0 0% 100%;\n    --success: 142 76% 36%;\n    --success-foreground: 0 0% 100%;\n    --warning: 32 95% 44%;\n    --warning-foreground: 222 24% 7%;\n    --success-strong: 142 60% 58%;\n    --warning-strong: 32 95% 62%;\n    --destructive-strong: 0 85% 70%;\n\n    /* Border and input colors */\n    --border: 222 14% 18%;\n    --input: 222 14% 15%;\n    --ring: 214 100% 60%;\n\n    /* Typography colors */\n    --heading-primary: 210 40% 98%;\n    --heading-secondary: 214 100% 70%;\n    --heading-accent: 214 100% 75%;\n    --body-text: 210 40% 95%;\n    --subtitle-text: 215 16% 75%;\n    --caption-text: 215 16% 65%;\n\n    /* File Explorer Tree dark colors */\n    --file-explorer-hover: 222 16% 18%;\n    --file-explorer-hover-foreground: 210 40% 95%;\n    --file-explorer-selected: 214 80% 14%;\n    --file-explorer-selected-foreground: 210 40% 98%;\n    --file-explorer-selected-border: 214 100% 60%;\n\n    /* Sidebar colors */\n    --sidebar-background: 222 28% 6%;\n    --sidebar-foreground: 210 40% 85%;\n    --sidebar-primary: 214 100% 60%;\n    --sidebar-primary-foreground: 0 0% 100%;\n    --sidebar-accent: 222 16% 12%;\n    --sidebar-accent-foreground: 210 40% 90%;\n    --sidebar-border: 222 14% 15%;\n    --sidebar-ring: 214 100% 60%;\n\n    /* Gradients */\n    --gradient-primary: linear-gradient(135deg, hsl(214 100% 60%), hsl(195 100% 65%));\n    --gradient-card: linear-gradient(145deg, hsl(222 20% 10%), hsl(222 18% 12%));\n    --gradient-accent: linear-gradient(120deg, hsl(214 100% 65%), hsl(214 100% 75%));\n\n    /* Shadows */\n    --shadow-card: 0 4px 12px -2px hsl(222 24% 4% / 0.3);\n    --shadow-glow: 0 0 20px hsl(214 100% 60% / 0.4);\n    --shadow-elevated: 0 8px 24px -4px hsl(222 24% 4% / 0.4);\n\n    --rs-paper: 217 31% 7%;\n    --rs-paper-edge: 215 25% 17%;\n    --rs-card: 215 29% 12%;\n    --rs-card-edge: 215 21% 24%;\n    --rs-ink: 214 32% 93%;\n    --rs-ink-soft: 214 18% 78%;\n    --rs-ink-mute: 215 16% 68%;\n    --rs-warm: 213 94% 68%;\n    --rs-warm-soft: 213 58% 18%;\n    --rs-plum: 185 96% 43%;\n    --rs-plum-soft: 185 58% 17%;\n    --rs-leaf: 158 64% 52%;\n    --rs-leaf-soft: 152 30% 14%;\n    --rs-amber: 41 84% 65%;             /* #f0c25a */\n    --rs-amber-soft: 41 35% 16%;\n  }\n}\n\n@layer base {\n  * {\n    @apply border-border;\n  }\n\n  html,\n  body,\n  #root {\n    @apply h-full w-full m-0;\n  }\n\n  body {\n    @apply bg-background text-foreground antialiased;\n    font-family: Inter, ui-sans-serif, system-ui, sans-serif;\n  }\n\n  /* Custom gradient backgrounds */\n  .gradient-primary {\n    background: var(--gradient-primary);\n  }\n\n  .gradient-card {\n    background: var(--gradient-card);\n  }\n\n  .gradient-accent {\n    background: var(--gradient-accent);\n  }\n\n  /* Custom shadows */\n  .shadow-card {\n    box-shadow: var(--shadow-card);\n  }\n\n  .shadow-glow {\n    box-shadow: var(--shadow-glow);\n  }\n\n  .shadow-elevated {\n    box-shadow: var(--shadow-elevated);\n  }\n\n  /* Smooth transitions */\n  .transition-smooth {\n    transition: var(--transition-smooth);\n  }\n\n  /* Custom scrollbar — vertical only, inset thumb (production-style) */\n  .custom-scrollbar {\n    overflow-x: hidden;\n    scrollbar-gutter: stable;\n    scrollbar-width: thin;\n    scrollbar-color: hsl(var(--muted-foreground) / 0.32) transparent;\n  }\n\n  .custom-scrollbar::-webkit-scrollbar {\n    width: 10px;\n  }\n\n  .custom-scrollbar::-webkit-scrollbar-track {\n    margin: 6px 0;\n    background: transparent;\n    border-radius: 999px;\n  }\n\n  .custom-scrollbar::-webkit-scrollbar-thumb {\n    background: hsl(var(--muted-foreground) / 0.28);\n    border: 2px solid transparent;\n    background-clip: padding-box;\n    border-radius: 999px;\n  }\n\n  .custom-scrollbar::-webkit-scrollbar-thumb:hover {\n    background: hsl(var(--muted-foreground) / 0.45);\n    border: 2px solid transparent;\n    background-clip: padding-box;\n  }\n\n  /* Diff / code block horizontal scrollbar — slim IDE-style thumb */\n  .nc-diff-scroll {\n    scrollbar-width: thin;\n    scrollbar-color: hsl(var(--muted-foreground) / 0.28) transparent;\n  }\n  .nc-diff-scroll::-webkit-scrollbar {\n    height: 5px;\n  }\n  .nc-diff-scroll::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  .nc-diff-scroll::-webkit-scrollbar-thumb {\n    background: hsl(var(--muted-foreground) / 0.28);\n    border-radius: 9999px;\n  }\n  .nc-diff-scroll::-webkit-scrollbar-thumb:hover {\n    background: hsl(var(--muted-foreground) / 0.5);\n  }\n}\n\n.poweredBy {\n  display: none !important;\n  visibility: hidden !important;\n}\n\n/* ─────────────────────────────────────────────────────────────────────────\n   rs-theme: opt-in Templates.html design wrapper.\n   Wrap a route subtree with class=\"rs-theme\" (or via <PaperTheme>) to remap\n   the standard CSS tokens to the --rs-* palette. Components using\n   bg-card / text-foreground / border / etc. inherit the cream-paper look\n   automatically — no per-component edits.\n   Works in both light and dark because --rs-* themselves are split by mode.\n   ─────────────────────────────────────────────────────────────────────────*/\n.rs-theme {\n  --background: var(--rs-paper);\n  --foreground: var(--rs-ink);\n\n  --card: var(--rs-card);\n  --card-foreground: var(--rs-ink);\n  --card-elevated: var(--rs-card);\n\n  --popover: var(--rs-card);\n  --popover-foreground: var(--rs-ink);\n\n  --muted: var(--rs-paper-edge);\n  --muted-foreground: var(--rs-ink-mute);\n\n  --secondary: var(--rs-paper-edge);\n  --secondary-foreground: var(--rs-ink);\n\n  --border: var(--rs-card-edge);\n  --input: var(--rs-card-edge);\n  --ring: var(--rs-warm);\n\n  --primary: var(--rs-warm);\n  --primary-foreground: 0 0% 100%;\n  --primary-glow: var(--rs-warm);\n\n  /* Semantic status colors stay native — destructive must read as red on\n     ANY page, success as green, warning as amber. Only the brand surfaces\n     shift to the warm palette. */\n\n  --accent: var(--rs-plum);\n  --accent-foreground: 0 0% 100%;\n  --accent-warm: var(--rs-warm);\n  --accent-warm-foreground: 0 0% 100%;\n  --accent-warm-soft: var(--rs-warm-soft);\n\n  /* Sidebar — slightly warmer surface to separate from the main paper */\n  --sidebar-background: var(--rs-paper-edge);\n  --sidebar-foreground: var(--rs-ink);\n  --sidebar-primary: var(--rs-warm);\n  --sidebar-primary-foreground: 0 0% 100%;\n  --sidebar-accent: var(--rs-warm-soft);\n  --sidebar-accent-foreground: var(--rs-ink);\n  --sidebar-border: var(--rs-card-edge);\n  --sidebar-ring: var(--rs-warm);\n}\n\n.rs-theme h1,\n.rs-theme h2,\n.rs-theme h3,\n.rs-theme h4 {\n  font-family: \"Space Grotesk\", Inter, ui-sans-serif, system-ui, sans-serif;\n  letter-spacing: 0;\n}\n\n.studio-shell.rs-theme {\n  --background: 220 22% 97%;\n  --foreground: 225 20% 10%;\n  --card: 0 0% 100%;\n  --card-foreground: 225 20% 10%;\n  --card-elevated: 220 19% 94%;\n  --popover: 0 0% 100%;\n  --popover-foreground: 225 20% 10%;\n  --muted: 220 18% 92%;\n  --muted-foreground: 220 10% 39%;\n  --secondary: 220 18% 92%;\n  --secondary-foreground: 225 20% 10%;\n  --border: 220 14% 81%;\n  --input: 220 14% 81%;\n  --ring: 224 17% 24%;\n  --primary: 224 17% 24%;\n  --primary-foreground: 0 0% 100%;\n  --primary-glow: 224 14% 36%;\n  --accent: 35 84% 54%;\n  --accent-foreground: 225 20% 10%;\n  --accent-warm: 35 84% 54%;\n  --accent-warm-foreground: 225 20% 10%;\n  --accent-warm-soft: 35 86% 91%;\n  --studio-line: 220 14% 81%;\n  --studio-line-strong: 224 17% 24%;\n  height: 100vh;\n  width: 100%;\n  overflow: clip;\n  background:\n    linear-gradient(145deg, hsl(var(--primary) / 0.07), transparent 34%),\n    linear-gradient(315deg, hsl(var(--accent) / 0.055), transparent 38%),\n    hsl(var(--background));\n  color: hsl(var(--foreground));\n  font-family: Inter, ui-sans-serif, system-ui, sans-serif;\n}\n\n.dark .studio-shell.rs-theme {\n  --background: 228 22% 6%;\n  --foreground: 210 35% 94%;\n  --card: 226 20% 10%;\n  --card-foreground: 210 35% 94%;\n  --card-elevated: 226 18% 13%;\n  --popover: 226 20% 10%;\n  --popover-foreground: 210 35% 94%;\n  --muted: 226 17% 15%;\n  --muted-foreground: 213 15% 69%;\n  --secondary: 226 17% 15%;\n  --secondary-foreground: 210 35% 94%;\n  --border: 221 16% 24%;\n  --input: 221 16% 24%;\n  --ring: 220 24% 72%;\n  --primary: 220 24% 72%;\n  --primary-foreground: 228 22% 6%;\n  --primary-glow: 220 30% 80%;\n  --accent: 224 14% 22%;\n  --accent-foreground: 210 35% 94%;\n  --accent-warm: 31 82% 66%;\n  --accent-warm-foreground: 228 22% 6%;\n  --accent-warm-soft: 30 32% 14%;\n  --studio-line: 220 16% 24%;\n  --studio-line-strong: 220 24% 72%;\n}\n\n.studio-sidebar {\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border-right: 1px solid hsl(var(--border));\n  background:\n    linear-gradient(180deg, hsl(var(--card) / 0.92), hsl(var(--muted) / 0.64)),\n    linear-gradient(90deg, hsl(var(--primary) / 0.08), transparent 52%);\n  padding: 20px 14px;\n}\n\n.studio-sidebar::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  background:\n    linear-gradient(180deg, hsl(var(--primary) / 0.16), transparent 34%),\n    linear-gradient(90deg, transparent calc(100% - 1px), hsl(var(--primary) / 0.34) calc(100% - 1px));\n}\n\n.studio-sidebar > * {\n  position: relative;\n}\n\n/* Override bg-sidebar solid color with the branded gradient for @ncoder/ui Sidebar */\n.studio-shell [data-sidebar=\"sidebar\"] {\n  background:\n    linear-gradient(180deg, hsl(var(--card) / 0.92), hsl(var(--muted) / 0.64)),\n    linear-gradient(90deg, hsl(var(--primary) / 0.08), transparent 52%);\n}\n\n.studio-shell [data-sidebar=\"sidebar\"]::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  background:\n    linear-gradient(180deg, hsl(var(--primary) / 0.16), transparent 34%),\n    linear-gradient(90deg, transparent calc(100% - 1px), hsl(var(--primary) / 0.34) calc(100% - 1px));\n}\n\n.dark .studio-shell [data-sidebar=\"sidebar\"] {\n  background:\n    linear-gradient(180deg, hsl(var(--card) / 0.96), hsl(var(--background) / 0.94)),\n    linear-gradient(90deg, hsl(var(--primary) / 0.14), transparent 58%);\n}\n\n.dark .studio-sidebar {\n  background:\n    linear-gradient(180deg, hsl(var(--card) / 0.96), hsl(var(--background) / 0.94)),\n    linear-gradient(90deg, hsl(var(--primary) / 0.14), transparent 58%);\n}\n\n.studio-brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n  padding: 6px 8px;\n  border-radius: 8px;\n  color: hsl(var(--foreground));\n  font-size: 18px;\n  font-weight: 800;\n  font-family: \"Space Grotesk\", Inter, ui-sans-serif, system-ui, sans-serif;\n  text-decoration: none;\n  letter-spacing: 0;\n}\n\n.studio-brand > span:last-child {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.studio-brand-mark {\n  display: grid;\n  place-items: center;\n  width: 26px;\n  height: 26px;\n  border-radius: 8px;\n  background:\n    linear-gradient(135deg, hsl(var(--primary)), hsl(var(--accent)));\n  color: hsl(var(--primary-foreground));\n  font-family: \"JetBrains Mono\", ui-monospace, monospace;\n  font-size: 14px;\n}\n\n/* Collapsed sidebar: brand — icon only, centered */\n[data-collapsible=\"icon\"] .studio-brand {\n  justify-content: center;\n  padding: 6px 0;\n  gap: 0;\n}\n\n[data-collapsible=\"icon\"] .studio-brand > span:last-child {\n  display: none;\n}\n\n/* Collapsed sidebar: org dropdown — pop out to the right of the rail */\n[data-collapsible=\"icon\"] .studio-org-menu {\n  left: calc(100% + 8px);\n  right: auto;\n  top: 0;\n  min-width: 220px;\n}\n\n/* Collapsed sidebar: org card — badge only, centered */\n[data-collapsible=\"icon\"] .studio-org-card {\n  justify-content: center;\n  padding: 8px;\n  border: none;\n  background: transparent;\n  box-shadow: none;\n  transform: none;\n}\n\n[data-collapsible=\"icon\"] .studio-org-card:hover {\n  background: hsl(var(--muted) / 0.68);\n  transform: none;\n}\n\n[data-collapsible=\"icon\"] .studio-org-card > *:not(:first-child) {\n  display: none;\n  width: 0;\n  overflow: hidden;\n}\n\n.studio-nav {\n  flex: 1;\n  min-width: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  scrollbar-gutter: stable;\n  scrollbar-width: thin;\n  scrollbar-color: hsl(var(--muted-foreground) / 0.32) transparent;\n  padding: 18px 0;\n}\n\n.studio-nav::-webkit-scrollbar {\n  width: 10px;\n}\n\n.studio-nav::-webkit-scrollbar-track {\n  margin: 6px 0;\n  background: transparent;\n  border-radius: 999px;\n}\n\n.studio-nav::-webkit-scrollbar-thumb {\n  background: hsl(var(--muted-foreground) / 0.28);\n  border: 2px solid transparent;\n  background-clip: padding-box;\n  border-radius: 999px;\n}\n\n.studio-nav::-webkit-scrollbar-thumb:hover {\n  background: hsl(var(--muted-foreground) / 0.45);\n  border: 2px solid transparent;\n  background-clip: padding-box;\n}\n\n.studio-nav-group {\n  margin-bottom: 24px;\n  min-width: 0;\n}\n\n.studio-nav-label {\n  padding: 0 6px 10px;\n  color: hsl(var(--muted-foreground));\n  font-family: \"JetBrains Mono\", ui-monospace, monospace;\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.studio-nav-link {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  min-height: 38px;\n  padding: 9px 12px;\n  border-radius: 8px;\n  box-sizing: border-box;\n  color: hsl(var(--foreground) / 0.78);\n  font-size: 14px;\n  font-weight: 500;\n  text-decoration: none;\n  transition: background 140ms ease, color 140ms ease;\n}\n\n.studio-nav-link:hover {\n  background: hsl(var(--muted) / 0.68);\n  color: hsl(var(--foreground));\n}\n\n.studio-nav-link svg {\n  flex-shrink: 0;\n}\n\n.studio-nav-link-active {\n  background:\n    linear-gradient(90deg, hsl(var(--primary)), color-mix(in oklab, hsl(var(--primary)), hsl(var(--accent)) 28%));\n  color: hsl(var(--primary-foreground));\n  box-shadow: inset 3px 0 0 hsl(var(--accent));\n  padding-right: 26px;\n}\n\n.studio-nav-link-active:has(.studio-nav-count) {\n  padding-right: 12px;\n}\n\n.studio-nav-link-active::after {\n  content: \"\";\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 5px;\n  height: 5px;\n  border-radius: 999px;\n  background: hsl(var(--primary-foreground));\n  opacity: 0.78;\n  pointer-events: none;\n}\n\n.studio-nav-count {\n  flex-shrink: 0;\n  min-width: 28px;\n  border-radius: 5px;\n  background: hsl(var(--muted));\n  color: hsl(var(--muted-foreground));\n  padding: 2px 6px;\n  text-align: center;\n  font-family: \"JetBrains Mono\", ui-monospace, monospace;\n  font-size: 10px;\n}\n\n.studio-nav-link-active .studio-nav-count {\n  background: hsl(var(--primary-foreground) / 0.16);\n  color: hsl(var(--primary-foreground));\n}\n\n/* @ncoder/ui SidebarMenuButton — match studio-nav-link visual style */\n.studio-nav [data-sidebar=\"group-label\"] {\n  font-family: \"JetBrains Mono\", ui-monospace, monospace;\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: hsl(var(--muted-foreground));\n}\n\n.studio-nav [data-sidebar=\"menu-button\"] {\n  color: hsl(var(--foreground) / 0.78);\n  font-size: 14px;\n  font-weight: 500;\n  min-height: 38px;\n  border-radius: 8px;\n  gap: 10px;\n  transition: background 140ms ease, color 140ms ease;\n}\n\n.studio-nav [data-sidebar=\"menu-button\"]:hover {\n  background: hsl(var(--muted) / 0.68);\n  color: hsl(var(--foreground));\n}\n\n.studio-nav [data-sidebar=\"menu-button\"][data-active=\"true\"] {\n  background:\n    linear-gradient(90deg, hsl(var(--primary)), color-mix(in oklab, hsl(var(--primary)), hsl(var(--accent)) 28%));\n  color: hsl(var(--primary-foreground));\n  box-shadow: inset 3px 0 0 hsl(var(--accent));\n}\n\n[data-collapsible=\"icon\"] .studio-nav [data-sidebar=\"menu-button\"][data-active=\"true\"] {\n  box-shadow: none;\n}\n\n[data-collapsible=\"icon\"] .studio-nav {\n  overflow-y: auto !important;\n}\n\n.studio-org-select {\n  position: relative;\n  z-index: 60;\n  min-width: 0;\n}\n\n.studio-org-card {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  border: 1px solid hsl(var(--border));\n  border-radius: 8px;\n  background:\n    linear-gradient(135deg, hsl(var(--card) / 0.92), hsl(var(--muted) / 0.7));\n  padding: 8px;\n  box-shadow: inset 0 1px 0 hsl(var(--foreground) / 0.04);\n  color: hsl(var(--foreground));\n  cursor: pointer;\n  text-align: left;\n  transition: border-color 160ms ease, background 160ms ease, transform 160ms ease;\n}\n\n.studio-org-card:hover {\n  border-color: hsl(var(--foreground) / 0.24);\n  background:\n    linear-gradient(135deg, hsl(var(--card)), hsl(var(--muted) / 0.9));\n  transform: translateY(-1px);\n}\n\n.studio-org-menu {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: calc(100% + 8px);\n  z-index: 80;\n  max-height: min(360px, calc(100vh - 180px));\n  overflow: auto;\n  border: 1px solid hsl(var(--border));\n  border-radius: 10px;\n  background: hsl(var(--popover));\n  box-shadow:\n    0 18px 46px hsl(var(--background) / 0.42),\n    inset 0 1px 0 hsl(var(--foreground) / 0.05);\n  padding: 6px;\n}\n\n.studio-org-menu-label {\n  padding: 6px 8px 8px;\n  color: hsl(var(--muted-foreground));\n  font-family: \"JetBrains Mono\", ui-monospace, monospace;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.studio-org-menu-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: hsl(var(--foreground));\n  padding: 8px;\n  cursor: pointer;\n  text-align: left;\n}\n\n.studio-org-menu-item:hover {\n  background: hsl(var(--muted));\n}\n\n.studio-org-menu-item-active {\n  background: hsl(var(--foreground));\n  color: hsl(var(--background));\n}\n\n.studio-org-menu-item-active:hover {\n  background: hsl(var(--foreground));\n}\n\n.studio-org-menu-item-active .text-muted-foreground {\n  color: hsl(var(--background) / 0.68) !important;\n}\n\n.studio-org-menu-mark {\n  width: 24px;\n  height: 24px;\n  display: grid;\n  place-items: center;\n  flex: 0 0 auto;\n  border-radius: 7px;\n  background: hsl(var(--muted));\n  color: hsl(var(--foreground));\n  font-size: 10px;\n  font-weight: 800;\n}\n\n.studio-org-menu-item-active .studio-org-menu-mark {\n  background: hsl(var(--background) / 0.16);\n  color: hsl(var(--background));\n}\n\n.studio-main {\n  position: relative;\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  isolation: isolate;\n}\n\n.studio-topbar {\n  position: sticky;\n  top: 0;\n  z-index: 40;\n  display: grid;\n  grid-template-columns: minmax(180px, 1fr) minmax(280px, 520px) minmax(180px, 1fr);\n  align-items: center;\n  gap: 18px;\n  min-height: 62px;\n  border-bottom: 1px solid hsl(var(--border));\n  background:\n    linear-gradient(90deg, hsl(var(--background) / 0.94), hsl(var(--card) / 0.9)),\n    linear-gradient(90deg, hsl(var(--primary) / 0.08), transparent 40%, hsl(var(--accent) / 0.07));\n  padding: 0 28px;\n  backdrop-filter: blur(12px);\n}\n\n@media (max-width: 1280px) {\n  .studio-topbar {\n    padding: 0 16px;\n  }\n}\n\n@media (max-width: 768px) {\n  .studio-topbar {\n    grid-template-columns: 1fr auto;\n    padding: 0 12px;\n  }\n\n  .studio-topbar--no-search {\n    grid-template-columns: 1fr auto;\n  }\n}\n\n/* Search hidden in StudioLayout — crumbs left, actions right */\n.studio-topbar--no-search {\n  grid-template-columns: minmax(0, 1fr) auto;\n}\n\n.studio-topbar::after {\n  content: \"\";\n  position: absolute;\n  right: 28px;\n  bottom: -1px;\n  left: 28px;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, hsl(var(--primary) / 0.42), hsl(var(--accent) / 0.36), transparent);\n}\n\n.studio-crumbs {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n}\n\n.studio-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  height: 34px;\n  border: 1px solid hsl(var(--border));\n  border-radius: 8px;\n  background: hsl(var(--card) / 0.86);\n  padding: 0 10px;\n  box-shadow: inset 0 1px 0 hsl(var(--foreground) / 0.04);\n}\n\n.studio-search:focus-within {\n  border-color: hsl(var(--primary) / 0.58);\n  box-shadow: 0 0 0 3px hsl(var(--primary) / 0.11);\n}\n\n.studio-search input {\n  min-width: 0;\n  flex: 1;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: hsl(var(--foreground));\n  font-size: 13px;\n}\n\n.studio-search kbd {\n  border-radius: 5px;\n  background: hsl(var(--muted));\n  color: hsl(var(--muted-foreground));\n  padding: 1px 5px;\n  font-family: \"JetBrains Mono\", ui-monospace, monospace;\n  font-size: 10px;\n}\n\n.studio-actions {\n  display: flex;\n  flex-shrink: 0;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n}\n\n.studio-icon-button {\n  display: grid;\n  place-items: center;\n  width: 34px;\n  height: 34px;\n  border: 1px solid hsl(var(--border));\n  border-radius: 8px;\n  background: hsl(var(--card) / 0.88);\n  color: hsl(var(--foreground));\n}\n\n.studio-content {\n  flex: 1;\n  width: 100%;\n  max-width: none;\n  min-height: 0;\n  margin: 0 auto;\n  padding: 14px;\n}\n\n.studio-content-full {\n  flex: 1;\n  max-width: none;\n  min-height: 0;\n  min-width: 0;\n  padding: 0;\n}\n\n.studio-hero {\n  position: relative;\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 24px;\n  margin-bottom: 24px;\n  padding-bottom: 18px;\n}\n\n.studio-hero::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 1px;\n  background: linear-gradient(90deg, hsl(var(--primary) / 0.32), hsl(var(--accent) / 0.26), transparent 72%);\n}\n\n.studio-eyebrow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: hsl(var(--muted-foreground));\n  font-family: \"JetBrains Mono\", ui-monospace, monospace;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.studio-eyebrow::before {\n  content: \"\";\n  width: 18px;\n  height: 2px;\n  border-radius: 999px;\n  background: linear-gradient(90deg, hsl(var(--primary)), hsl(var(--accent)));\n}\n\n.studio-title {\n  margin-top: 10px;\n  color: hsl(var(--foreground));\n  font-family: \"Space Grotesk\", Inter, ui-sans-serif, system-ui, sans-serif;\n  font-size: clamp(32px, 4.2vw, 48px);\n  line-height: 1.02;\n  font-weight: 700;\n  text-wrap: balance;\n}\n\n.studio-title em {\n  background: linear-gradient(90deg, hsl(var(--primary)), hsl(var(--accent)));\n  background-clip: text;\n  color: transparent;\n  font-style: normal;\n}\n\n.studio-subtitle {\n  margin-top: 10px;\n  max-width: 680px;\n  color: hsl(var(--muted-foreground));\n  font-size: 15px;\n  line-height: 1.55;\n}\n\n.studio-card {\n  position: relative;\n  border: 1px solid hsl(var(--border));\n  border-radius: 8px;\n  background:\n    linear-gradient(180deg, hsl(var(--card) / 0.98), hsl(var(--card-elevated) / 0.84));\n  box-shadow:\n    inset 0 1px 0 hsl(var(--foreground) / 0.04),\n    0 1px 1px hsl(var(--foreground) / 0.04);\n}\n\n/* .studio-card::before {\n  content: \"\";\n  position: absolute;\n  inset: 0 0 auto;\n  height: 2px;\n  background: linear-gradient(90deg, hsl(var(--primary) / 0.64), hsl(var(--accent) / 0.42), transparent);\n  opacity: 0.72;\n  pointer-events: none;\n} */\n\n.studio-card-hover {\n  transition: transform 140ms ease, border-color 140ms ease, box-shadow 140ms ease;\n}\n\n.studio-card-hover:hover {\n  transform: translateY(-1px);\n  border-color: hsl(var(--primary) / 0.42);\n  box-shadow:\n    inset 0 1px 0 hsl(var(--foreground) / 0.05),\n    0 12px 28px hsl(var(--primary) / 0.12);\n}\n\n/* Legacy route panels still use raw Tailwind bg-card/border boxes. In Studio,\n   soften those so old pages blend into the new shell instead of looking like\n   stacked square blocks. */\n.studio-shell :where(.bg-card.border, .border.bg-card):not(.studio-card):not(.term-window):not(.term-window-flat) {\n  border-color: hsl(var(--border) / 0.72) !important;\n  background:\n    linear-gradient(180deg, hsl(var(--card) / 0.82), hsl(var(--card-elevated) / 0.58)) !important;\n  box-shadow:\n    inset 0 1px 0 hsl(var(--foreground) / 0.035),\n    0 1px 2px hsl(var(--foreground) / 0.035) !important;\n}\n\n.studio-shell :where([class*=\"bg-muted/\"][class*=\"border\"], [class*=\"bg-background/\"][class*=\"border\"]) {\n  border-color: hsl(var(--border) / 0.62) !important;\n  background: hsl(var(--muted) / 0.34) !important;\n}\n\n.studio-shell :where(.shadow-sm, .shadow-md):not(.studio-card) {\n  box-shadow: 0 1px 2px hsl(var(--foreground) / 0.04) !important;\n}\n\n.studio-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 30px;\n  border: 1px solid hsl(var(--border));\n  border-radius: 999px;\n  background: hsl(var(--card));\n  padding: 0 12px;\n  color: hsl(var(--foreground) / 0.78);\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.studio-pill-active {\n  border-color: hsl(var(--foreground));\n  background: hsl(var(--foreground));\n  color: hsl(var(--background));\n}\n\n.studio-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 36px;\n  border: 1px solid var(--studio-button-border, hsl(var(--border)));\n  border-radius: 8px;\n  background: var(--studio-button-bg, hsl(var(--card)));\n  color: var(--studio-button-color, hsl(var(--foreground)));\n  padding: var(--studio-button-padding, 0 14px);\n  font-size: var(--studio-button-font-size, 13px);\n  font-weight: 600;\n  text-decoration: none;\n  box-shadow: var(--studio-button-shadow, none);\n  transition: transform 140ms ease, border-color 140ms ease, box-shadow 140ms ease, background 140ms ease, color 140ms ease;\n}\n\n.studio-button-sm {\n  height: 32px;\n  padding: 0 12px;\n  font-size: 12px;\n}\n\n.studio-button-lg {\n  height: 44px;\n  padding: 0 20px;\n}\n\n.studio-button-xl {\n  height: 48px;\n  padding: 0 32px;\n  font-size: 16px;\n}\n\n.studio-button-icon {\n  width: 36px;\n  height: 36px;\n  padding: 0;\n}\n\n.studio-button:hover {\n  border-color: var(--studio-button-hover-border, hsl(var(--primary) / 0.45));\n  background: var(--studio-button-hover-bg, var(--studio-button-bg, hsl(var(--card))));\n  color: var(--studio-button-hover-color, var(--studio-button-color, hsl(var(--foreground))));\n}\n\n.studio-button-primary {\n  --studio-button-border: hsl(var(--primary));\n  --studio-button-bg:\n    linear-gradient(135deg, hsl(var(--primary)), color-mix(in oklab, hsl(var(--primary)), hsl(var(--accent)) 32%));\n  --studio-button-color: hsl(var(--primary-foreground));\n  --studio-button-shadow: 0 8px 20px hsl(var(--primary) / 0.18);\n}\n\n.studio-button-primary:hover {\n  --studio-button-hover-shadow: 0 12px 28px hsl(var(--primary) / 0.24);\n}\n\n.studio-button-secondary {\n  --studio-button-border: hsl(var(--secondary));\n  --studio-button-bg: hsl(var(--secondary));\n  --studio-button-color: hsl(var(--secondary-foreground));\n  --studio-button-hover-bg: hsl(var(--secondary) / 0.84);\n}\n\n.studio-button-destructive {\n  --studio-button-border: hsl(var(--destructive));\n  --studio-button-bg: hsl(var(--destructive));\n  --studio-button-color: hsl(var(--destructive-foreground));\n  --studio-button-hover-bg: hsl(var(--destructive) / 0.9);\n  --studio-button-hover-border: hsl(var(--destructive));\n}\n\n.studio-button-ghost {\n  --studio-button-border: transparent;\n  --studio-button-bg: transparent;\n  --studio-button-shadow: none;\n  --studio-button-hover-bg: hsl(var(--muted));\n  --studio-button-hover-shadow: none;\n}\n\n.studio-button-link {\n  height: auto;\n  border-color: transparent;\n  background: transparent;\n  color: hsl(var(--primary));\n  padding: 0;\n  box-shadow: none;\n  text-decoration: none;\n  text-underline-offset: 4px;\n}\n\n.studio-button-link:hover {\n  transform: none;\n  border-color: transparent;\n  background: transparent;\n  color: hsl(var(--primary));\n  box-shadow: none;\n  text-decoration: underline;\n}\n\n.studio-primary-action {\n  --studio-button-border: hsl(var(--primary));\n  --studio-button-bg:\n    linear-gradient(135deg, hsl(var(--primary)), color-mix(in oklab, hsl(var(--primary)), hsl(var(--accent-warm)) 38%));\n  --studio-button-color: hsl(var(--primary-foreground));\n  --studio-button-shadow: 0 8px 20px hsl(var(--primary) / 0.18);\n}\n\n.studio-primary-action:hover {\n  --studio-button-hover-border: hsl(var(--primary));\n  --studio-button-hover-shadow:\n    0 12px 28px hsl(var(--primary) / 0.24),\n    0 0 0 4px hsl(var(--primary) / 0.10);\n}\n\n.loading-parallax,\n.studio-shell :where([class*=\"animate-pulse\"][class*=\"bg-muted\"]) {\n  position: relative;\n  overflow: hidden;\n  isolation: isolate;\n  background:\n    linear-gradient(135deg, hsl(var(--muted) / 0.72), hsl(var(--muted) / 0.42)) !important;\n}\n\n.loading-parallax::before,\n.studio-shell :where([class*=\"animate-pulse\"][class*=\"bg-muted\"])::before {\n  content: \"\";\n  position: absolute;\n  inset: -45% -70%;\n  z-index: 1;\n  background:\n    linear-gradient(110deg, transparent 22%, hsl(var(--background) / 0.48) 46%, hsl(var(--accent-warm) / 0.22) 52%, transparent 70%);\n  transform: translateX(-55%) skewX(-12deg);\n  animation: loadingParallaxSweep 1.8s cubic-bezier(.22, .61, .36, 1) infinite;\n}\n\n.loading-parallax::after,\n.studio-shell :where([class*=\"animate-pulse\"][class*=\"bg-muted\"])::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  background:\n    radial-gradient(circle at 18% 20%, hsl(var(--primary) / 0.10), transparent 28%),\n    radial-gradient(circle at 82% 78%, hsl(var(--accent-warm) / 0.10), transparent 30%);\n  animation: loadingParallaxDrift 3.2s ease-in-out infinite alternate;\n}\n\n@keyframes loadingParallaxSweep {\n  0% { transform: translateX(-58%) skewX(-12deg); }\n  100% { transform: translateX(58%) skewX(-12deg); }\n}\n\n@keyframes loadingParallaxDrift {\n  0% { transform: translate3d(-8px, -4px, 0) scale(1); opacity: .58; }\n  100% { transform: translate3d(8px, 5px, 0) scale(1.04); opacity: .9; }\n}\n\n.floating-chat-launcher {\n  position: fixed;\n  right: 24px;\n  bottom: 24px;\n  z-index: 999;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  height: 48px;\n  border: 1px solid hsl(var(--border) / 0.78);\n  border-radius: 999px;\n  background:\n    linear-gradient(135deg, hsl(var(--foreground)), hsl(var(--foreground) / 0.88)),\n    linear-gradient(135deg, hsl(var(--primary) / 0.2), hsl(var(--accent-warm) / 0.24));\n  color: hsl(var(--background));\n  padding: 0 12px 0 8px;\n  box-shadow:\n    0 16px 38px hsl(var(--foreground) / 0.18),\n    inset 0 1px 0 hsl(var(--background) / 0.16);\n  transition: transform 150ms ease, box-shadow 150ms ease, border-color 150ms ease;\n}\n\n.floating-chat-launcher:hover {\n  transform: translateY(-2px);\n  border-color: hsl(var(--accent-warm) / 0.72);\n  box-shadow:\n    0 22px 48px hsl(var(--foreground) / 0.22),\n    0 0 0 4px hsl(var(--accent-warm) / 0.13),\n    inset 0 1px 0 hsl(var(--background) / 0.18);\n}\n\n.floating-chat-launcher__mark {\n  position: relative;\n  display: grid;\n  place-items: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 999px;\n  background: linear-gradient(135deg, hsl(var(--primary)), hsl(var(--accent-warm)));\n  color: hsl(var(--primary-foreground));\n}\n\n.floating-chat-launcher__spark {\n  position: absolute;\n  right: -3px;\n  top: -3px;\n  width: 11px;\n  height: 11px;\n  border-radius: 999px;\n  color: hsl(var(--accent-warm));\n  filter: drop-shadow(0 1px 2px hsl(var(--foreground) / 0.22));\n}\n\n.floating-chat-launcher__copy {\n  display: grid;\n  gap: 1px;\n  text-align: left;\n  line-height: 1;\n}\n\n.floating-chat-launcher__copy span:first-child {\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.floating-chat-launcher__copy span:last-child {\n  color: hsl(var(--background) / 0.68);\n  font-family: \"JetBrains Mono\", ui-monospace, monospace;\n  font-size: 10px;\n  text-transform: uppercase;\n}\n\n.floating-chat-launcher__send {\n  display: grid;\n  place-items: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 999px;\n  background: hsl(var(--background) / 0.14);\n  color: currentColor;\n  opacity: 0.78;\n}\n\n.dark .floating-chat-launcher {\n  background:\n    linear-gradient(135deg, hsl(226 22% 11% / 0.98), hsl(230 20% 7% / 0.98)),\n    linear-gradient(135deg, hsl(var(--primary) / 0.22), hsl(var(--accent-warm) / 0.28));\n  color: hsl(var(--foreground));\n  box-shadow:\n    0 18px 42px hsl(0 0% 0% / 0.42),\n    inset 0 1px 0 hsl(var(--foreground) / 0.09);\n}\n\n.dark .floating-chat-launcher__copy span:last-child {\n  color: hsl(var(--foreground) / 0.58);\n}\n\n\n.metadata-studio-page {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  flex-direction: column;\n  gap: 16px;\n  background: hsl(var(--background));\n  padding: 24px 28px 28px;\n}\n\n.metadata-studio-editor {\n  flex: 1;\n  min-height: max(320px, 40vh);\n}\n\n.metadata-studio-editor > div {\n  height: 100%;\n}\n\n@media (max-width: 960px) {\n  .studio-sidebar {\n    position: relative;\n    height: auto;\n    border-right: 0;\n    border-bottom: 1px solid hsl(var(--border));\n  }\n\n  .studio-nav {\n    display: grid;\n    grid-template-columns: 1fr;\n  }\n\n  .studio-topbar {\n    grid-template-columns: 1fr;\n    padding: 12px 18px;\n  }\n\n  .studio-topbar--no-search {\n    grid-template-columns: 1fr;\n  }\n\n  .studio-actions {\n    justify-content: flex-start;\n  }\n\n  .studio-content {\n    padding: 24px 18px 40px;\n  }\n\n  .studio-title {\n    font-size: 32px;\n  }\n\n  .studio-hero {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n}\n\n\n@layer components {\n  .term-window {\n    @apply border border-border rounded-lg shadow-sm overflow-visible;\n    position: relative;\n    background:\n      linear-gradient(180deg, hsl(var(--card) / 0.98), hsl(var(--card-elevated) / 0.88));\n    box-shadow:\n      inset 0 1px 0 hsl(var(--foreground) / 0.04),\n      0 1px 2px hsl(var(--foreground) / 0.05);\n  }\n\n  .term-window-flat {\n    @apply border border-border rounded-lg overflow-visible;\n    background:\n      linear-gradient(180deg, hsl(var(--card) / 0.98), hsl(var(--card-elevated) / 0.86));\n  }\n\n  .term-header {\n    @apply flex items-center justify-between px-3 py-2 border-b border-border;\n    min-height: 36px;\n    background:\n      linear-gradient(90deg, hsl(var(--muted) / 0.68), hsl(var(--card) / 0.82));\n  }\n\n  .term-dots {\n    @apply flex items-center gap-1.5;\n  }\n\n  .term-dot {\n    width: 11px;\n    height: 11px;\n    border-radius: 9999px;\n    display: inline-block;\n  }\n\n  .term-dot-red {\n    background-color: #ff5f57;\n  }\n\n  .term-dot-yellow {\n    background-color: #febc2e;\n  }\n\n  .term-dot-green {\n    background-color: #28c840;\n  }\n\n  .term-title {\n    @apply text-xs text-muted-foreground font-mono truncate;\n    letter-spacing: 0.02em;\n  }\n\n  .term-status {\n    @apply text-xs text-muted-foreground font-mono uppercase tracking-wide;\n  }\n\n  .coral {\n    color: hsl(var(--accent-warm));\n  }\n\n  .skill-outcome-shell {\n    @apply bg-card;\n  }\n\n  .skill-outcome-toolbar {\n    @apply flex items-center justify-between gap-3 border-b border-border bg-muted/30 px-4 py-3;\n  }\n\n  .skill-outcome-pill {\n    @apply inline-flex items-center rounded-md border border-border bg-background px-2 py-1 font-mono text-[11px] text-muted-foreground;\n  }\n\n  .skill-outcome-body {\n    @apply px-4 py-4;\n  }\n\n  .skill-streamdown {\n    @apply text-sm leading-6 text-foreground;\n  }\n\n  /* Typography hierarchy */\n  .text-heading-primary {\n    @apply text-3xl font-bold tracking-tight;\n    color: hsl(var(--heading-primary));\n  }\n  \n  .text-heading-secondary {\n    @apply text-2xl font-semibold;\n    color: hsl(var(--heading-secondary));\n  }\n  \n  .text-heading-accent {\n    @apply text-xl font-semibold;\n    color: hsl(var(--heading-accent));\n  }\n  \n  .text-page-title {\n    @apply text-4xl font-bold tracking-tight bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent;\n  }\n  \n  .text-section-title {\n    @apply text-lg font-semibold;\n    color: hsl(var(--heading-secondary));\n  }\n  \n  .text-body {\n    color: hsl(var(--body-text));\n  }\n  \n  .text-subtitle {\n    color: hsl(var(--subtitle-text));\n  }\n  \n  .text-caption {\n    @apply text-sm;\n    color: hsl(var(--caption-text));\n  }\n\n  /* Sidebar specific styles */\n  .sidebar-group-label {\n    @apply text-xs font-semibold uppercase tracking-wider;\n    color: hsl(var(--primary));\n  }\n  \n  .sidebar-menu-item {\n    @apply font-medium;\n    color: hsl(var(--sidebar-foreground));\n  }\n  \n  .sidebar-menu-item-active {\n    @apply font-semibold;\n    color: hsl(var(--sidebar-accent-foreground));\n  }\n\n  /* Metric card styles */\n  .metric-card {\n    @apply bg-card border border-border rounded-xl p-6 shadow-card transition-smooth hover:shadow-elevated;\n  }\n\n  /* Glow effect for active states */\n  .glow-effect {\n    @apply relative;\n  }\n  \n  .glow-effect::before {\n    content: \"\";\n    @apply absolute -inset-px rounded-xl opacity-0 transition-opacity;\n    background: var(--gradient-primary);\n    z-index: -1;\n  }\n  \n  .glow-effect:hover::before {\n    @apply opacity-20;\n  }\n}\n\n/* Indeterminate progress bar animation */\n@keyframes progress-indeterminate {\n  0% {\n    transform: translateX(-100%);\n    width: 50%;\n  }\n  50% {\n    transform: translateX(50%);\n    width: 30%;\n  }\n  100% {\n    transform: translateX(200%);\n    width: 50%;\n  }\n}\n\n.animate-progress-indeterminate {\n  animation: progress-indeterminate 1.5s ease-in-out infinite;\n}\n\n\n@layer base {\n  * {\n    @apply border-border;\n  }\n  body {\n    @apply bg-background text-foreground;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
